import {AfterContentChecked, ChangeDetectorRef, Component, ElementRef, EventEmitter, OnInit, ViewChild} from '@angular/core';
import { resolveDealerDeliveryAddress } from './dealer-delivery-address';
import {Order} from '../../../back-office/Models/Order';
import {OrderItem} from '../../../back-office/Models/OrderItem';
import {OrderItemProduct, StockAmountAlert} from '../../../back-office/Models/OrderItemProduct';
import {CollectionService} from '../../../back-office/Services/collection.service';
import {ProductService} from '../../../back-office/Services/product.service';
import {ModelService} from '../../../back-office/Services/model.service';
import {HttpParams, HttpResponse} from '@angular/common/http';
import {OrderItemProductPackage} from '../../../back-office/Models/OrderItemProductPackage';
import {OrderService} from '../../../dealer-system/Services/order.service';
import {Product} from '../../../back-office/Models/Product';
import {CarpetLineCost, carpetRoleLabelKey, carpetRoleOfGroup, carpetRoleOfRow, carpetSizeLabel, computeCarpetLineCost, resolveFixedSizePrice} from '../../../helpers/carpet-price';
import {Helper} from '../../../helpers/helper.service';
import {Collection} from '../../../back-office/Models/Collection';
import {ActivatedRoute, Router} from '@angular/router';
import {environment} from '../../../../environments/environment';
import {Model} from '../../../back-office/Models/Model';
import {Login} from '../../../auth/model/Login';
import {AuthenticationService} from '../../Services/authentication.service';
import {catchError, debounceTime, distinctUntilChanged, finalize, switchMap} from 'rxjs/operators';
import {throwError} from 'rxjs';
import {TranslateService} from '@ngx-translate/core';
import {NgForm} from '@angular/forms';
import {TotalCost} from '../../../back-office/Models/TotalCost';
import {ComponentCanDeactivate} from '../../components/can-deactivate/component-can-deactivate';
import {FabricCollectionService} from '../../../back-office/Services/fabric-collection.service';
import {FabricService} from '../../../back-office/Services/fabric.service';
import {FabricCollection} from '../../../back-office/Models/FabricCollection';
import {Fabric} from '../../../back-office/Models/Fabric';
import {FabricColor} from '../../../back-office/Models/FabricColor';
import {OrderItemProductFabricCollection} from '../../../back-office/Models/OrderItemProductFabricCollection';
import * as _ from 'lodash';
import {OrderItemOption} from '../../../back-office/Models/OrderItemOptions';
import {SummaryOption} from '../../../back-office/Models/SummaryOption';
import {SystemUser} from '../../Models/SystemUser';
import {StyleService} from '../../../back-office/Services/style.service';
import {OptionService} from '../../../back-office/Services/option.service';
import {Style} from '../../../back-office/Models/Style';
import {Option} from '../../../back-office/Models/Option';
import {Property} from '../../../back-office/Models/Property';
import {ProductCost} from '../../../back-office/Models/ProductCost';
import {UsersService} from '../../../back-office/Services/users.service';
import {NgbDateParserFormatter} from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import {NgbDateCustomParserFormatter} from '../../Services/NgbDateCustomParserFormatter';
import {OrderCustomRow} from '../../../back-office/Models/OrderCustomRow';
import {Supplier} from '../../../back-office/Models/Supplier';
import {InvoiceDealer} from '../../../back-office/Models/InvoiceDealer';
import {DisclaimerService} from '../../../back-office/Services/disclaimer.service';
import {Disclaimer} from '../../../back-office/Models/Disclaimer';
import {CustomerDeliveryAddress} from '../../../back-office/Models/CustomerDeliveryAddress';
import {type PosCountryCode, PosRegistration} from '../../../back-office/Models/PosRegistration';
import {LoadingBarService} from '@ngx-loading-bar/core';
import {Discount} from '../../../back-office/Models/Discount';
import { BackOfficeOrderService } from 'src/app/back-office/Services/order.service';

interface PdfResponse {
  url: string;
  filename?: string;
}

@Component({
  selector: 'app-manage-order',
  templateUrl: './manage-order.component.html',
  styleUrls: ['./manage-order.component.scss'],
  providers: [
    {provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter}
  ],
})
export class ManageOrderComponent extends ComponentCanDeactivate implements OnInit, AfterContentChecked {


  constructor(private readonly translate: TranslateService, public readonly auth: AuthenticationService, private readonly helper: Helper, private readonly route: Router,
              private readonly collectionService: CollectionService, private readonly modelService: ModelService,
              private readonly styleService: StyleService,
              private readonly router: ActivatedRoute,
              private readonly productService: ProductService,
              private readonly optionService: OptionService,
              private readonly orderService: OrderService,
              private readonly backOfficeOrderService: BackOfficeOrderService,
              private readonly userService: UsersService,
              private readonly fabricCollectionService: FabricCollectionService,
              private readonly disclaimerService: DisclaimerService,
              private readonly fabricService: FabricService,
              private readonly changeDetector: ChangeDetectorRef,
              private readonly loadingBar: LoadingBarService
  ) {
    super();
  }
  userLoading: boolean;
  public order: Order = new Order();
  public orderId: number;
  public collections: Collection[] = [];
  public products = [];
  public packages = [];
  public baseUrl = environment.apiUrl;
  public pdfLink: string;
  public customerPrice = true;
  public priceItem = true;
  public priceItemHasError = false;
  public dealerPassword: string;
  public login: Login = new Login();
  public absolutePath = environment.absolutePath;
  public disableConfirmBtn = false;
  private isSubmittingOrder = false;
  public isRegularUser = false;
  public showDeliveryWeek = false;
  public allowItems = [];
  public isAllowedPartialPaid: any;
  public showPartialOrder: boolean;
  public deleteIndex: number;
  public isEdit = false;
  public isShow = false;
  public isNewQuote = false;
  public isBackoffice = false;
  public lastOptions = [];
  public requiredOption = false;
  public checkEnableArray = [];
  public orderItemProperties = [];
  public options = [];
  public dealerVAT;
  public customerVAT;
  public usersTypeahead = new EventEmitter<string>();
  public selectedUsers = [];
  public formAction: string;
  public hasDeliveryAt = false;
  public hasRegularDelivery = false;
  public discountTypeOptions = [];
  private tempOrderData: {order: any, kind: string, secondaryDeliveryAt: any};
  @ViewChild('orderModal', {static: false}) orderModal = null;
  @ViewChild('addressModal', {static: false}) addressModal = null;
  @ViewChild('posDetailsModal', {static: false}) posDetailsModal = null;
  @ViewChild('pdfModal', {static: false}) pdfModal = null;
  @ViewChild('passwordModal', {static: false}) passwordModal = null;
  @ViewChild('passwordModalForm', {static: false}) passwordModalForm: NgForm;
  @ViewChild('downloadLink', {static: false}) downloadLink: ElementRef;
  @ViewChild('orderFrom', {static: false}) orderFrom: NgForm;
  @ViewChild('deleteModal', {static: false}) deleteModal = null;
  @ViewChild('addCustomRowModal', {static: false}) addCustomRowModal = null;
  @ViewChild('addDiscountModal', {static: false}) addDiscountModal = null;
  @ViewChild('addDiscountForm', {static: false}) addDiscountForm;
  @ViewChild('addCustomRowForm', {static: false}) addCustomRowForm;
  @ViewChild('cancelPlaceOrderModal', {static: false}) cancelPlaceOrderModal;
  public hasCustomRow = false;
  public editCustomRow = false;
  public customRows: OrderCustomRow[] = [];
  public currentOrderItemOptions = [];
  public formChecked: boolean[] = [];
  public suppliers: Supplier[] = [];
  public isTabletLandscape = false;
  public haveRemark = false;
  public isQuote = false;
  public quoteToOrder = false;
  public isService = false;
  public replyId: number;
  public serviceRequestId: number;
  public disclaimers: Disclaimer[];
  public disclaimersChecked = false;
  /** What to run once the POS customer-details modal is confirmed - the caller's own next step. */
  private afterPosDetails: () => void = null;
  public deliveryAtOptions = [{value: Order.DELIVERY_AT_DEALER, label: 'Dealer'}, {value: Order.DELIVERY_AT_CUSTOMER, label: 'Customer'}];
  public alertInactive = false;
  public placeOrderBtnIsDisable = true;
  public discount = new Discount();

  protected readonly Discount = Discount;

  canDeactivate(): boolean {
    return this.orderFrom.submitted || !this.orderFrom.dirty;
  }

  ngOnInit() {
    this.discountTypeOptions.push(...[
      {
        label: this.translate.instant('admin.amount'),
        value: Discount.TYPE_AMOUNT
      },
      {
        label: this.translate.instant('admin.percent'),
        value: Discount.TYPE_PERCENTAGE
      }
    ]);

    this.loadingBar.value$.subscribe(value => {
      this.placeOrderBtnIsDisable = value !== 0;
    });
    this.isTabletLandscape = this.isTabletDevice() && window.innerWidth < 1367;
    this.isBackoffice = this.auth.isBackOffice();
    this.searchDealerUsers();
    const url = Object.assign([], this.router.snapshot.url);
    if ((url[0].path == 'order' || url[0].path == 'quote') && Helper.isDefined(url[2]) && url[2].path == 'show') {
      this.isShow = true;
    }
    this.isQuote = url[0].path == 'quote';
    this.allowItems = [
      {label: this.translate.instant('doctrine.order.allow_partial_order'), value: 'allowed'},
      {label: this.translate.instant('doctrine.order.not_allow_partial_order'), value: 'not_allowed'}
    ];
    // check if user is dealer
    this.isRegularUser = this.auth.isDealerUser();
    this.dealerVAT = this.auth.getDealerVAT();
    this.customerVAT = this.auth.getCustomerVAT();
    //
    if (!this.isTabletLandscape) {
      window.onscroll = function () {
        const scrollTop = document.documentElement.scrollTop;
        const boxElement = document.getElementById('summary_box');
        if (!boxElement) {
          return;
        }
        if (scrollTop >= 70) {
          boxElement.classList.add('fixed-position');
          boxElement.classList.add('col-5');
        } else {
          boxElement.classList.remove('fixed-position');
          boxElement.classList.remove('col-5');
        }
      };
    }

    // get current selected order id from route param
    new Promise(resolve => {
      this.router.params.subscribe((params) => {
        if (Helper.isDefined(params['replyId'])) {
          this.replyId = parseInt(params['replyId']);
          this.isService = true;
        }
        if (Helper.isDefined(params['requestId'])) {
          this.serviceRequestId = parseInt(params['requestId']);
        }
        if (Helper.isDefined(params['id'])) {
          this.orderId = params['id'];
          // get list of collection
          this.collectionService.getCollection(new HttpParams(), 'dealer-system').subscribe((resp) => {
            // set into this.collection
            this.collections = resp.data;
            this.isEdit = true;
            // get order data for current order/quote
            const request = this.isQuote ? this.orderService.getQuoteOrder(this.orderId) : this.orderService.getOrder(this.orderId);
            request.subscribe((resp) => {
              this.isEdit = true;
              this.order = resp;
              if (this.order.customerDeliveryAddress !== null) {
                this.order.secondaryDeliveryAt = Order.DELIVERY_AT_CUSTOMER;
              } else {
                this.order.secondaryDeliveryAt = Order.DELIVERY_AT_DEALER;
              }

              this.discount.applied = this.order.discount.applied;
              this.discount.percentage = this.order.discount.percentage;
              this.discount.amount = this.order.discount.amount;
              this.discount.description = this.order.discount.description;
              if (this.discount.applied > 0) {
                this.order.totalCost.totalDealerPrice = Helper.bcAdd(this.order.totalCost.totalDealerPrice, this.discount.applied);
              }
              this.discount.type = this.order.discount.amount > 0 ? 'amount' : 'percent';
              const totalPrice = this.findDiscountablePrice();
              this.discount.castIt(
                totalPrice,
                this.order.discount.amount > 0 ?
                  this.order.discount.amount : this.order.discount.percentage
              );

              if (!this.isBackoffice) {
                this.order.discount = new Discount();
                this.discount = new Discount();
              }

              if (!this.order.customerDeliveryAddress) {
                this.order.customerDeliveryAddress = new CustomerDeliveryAddress();
              }
              // Re-evaluated on load, not only on selection: an order saved with an
              // incomplete POS registration must hit the same gate when it is reopened.
              if (!this.order.posRegistration) {
                this.order.posRegistration = new PosRegistration();
              }
              if (this.order.allowPartial === Order.PARTIAL_ORDER_ALLOW) {
                this.isAllowedPartialPaid = {
                  label: this.translate.instant('doctrine.order.allow_partial_order'),
                  value: Order.PARTIAL_ORDER_ALLOW
                };
              } else {
                this.isAllowedPartialPaid = {
                  label: this.translate.instant('doctrine.order.not_allow_partial_order'),
                  value: Order.PARTIAL_ORDER_NOT_ALLOW
                };
              }
              this.order.allowPartial = this.isAllowedPartialPaid.value;
              if (this.order.user) {
                this.dealerVAT = this.order.user.invoiceDealer.salesVatPercentage;
                this.customerVAT = this.order.user.country.customerVat;
                if (this.order.user.status === SystemUser.SYSTEMUSER_INACTIVE) {
                  this.order.user.disabled = true;
                  this.order.user.companyName += ' (' + this.translate.instant('global.inactive') + ')';
                }
                this.selectedUsers.push(this.order.user);
              }
              if (this.isShow) {
                const requestOption = this.isQuote ?
                  this.orderService.getQuoteOption(this.orderId) : this.orderService.getOption(this.orderId);
                requestOption.subscribe(option => {
                  this.order.orderItems.forEach((orderItem) => {
                    const orderItemId = orderItem.id;
                    if (option[orderItemId] == null) {
                      this.options.push([]);
                    } else {
                      this.options.push(Object.values(option[orderItemId]));
                    }
                  });
                });
              }

              if (this.order.deliveryWeek) {
                this.order.allowDeliveryWeek = true;
              }

              if (this.order.secondaryDeliveryWeek) {
                this.order.allowSecondaryDeliveryWeek = true;
              }

              this.hasDeliveryAt = this.order.orderItems.some(orderItem => orderItem.collection.endCustomerDelivery);

              this.hasRegularDelivery = this.order.orderItems.some(orderItem => !orderItem.collection.endCustomerDelivery);

              this.order.orderItems.map((orderItem) => {
                orderItem.random = Math.floor((Math.random() * 1000000) + 1);
                // current order item collection with relations
                const orderItemCollectionCopy = JSON.parse(JSON.stringify(orderItem.collection));
                // current order item model with relations
                const orderItemModelCopy = JSON.parse(JSON.stringify(orderItem.model));
                // current order item style with relations
                const orderItemStyleCopy = JSON.parse(JSON.stringify(orderItem.style));
                this.addInactiveItem(this.collections, orderItem.collection);
                // fill order item collections list
                orderItem.collections = this.collections;
                // fill modelObj with current order item model data
                orderItem.modelObj = orderItemModelCopy;
                orderItem.styleObj = orderItemStyleCopy;
                orderItem.collectionObj = orderItemCollectionCopy;

                this.addInactiveItem(orderItemCollectionCopy.models, orderItem.modelObj);

                orderItem.models = orderItemCollectionCopy.models;

                if (orderItemStyleCopy !== null) {
                  orderItem.style = orderItemStyleCopy.id;
                  this.addInactiveItem(orderItemModelCopy.styles, orderItemStyleCopy);
                  orderItem.styles = orderItemModelCopy.styles;
                } else {
                  orderItem.style = null;
                  orderItem.styles = [];
                }
                if (!this.isShow) {
                  orderItem.model = orderItemModelCopy.id;
                  orderItem.collection = orderItemCollectionCopy.id;
                } else {
                  orderItem.style = orderItemStyleCopy;
                }

                orderItem.products = orderItemModelCopy.products;
                this.suppliers = [];
                if (Helper.isDefined(orderItem.modelObj.supplier)) {
                  this.suppliers.push(orderItem.modelObj.supplier);
                }
                this.suppliers = _.uniqBy(this.suppliers, 'id');
              });
              this.order.customRows.map(customRow => {
                if (customRow.supplier) {
                  customRow.supplier = customRow.supplier.id;
                }
              });
              for (const i in this.order.orderItems) {
                if (this.order.orderItems.hasOwnProperty(i)) {
                  this.order.orderItems[i].articleOptionsListToSelect = []; // init order item without option
                  // check and process all products in this order item
                  for (const j in this.order.orderItems[i].orderItemProducts) {
                    // Check per product options for this orderItemProduct
                    const modelId = this.order.orderItems[i].model.id || this.order.orderItems[i].model;
                    const styleId = this.order.orderItems[i].style && this.order.orderItems[i].style.id;
                    const productId = this.order.orderItems[i].orderItemProducts[j].product['id'];
                    this.optionService.getPerProductOptionByProductModelStyle(productId, modelId, styleId, 'dealer-system').subscribe(res => {
                      let activePerProductOption = res.filter(perProductOptionItem => perProductOptionItem.deleted === false);
                      activePerProductOption = activePerProductOption.length > 0 ? activePerProductOption[0] : null;
                      if (res.length > 0 && activePerProductOption) {
                        this.order.orderItems[i].orderItemProducts[j].perProductOptionObj = activePerProductOption;
                        this.order.orderItems[i].orderItemProducts[j].allowFabricSide = !!this.order.orderItems[i].orderItemProducts[j].selectedPerProductOption;
                        if (this.order.orderItems[i].orderItemProducts[j].allowFabricSide) {
                          this.order.orderItems[i].orderItemProducts[j].perProductOptions = [];
                          const perProductOption = this.order.orderItems[i].orderItemProducts[j].selectedPerProductOption.urbanOption;
                          const sideFabricOrderItemOption = this.createPerProductOptionItem(i, j, perProductOption, productId);
                          sideFabricOrderItemOption.propertyAmount = this.order.orderItems[i].orderItemProducts[j].amount;
                          this.order.orderItems[i].orderItemProducts[j].perProductOptions = [];
                          this.order.orderItems[i].orderItemProducts[j].perProductOptions.push(
                            sideFabricOrderItemOption
                          );
                          this.order.orderItems[i].orderItemProducts[j].selectedPerProductOption = sideFabricOrderItemOption.option;
                        }
                      } else {
                        delete this.order.orderItems[i].orderItemProducts[j].perProductOptionObj;
                        delete this.order.orderItems[i].orderItemProducts[j].perProductOptions;
                        delete this.order.orderItems[i].orderItemProducts[j].allowFabricSide;
                      }
                    });
                    // ---

                    if (this.order.orderItems[i].orderItemProducts.hasOwnProperty(j)) {

                      this.lastOptions = this.order.orderItemOptions;
                      this.order.orderItems[i].orderItemProducts[j].random = Math.floor((Math.random() * 1000000) + 1); // define new stock amount alert
                      this.order.orderItems[i].orderItemProducts[j].stockAmountAlert = new StockAmountAlert(); // define new stock amount alert
                      const fabricObj = JSON.parse(JSON.stringify(this.order.orderItems[i].orderItemProducts[j].orderItemProductFabricCollections[0].fabricCollection));

                      // TODO : </>
                      let fabricCollection = new FabricCollection(); // create empty fabric collection object
                      let fabric = new Fabric(); // create empty fabric object
                      let fabricColor = new FabricColor(); // create empty fabric object
                      // this.order.orderItems[i].orderItemProducts[0].orderItemProductFabricCollection.fabricObj= fabricObj
                      new Promise((resolve2, reject) => {
                        new Promise((productsListedResolve) => {
                          let paramsProduct = new HttpParams();
                          paramsProduct = paramsProduct.set('q[model_id]', this.order.orderItems[i].model);
                          if (this.order.orderItems[i].style) {
                            paramsProduct = paramsProduct.set('q[style_id]', this.order.orderItems[i].style);
                          }
                          this.productService.getProduct(paramsProduct, new HttpParams(), 'dealer-system').subscribe((resp) => {
                            this.order.orderItems[i].products = resp.data;
                            productsListedResolve(true);
                          });
                        }).then(() => {
                          this.addInactiveItem(this.order.orderItems[i].products, this.order.orderItems[i].orderItemProducts[j].product);
                          // get product packages TODO: We must check this section
                          this.getPackages(i, j, this.order.orderItems[i].orderItemProducts[j].product['id']);
                          this.savePropertiesForOrderItem(i);
                          resolve2(true);
                        });
                      }).then(() => {
                        if (this.isShow) {

                          this.order.orderItems[i].orderItemProducts[j].productObj = JSON.parse(JSON.stringify(this.order.orderItems[i].orderItemProducts[j].product));
                          // selectedSizeId is view state and is never persisted — only
                          // widthCm/lengthCm are. Match the saved dimensions back onto a
                          // preset so a reopened fixed-size rug shows its chosen size
                          // instead of an empty dropdown.
                          this.restoreRugPreset(this.order.orderItems[i].orderItemProducts[j]);
                        }
                        // set product id as product value for ng-select show this product correctly
                        this.order.orderItems[i].orderItemProducts[j].product = this.order.orderItems[i].orderItemProducts[j].product['id'];
                        // this.onChangeSelectedProducts(i);
                        const baseFabricCollections = JSON.parse(JSON.stringify(this.order.orderItems[i].orderItemProducts[j].orderItemProductFabricCollections[0]));
                        this.order.orderItems[i].orderItemProducts[j].orderItemProductFabricCollection = JSON.parse(JSON.stringify(this.order.orderItems[i].orderItemProducts[j].orderItemProductFabricCollections[0]));
                        // I change this value because we use customerPrice as customerCost in frontend but its wrong
                        this.order.orderItems[i].orderItemProducts[j].orderItemProductFabricCollection.totalCost.totalCustomerPrice = this.order.orderItems[i].orderItemProducts[j].orderItemProductFabricCollection.totalCost.totalCustomerCost;
                        if (Helper.isDefined(baseFabricCollections)) {
                          // empty fabric collection object with values from current product
                          fabricCollection = JSON.parse(JSON.stringify(baseFabricCollections.fabricCollection));
                          if (fabricCollection && fabricCollection.isCustom) {
                            fabricCollection.fabricName = baseFabricCollections.fabricName;
                            fabricCollection.fabricColorName = baseFabricCollections.fabricColorName;
                          }
                          // empty fabric collection object with values from current product
                          fabric = JSON.parse(JSON.stringify(baseFabricCollections.fabric));
                          // empty fabric color object with values from current product
                          fabricColor = JSON.parse(JSON.stringify(baseFabricCollections.fabricColor));
                        }
                      }).then(() => {
                        if (fabricCollection != null && Helper.isDefined(fabricCollection.id)) {
                          // load fabric collection into fabricCollectionObj this variable used in summary box
                          this.order.orderItems[i].orderItemProducts[j].orderItemProductFabricCollection.fabricCollectionObj = fabricCollection;

                          // set fabric collection id as fabric collection value for ng-select show this fabric collection correctly
                          this.order.orderItems[i].orderItemProducts[j].orderItemProductFabricCollection.fabricCollection = fabricCollection['id'];

                          // set fabrics ng-select items
                          this.order.orderItems[i].orderItemProducts[j].orderItemProductFabricCollection.fabrics = _.filter(fabricCollection.fabrics, (fabric: any) => fabric.status && (fabric.collectionIdList.indexOf(this.order.orderItems[i].collection) !== -1));
                          // this.order.orderItems[i].orderItemProducts[j].orderItemProductFabricCollection.fabricCollectionObj = fabricCollection;

                          // load fabric into fabricObj this variable used in summary box
                          this.order.orderItems[i].orderItemProducts[j].orderItemProductFabricCollection.fabricObj = fabric;

                          // set fabric id as fabric value for ng-select show this fabric correctly
                          this.order.orderItems[i].orderItemProducts[j].orderItemProductFabricCollection.fabric = fabric['id'];
                          // set fabrics colors ng-select items
                          this.order.orderItems[i].orderItemProducts[j].orderItemProductFabricCollection.fabricColors = _.filter(fabric.fabricColors, 'status');
                          this.order.orderItems[i].orderItemProducts[j].orderItemProductFabricCollection.fabricColorObj = fabricColor;
                          this.order.orderItems[i].orderItemProducts[j].orderItemProductFabricCollection.fabricColor = fabricColor['id'];
                          this.allowFabricChecked(i, j);
                        }
                        this.getAllTotal();
                      });
                    }

                    this.order.orderItems[i].orderItemProducts[j].orderItemProductPackages.forEach((productPackage, z) => {
                      if (productPackage.package.packageProducts.length) {
                        this.onPackageProductChange(i, j, z , productPackage.package.packageProducts.find(pp => {
                          if (typeof productPackage.orderItemProductPackageProducts[0].product !== 'number') {
                            return pp.product.id === (productPackage.orderItemProductPackageProducts[0].product as Product).id;
                          } else {
                            return pp.product.id === productPackage.orderItemProductPackageProducts[0].product;
                          }
                        }));
                      }
                    });

                  }
                }
              }

            });
          });

        } else {
          this.collectionService.getCollection(new HttpParams(), 'dealer-system').subscribe((resp) => {
            this.collections = resp.data;
            this.order.orderItems.push(this.newOrderItem());
          });
        }
      });
      resolve(true);
    }).then(() => {
      if (!this.isEdit) {
        this.auth.getProfile().subscribe((user: SystemUser) => {
          // Get user allow partial order selected setting
          if (user.isAllowedPartialPaid) {
            this.isAllowedPartialPaid = {
              label: this.translate.instant('doctrine.order.allow_partial_order'),
              value: Order.PARTIAL_ORDER_ALLOW
            };
          } else {
            this.isAllowedPartialPaid = {
              label: this.translate.instant('doctrine.order.not_allow_partial_order'),
              value: Order.PARTIAL_ORDER_NOT_ALLOW
            };
          }
          this.order.allowPartial = this.isAllowedPartialPaid.value;
          if (!this.order.user) {
            this.order.user = user;
          }
        });
      }
    });

  }
  ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }

  checkDeliveryWeek(order) {
    return (order.orderItems.length > 0 && order.orderItems[0].collection.type === Collection.TYPE_PRODUCTION);
  }

  checkAllowPartialOrder(order) {
    let totalStockAmount = 0;
    let hasProductSet = false;
    if (order.orderItems) {
      order.orderItems.forEach((orderItem) => {
        if (orderItem.collection) {
          if (orderItem.collection.type === Collection.TYPE_STOCK) {
            orderItem.orderItemProducts.forEach(function (productItem) {
              if (productItem.orderItemProductPackages) {
                productItem.orderItemProductPackages.forEach((orderItemProductPackage) => {
                  if (orderItemProductPackage.packageObj && orderItemProductPackage.packageObj.packageProducts && orderItemProductPackage.packageObj.packageProducts.length > 0) {
                    hasProductSet = true;
                  }
                });
              }
              totalStockAmount += productItem.amount;
            });
          }
        }
      });
    }
    return (totalStockAmount > 1 || hasProductSet);
  }

  getLastOptions(item, orderItem) {
    const itemCopy = JSON.parse(JSON.stringify(item));
    const lastOptionsCopy = JSON.parse(JSON.stringify(this.lastOptions));
    const result = [];
    lastOptionsCopy.forEach((value) => {
      if (value.product.id == itemCopy.product.id && value.orderItemId == orderItem.id) {
        result.push(value);
      }
    });
    return result;
  }

  scrollToBottom = (element) => {
    element.scroll({
      behavior: 'smooth',
      left: 0,
      top: element.scrollHeight
    });
  }

  addOrderItem() {
    this.order.orderItems.push(this.newOrderItem());
  }

  // delete other index of Article
  deleteOrderItem(index) {
    this.deleteIndex = index;
    this.deleteModal.show();
  }

  // delete first index of Article
  deleteOrderItemFirst() {
    new Promise((resolve, reject) => {
      this.order.orderItems.splice(this.deleteIndex, 1);
      resolve(true);
    }).then(() => {
      this.getAllTotal();
      this.deleteModal.hide();
    });
    return;

  }

  addProductItem(index) {
    this.order.orderItems[index].orderItemProducts.push(this.newOrderItemProduct());
  }

  deleteOrderProduct(i, j) {
    if (this.order.orderItems[i].orderItemProducts[j] && this.order.orderItems[i].orderItemProducts[j].productObj) {
      new Promise((resolve, reject) => {
        const productId = this.order.orderItems[i].orderItemProducts[j].productObj.id;
        this.order.orderItems[i].orderItemProducts.splice(j, 1);
        // this.byRemoveProductUpdateOptionsList(i,this.order.orderItems[i].orderItemProducts[j].productObj.id);
        if (this.findByProductId(i, productId)) {
          this.removeExtraOption(i, productId);
        }
        resolve(true);
      }).then(() => {
        // this.onChangeSelectedProducts(i);
        this.getAllTotal();
      });
    } else {
      this.order.orderItems[i].orderItemProducts.splice(j, 1);
    }
    /*   new Promise((resolve, reject) => {
         const productId = this.order.orderItems[i].orderItemProducts[j].productObj.id;
        this.order.orderItems[i].orderItemProducts.splice(j, 1);
      //
         //this.byRemoveProductUpdateOptionsList(i,this.order.orderItems[i].orderItemProducts[j].productObj.id);
         this.removeExtraOption(i, productId);
         resolve(true);
       }).then(() => this.getAllTotal());*/
  }

  removeExtraOption(i, productId) {
  for (const item in this.order.orderItems[i].articleOptionsListToSelect) {
    if (this.order.orderItems[i].articleOptionsListToSelect.hasOwnProperty(item)) {
      const selectOption = this.order.orderItems[i].articleOptionsListToSelect[item];
      if (selectOption.products.indexOf(productId) > -1) {
        if (selectOption.products.length > 1) {
          const index = selectOption.products.indexOf(productId);

          if (index > -1) {
            const products = this.order.orderItems[i].articleOptionsListToSelect[item].products;

            const lengthProductId = products.filter(x => x == productId).length;
            if (lengthProductId > 0 && lengthProductId == products.length) {
              delete this.order.orderItems[i].articleOptionsListToSelect[item];
            } else {
              this.order.orderItems[i].articleOptionsListToSelect[item].products.splice(index, 1);
            }
          }
        } else {
          delete this.order.orderItems[i].articleOptionsListToSelect[item];
        }
      }
    }
  }

  this.order.orderItems[i].articleOptionsListToSelect = this.order.orderItems[i].articleOptionsListToSelect.filter(function () {
    return true;
  });

  for (const item in this.order.orderItems[i].selectedOptions) {
    if (this.order.orderItems[i].selectedOptions.hasOwnProperty(item)) {
      const selectOption = this.order.orderItems[i].selectedOptions[item];

      if (selectOption.products.indexOf(productId) > -1) {
        if (selectOption.products.length > 1) {
          const index = selectOption.products.indexOf(productId);
          if (index > -1) {
            this.order.orderItems[i].selectedOptions[item].products.splice(index, 1);
          }
        } else {
          delete this.order.orderItems[i].selectedOptions[item];
        }
      }
    }
  }
  _.remove(this.checkEnableArray, (cea) => {
    if (cea.orderItem !== i) return false;
    const findProduct = _.findIndex(this.order.orderItems[i].orderItemProducts, (op) => op.product == cea.product);
    return findProduct === -1;
  });

  const hasUnmet = this.checkEnableArray.some(item => item.status === false);
  this.requiredOption = hasUnmet;
}


  findByProductId(i, productId) {
    const founded = _.filter(this.order.orderItems[i].orderItemProducts, (op: OrderItemProduct) => op.product == productId);
    return founded.length === 0;
  }

  /**
   * Toggle fabric different
   * @param i Order item index
   * @param j Order item product in order item index
   * @param checked
   */
  allowFabric(i, j, checked = null) {
    const orderItemProductFabricCollection = this.order.orderItems[i].orderItemProducts[j].orderItemProductFabricCollection;
    const baseOrderItemProductFabricCollection = this.order.orderItems[i].orderItemProducts[0].orderItemProductFabricCollection;
    if (checked) {
      this.order.orderItems[i].orderItemProducts[j].allowFabric = false;
      orderItemProductFabricCollection.fabricCollectionObj = baseOrderItemProductFabricCollection.fabricCollectionObj;
      orderItemProductFabricCollection.fabricObj = baseOrderItemProductFabricCollection.fabricObj;
      orderItemProductFabricCollection.fabricColorObj = baseOrderItemProductFabricCollection.fabricColorObj;
      orderItemProductFabricCollection.fabric = baseOrderItemProductFabricCollection.fabric;
      orderItemProductFabricCollection.fabricColor = baseOrderItemProductFabricCollection.fabricColor;
      orderItemProductFabricCollection.fabricCollection = baseOrderItemProductFabricCollection.fabricCollection;
    } else {
      this.order.orderItems[i].orderItemProducts[j].allowFabric = true;
      orderItemProductFabricCollection.fabricCollectionObj = null;
      orderItemProductFabricCollection.fabricObj = null;
      orderItemProductFabricCollection.fabricColorObj = null;
      orderItemProductFabricCollection.fabric = null;
      orderItemProductFabricCollection.fabricColor = null;
      orderItemProductFabricCollection.fabricCollection = null;
    }
    this.getAllTotal();
  }

  allowPerProductOption(i: number, j: number, checked) {
    this.order.orderItems[i].orderItemProducts[j].allowFabricSide = checked;
    const orderItemProduct = this.order.orderItems[i].orderItemProducts[j];
    const childOption = orderItemProduct.perProductOptionObj.option.options.filter(option => option.deleted !== true)[0];
    if (checked) {
      const sideFabricOrderItemOption = this.createPerProductOptionItem(i, j, childOption);
      this.order.orderItems[i].orderItemProducts[j].perProductOptions = [];
      this.order.orderItems[i].orderItemProducts[j].perProductOptions.push(
        sideFabricOrderItemOption
      );
    } else {
      this.order.orderItems[i].orderItemProducts[j].perProductOptions = [];
      this.order.orderItems[i].orderItemProducts[j].selectedPerProductOption = null;
    }
    this.createSummaryBox(i);
    this.getAllTotal(i);
  }

  createPerProductOptionItem(i, j, option, productId = null) {
    const orderItemProduct = this.order?.orderItems?.[i]?.orderItemProducts?.[j];
    const sideFabricOrderItemOption = new OrderItemOption();
    sideFabricOrderItemOption.option = option?.id;
    sideFabricOrderItemOption.firstParent = orderItemProduct?.perProductOptionObj?.option?.id;
    sideFabricOrderItemOption.productAmount = orderItemProduct?.amount;
    sideFabricOrderItemOption.cost.customerPrice = option?.customerPrice;
    sideFabricOrderItemOption.cost.dealerPrice = option?.dealerPrice;
    sideFabricOrderItemOption.cost.amount = orderItemProduct?.amount;
    sideFabricOrderItemOption.propertyAmount = orderItemProduct?.amount;
    delete sideFabricOrderItemOption.cost;
    delete sideFabricOrderItemOption.options;
    delete sideFabricOrderItemOption.order;
    delete sideFabricOrderItemOption.urbanOption;
    delete sideFabricOrderItemOption.orderItem;
    delete sideFabricOrderItemOption.customerPrice;
    delete sideFabricOrderItemOption.dealerPrice;
    delete sideFabricOrderItemOption.parentPosition;
    delete sideFabricOrderItemOption.position;
    delete sideFabricOrderItemOption.optionsAppliedCount;
    delete sideFabricOrderItemOption.totalCost;
    delete sideFabricOrderItemOption.random;
    delete sideFabricOrderItemOption.productAmount;
    const resultSideFabricOderItemOption = JSON.parse(JSON.stringify(sideFabricOrderItemOption));
    resultSideFabricOderItemOption.product = productId ? productId : orderItemProduct?.productObj?.id;
    resultSideFabricOderItemOption.optionObj = option;
    return resultSideFabricOderItemOption;
  }

  onDeliveryWeekSelected(event) {
    const firstDayOfWeek = moment(event.date, 'YYYY-MM-DD').startOf('isoWeek');
    this.order.deliveryWeek = firstDayOfWeek.year() + '-' + (firstDayOfWeek.month() + 1) + '-' + firstDayOfWeek.date();
  }

  onSecondaryDeliveryWeekSelected(event) {
    const firstDayOfWeek = moment(event.date, 'YYYY-MM-DD').startOf('isoWeek');
    this.order.secondaryDeliveryWeek = firstDayOfWeek.year() + '-' + (firstDayOfWeek.month() + 1) + '-' + firstDayOfWeek.date();
  }

  findModel(orderItemId, modelId): Model {
    return this.order.orderItems[orderItemId].models.filter(model => {
      if (model.id === parseInt(modelId)) {
        return true;
      }
      return false;
    }).pop();
  }

  findCollection(orderItemId, collectionId): Collection {
    return this.order.orderItems[orderItemId].collections.filter(collection => {
      if (collection.id === parseInt(collectionId)) {
        return true;
      }
      return false;
    }).pop();
  }

  findStyle(orderItemId, styleId): Style {
    return this.order.orderItems[orderItemId].styles.filter(style => {
      if (style.id === parseInt(styleId)) {
        return true;
      }
      return false;
    }).pop();
  }

  /**
   * Find product in orderItem products
   *
   * @param orderItemId selected order item index
   * @param productId needle product index
   * @return product
   */
  findProduct(orderItemId, productId): Product {
    return this.order.orderItems[orderItemId].products.filter(product => {
      if (product.id === parseInt(productId)) {
        return true;
      }
      return false;
    }).pop();
  }

  filterCollection(index, query) {
    let params = new HttpParams();
    params = params.set('query', query.term);
    this.collectionService.getCollection(params, 'dealer-system').subscribe((resp) => {
      this.order.orderItems[index].collections = resp.data;
    });
  }

  filterModel(index, query) {
    let params = new HttpParams();
    params = params.set('query', query.term);

    params = params.set('q[collection_id]', this.order.orderItems[index].collection.toString());
    this.modelService.getModel(params, 'dealer-system').subscribe((resp) => {
      this.order.orderItems[index].models = resp.data;
    });

  }

  filterStyle(index, query) {
    let params = new HttpParams();
    params = params.set('query', query.term);

    params = params.set('q[model_id]', this.order.orderItems[index].models.toString());
    this.styleService.getStyle(params, 'dealer-system').subscribe((resp) => {
      this.order.orderItems[index].styles = resp.data;
    });

  }

  filterProduct(i, query) {
    let params = new HttpParams();
    params = params.set('query', query.term);
    params = params.set('q[model_id]', this.order.orderItems[i].model.toString());
    if (this.order.orderItems[i].style !== null) {
      params = params.set('q[style_id]', this.order.orderItems[i].style.toString());
    }
    this.productService.getProduct(params, new HttpParams(), 'dealer-system').subscribe((resp) => {
      this.order.orderItems[i].products = resp.data;
    });
  }

  getModels(index, collectionId) {
    new Promise((resolve, reject) => {

      this.order.orderItems[index].styles = [];
      this.order.orderItems[index].modelObj = null;
      this.order.orderItems[index].styleObj = null;
      this.order.orderItems[index].orderItemProducts = [new OrderItemProduct()];
      this.order.orderItems[index].model = null;
      this.order.orderItems[index].style = null;
      this.order.orderItems[index].models = [];
      this.order.orderItems[index].products = [];
      this.order.orderItems[index].collectionObj = this.findCollection(index, collectionId);
      if (collectionId === null) {
        this.getAllTotal();
        return;
      }
      let params = new HttpParams();
      params = params.set('q[collection_id]', collectionId);
      this.modelService.getModel(params, 'dealer-system').subscribe((resp) => {
        this.order.orderItems[index].models = resp.data;
        resolve(true);
      });

    }).then(() => {
      this.getAllTotal();
    });
  }

  getStyles(i, modelId) {
    // this.order.orderItems[i].orderItemOptions=[];
    // this.order.orderItems[i].selectedSummaryOptions=[];
    // this.order.orderItems[i].selectedOptions=[];

    //
    //
    //

    // if model not set clear all settings for model and style
    if (modelId === null) {
      this.order.orderItems[i].styles = [];
      this.order.orderItems[i].modelObj = null;
      this.order.orderItems[i].styleObj = null;
      this.order.orderItems[i].model = null;
      this.order.orderItems[i].style = null;
      return;
    }
    new Promise((resolve, reject) => {
      this.order.orderItems[i].styles = [];
      this.order.orderItems[i].styleObj = null;
      this.order.orderItems[i].style = null;
      this.order.orderItems[i].modelObj = this.findModel(i, modelId);
      this.suppliers = [];
      if (this.isBackoffice) {
        this.order.orderItems.map(orderItem => {
          if (Helper.isDefined(orderItem.modelObj.supplier)) {
            this.suppliers.push(orderItem.modelObj.supplier);
          }
        });
      }
      this.suppliers = _.uniqBy(this.suppliers, 'id');
      let params = new HttpParams();
      params = params.set('q[model_id]', modelId);
      this.order.orderItems[i].orderItemProducts = [this.newOrderItemProduct()];
      this.order.orderItems[i].selectedOptions = [];
      this.styleService.getStyle(params, 'dealer-system').subscribe((resp) => {
        this.order.orderItems[i].styles = resp.data;
        resolve(true);
      });
    }).then(() => {
      if (this.order.orderItems[i].styles.length === 0) {
        this.getProducts(i, modelId);
      }
      this.getAllTotal();
    });
  }

  getProducts(i, modelId, styleId = null) {

    if (this.order?.orderItems?.[i]?.styles?.length > 0 && styleId === null) {
      this.order.orderItems[i].style = null;
      // this.order.orderItems[i].styleObj = null;
      return;
    }
    new Promise((resolve, reject) => {
      this.order.orderItems[i].orderItemOptions = [];
      this.order.orderItems[i].selectedOptions = [];
      this.order.orderItems[i].orderItemProducts = [];


      this.order.orderItems[i].products = null;
      this.order.orderItems[i].styleObj = this.findStyle(i, styleId);
      let params = new HttpParams();
      params = params.set('q[model_id]', modelId);
      if (styleId) {
        params = params.set('q[style_id]', styleId);
      }
      this.order.orderItems[i].orderItemProducts = [this.newOrderItemProduct()];
      this.order.orderItems[i].articleOptionsListToSelect = [];
      this.savePropertiesForOrderItem(i);
      this.productService.getProduct(params, new HttpParams(), 'dealer-system').subscribe((resp) => {
        this.order.orderItems[i].products = resp.data;
        resolve(true);
      });
    }).then(() => this.getAllTotal());
  }

  orderItemCount(index) {
    return parseInt(index) + 1;
  }

  /**
   * Get product package and update it Or if not set productID delete product ad this index and recalculate total
   *
   * @param i orderItem index
   * @param j OrderItemProduct index
   * @param productId product ID
   */
  getPackages(i, j, productId) {
    // // set current order item -> orderItemProduct productObj to null
    // this.order.orderItems[i].orderItemProducts[j].productObj = null;
    // set current order item -> orderItemProduct orderItemProductPackages empty
    const orderItemProductPackagesCopy = _.cloneDeep(this.order.orderItems[i].orderItemProducts[j].orderItemProductPackages);
    this.order.orderItems[i].orderItemProducts[j].orderItemProductPackages = [];
    // set current order item -> orderItemProduct orderItemProductFabricCollection to empty OrderItemProductFabricCollection
    if (!Helper.isDefined(this.order.orderItems[i].orderItemProducts[j].orderItemProductFabricCollection)) {
      this.order.orderItems[i].orderItemProducts[j].orderItemProductFabricCollection = new OrderItemProductFabricCollection();
    }
    // remove Selected product at `i` and `j` index if productID is null
    if (productId === null) {
      // this.order.orderItems[i].orderItemProducts.splice(j, 1); // delete product at `i` and `j` index
      // this.deleteOrderProduct(i, j);
      this.removeExtraOption(i, this.order.orderItems[i].orderItemProducts[j].productObj.id);
      this.order.orderItems[i].orderItemProducts[j].productObj = null;
      this.order.orderItems[i].orderItemProducts[j].amount = 1;
      this.order.orderItems[i].orderItemProducts[j].random = Math.floor((Math.random() * 1000000) + 1);
      this.order.orderItems[i].orderItemProducts[j].allowFabric = false;
      this.order.orderItems[i].orderItemProducts[j].cost = new ProductCost();
      this.order.orderItems[i].orderItemProducts[j].totalCost = new TotalCost();
      this.order.orderItems[i].orderItemProducts[j].orderItemProductPackages = [];
      this.order.orderItems[i].orderItemProducts[j].orderItemProductFabricCollection = new OrderItemProductFabricCollection();
      this.order.orderItems[i].orderItemProducts[j].stockAmountAlert = new StockAmountAlert();
      // // delete whole model if orderItem not have any product item
      // if (this.order.orderItems[i].orderItemProducts.length === 0) {
      //   this.order.orderItems[i].orderItemProducts = [new OrderItemProduct()];
      //   this.order.orderItems[i].model = null;
      //   this.order.orderItems[i].style = null;
      //   this.getAllTotal();
      //   return;
      // }
      this.getAllTotal();
      return;
    }
    new Promise((resolve, reject) => {
      // get requested product item data
      this.productService.getProductItem(productId, 'dealer-system').subscribe(productResp => {
        // load product into productObj we use this in summary box and confirm box
        this.order.orderItems[i].orderItemProducts[j].productObj = productResp;
        // D5: productSizes only exists on productObj from here on, so the saved
        // widthCm/lengthCm can only be matched back onto a preset now — doing it
        // any earlier (e.g. isShow's synchronous copy above) races the fetch and
        // patches selectedSizeId before the option list exists.
        this.restoreRugPreset(this.order.orderItems[i].orderItemProducts[j]);
        // set product image and load it
        if (productResp.image === null) {
          this.order.orderItems[i].orderItemProducts[j].productObj.image = productResp.image;
        } else {
          this.order.orderItems[i].orderItemProducts[j].productObj.image = productResp.image.fileManagers.thumbnail;
        }
        if (this.order.orderItems[i].orderItemProducts[j].productObj.hasOwnProperty('productProperties')) {
          // calculate product properties amount on productChange
          this.order.orderItems[i].orderItemProducts[j].productObj.productProperties = this.calculateProductPropertiesAmount(i, this.order.orderItems[i].orderItemProducts[j].productObj.productProperties);
        }
        // TODO: I don't know how it work
        this.fillStockAmount(this.order.orderItems[i].orderItemProducts[j]);

        // load and restructure product packages with format to use in view
        // TODO: more check here
        const packages = productResp.packages;
        const items = [];
        packages.forEach((pakageItem) => {
          const p = new OrderItemProductPackage;
          p.package = pakageItem.id;
          p.packageObj = pakageItem;
          if (p.packageObj && p.packageObj.deleted) {
            p.packageObj.name += ' (' + this.translate.instant('global.inactive') + ')';
          }
          const copyPackageProducts = JSON.parse(JSON.stringify(p.packageObj.packageProducts));
          p.packageObj.packageProducts = p.packageObj.packageProducts.filter((packageProduct) => packageProduct.product.status && !packageProduct.deleted);
          p.packageObj.products = p.packageObj.packageProducts;
          const selectedPackageProduct = _.find(orderItemProductPackagesCopy, (packageProduct: any) => packageProduct.package.id === p.packageObj.id);

          if (selectedPackageProduct !== undefined && selectedPackageProduct.orderItemProductPackageProducts.length > 0) {
            p.orderItemProductPackageProducts = selectedPackageProduct.orderItemProductPackageProducts;
            if (p.orderItemProductPackageProducts.length > 0 && p.orderItemProductPackageProducts[0].product.hasOwnProperty('id')) {
              const product = <Product>p.orderItemProductPackageProducts[0].product;
              p.orderItemProductPackageProducts[0].productObj = product;
              p.orderItemProductPackageProducts[0].product = product.id;

              if (p.orderItemProductPackageProducts[0]) {
                const item = JSON.parse(JSON.stringify(p.orderItemProductPackageProducts[0]));
                // find current selected in collections list
                const currentCollection = _.find(p.packageObj.packageProducts, (packageProductItem: any) => packageProductItem.product.id === item.productObj.id);
                // if not exist current select item in collections list add it with inactive added to name and disable
                if (currentCollection === undefined) {
                  if (item) {
                    const itemProduct = _.find(copyPackageProducts, (packageProductItem: any) => packageProductItem.product.id === item.productObj.id);
                    itemProduct.product.name += ' (' + this.translate.instant('global.inactive') + ')';
                    itemProduct.disabled = true;
                    itemProduct.id = item.productObj.id;
                    itemProduct.disabled = true;
                    itemProduct.dealerPrice = item.cost.dealerPrice;
                    itemProduct.customerPrice = item.cost.customerPrice;
                    p.packageObj.packageProducts.push(itemProduct);
                  }
                }
              }
              p.orderItemProductPackageProducts[0].productObj = _.find(p.packageObj.products, (packageProduct: any) => p.orderItemProductPackageProducts[0].product === packageProduct.product.id);
            }
          }
          if (p.packageObj.packageProducts.length > 0) {
            items.push(p);
          }
        });
        this.order.orderItems[i].orderItemProducts[j].orderItemProductPackages = items;
        if (this.isEdit) {
          this.order.orderItems[i].orderItemProducts[j].orderItemProductPackages.forEach((packageItem, z) => {
            this.findPackProduct(i, j, z, packageItem.orderItemProductPackageProducts[0].product);
            this.fillStockAmountForPackage(packageItem.orderItemProductPackageProducts[0]);
          });
        }
        resolve(true);
      });
    }).then(() => {
      let collectionId = this.order.orderItems[i].collection;
      let modelId = this.order.orderItems[i].model;
      productId = this.order.orderItems[i].orderItemProducts[j].product;

      if (this.isShow) {
        collectionId = this.order.orderItems[i].collection['id'];
        modelId = this.order.orderItems[i].model['id'];
        productId = this.order.orderItems[i].orderItemProducts[j].product;
      }
      // get fabric based on collection of order item
      this.collectionService.getFabricCollectionWithCollection(collectionId, modelId, productId).subscribe((respColection) => {
        // set order item products fabric collection for list fabrics in product fabric
        this.order.orderItems[i].orderItemProducts[j].orderItemProductFabricCollection.fabricsCollections = respColection;
        // first fabric default
        const firstProduct = this.order.orderItems[i].orderItemProducts[0];
        // check if fabric collection of this product not equal to first product in this order item active different fabric check box
        if (Helper.isDefined(this.order.orderItems[i].orderItemProducts[j].orderItemProductFabricCollection.fabricCollection) &&
          this.order.orderItems[i].orderItemProducts[j].orderItemProductFabricCollection.fabricCollection !== null &&
          (
            (firstProduct.orderItemProductFabricCollection.fabricCollection !== this.order.orderItems[i].orderItemProducts[j].orderItemProductFabricCollection.fabricCollection) ||
            (firstProduct.orderItemProductFabricCollection.fabric !== this.order.orderItems[i].orderItemProducts[j].orderItemProductFabricCollection.fabric) ||
            (firstProduct.orderItemProductFabricCollection.fabricColor !== this.order.orderItems[i].orderItemProducts[j].orderItemProductFabricCollection.fabricColor)
          )) {
          // this.allowFabric(i, j, this.order.orderItems[i].orderItemProducts[j].allowFabric);
        } else if (this.order.orderItems[i].orderItemProducts[j].productObj.hasFabric &&
          firstProduct.orderItemProductFabricCollection &&
          firstProduct.orderItemProductFabricCollection.fabricCollection) {
          this.order.orderItems[i].orderItemProducts[j].orderItemProductFabricCollection.fabricCollection =
            firstProduct.orderItemProductFabricCollection.fabricCollection;
          this.order.orderItems[i].orderItemProducts[j].orderItemProductFabricCollection.fabricCollectionObj =
            firstProduct.orderItemProductFabricCollection.fabricCollectionObj;
        }

        // if product not have any fabric set fabric Object to empty fabric
        if (!this.order.orderItems[i].orderItemProducts[j].orderItemProductFabricCollection.fabricObj) {
          this.order.orderItems[i].orderItemProducts[j].orderItemProductFabricCollection.fabricObj = new Fabric();
        }

        if (!this.order.orderItems[i].orderItemProducts[j].orderItemProductFabricCollection.fabricObj.name && firstProduct.orderItemProductFabricCollection.fabricObj) {
          this.order.orderItems[i].orderItemProducts[j].orderItemProductFabricCollection.fabrics = _.filter(firstProduct.orderItemProductFabricCollection.fabrics, 'status');
          this.order.orderItems[i].orderItemProducts[j].orderItemProductFabricCollection.fabricObj = firstProduct.orderItemProductFabricCollection.fabricObj;
          this.order.orderItems[i].orderItemProducts[j].orderItemProductFabricCollection.fabric = firstProduct.orderItemProductFabricCollection.fabric;

          this.order.orderItems[i].orderItemProducts[j].orderItemProductFabricCollection.fabricColors = _.filter(firstProduct.orderItemProductFabricCollection.fabricColors, 'status');
          this.order.orderItems[i].orderItemProducts[j].orderItemProductFabricCollection.fabricColorObj = firstProduct.orderItemProductFabricCollection.fabricColorObj;
          this.order.orderItems[i].orderItemProducts[j].orderItemProductFabricCollection.fabricColor = firstProduct.orderItemProductFabricCollection.fabricColor;

        }
        if (!this.order.orderItems[i].orderItemProducts[j].productObj.hasFabric) {
          this.order.orderItems[i].orderItemProducts[j].orderItemProductFabricCollection = new OrderItemProductFabricCollection();
        }

        this.addInactiveItem(this.order.orderItems[i].orderItemProducts[j].orderItemProductFabricCollection.fabricsCollections, this.order.orderItems[i].orderItemProducts[j].orderItemProductFabricCollection.fabricCollectionObj);
        if (Helper.isDefined(this.order.orderItems[i].orderItemProducts[j].orderItemProductFabricCollection.fabricCollectionObj) &&
          this.order.orderItems[i].orderItemProducts[j].orderItemProductFabricCollection.fabricCollectionObj.status === false) {
          this.order.orderItems[i].orderItemProducts[j].orderItemProductFabricCollection.fabrics = [];
          this.order.orderItems[i].orderItemProducts[j].orderItemProductFabricCollection.fabricColors = [];
        }
        // check if selected fabric is not exist in list add it to list as an inactive item
        this.addInactiveItem(this.order.orderItems[i].orderItemProducts[j].orderItemProductFabricCollection.fabrics, this.order.orderItems[i].orderItemProducts[j].orderItemProductFabricCollection.fabricObj);

        if (Helper.isDefined(this.order.orderItems[i].orderItemProducts[j].orderItemProductFabricCollection.fabricObj) &&
          this.order.orderItems[i].orderItemProducts[j].orderItemProductFabricCollection.fabricObj.status === false) {
          this.order.orderItems[i].orderItemProducts[j].orderItemProductFabricCollection.fabricColors = [];
        }
        // check if selected fabric color is not exist in list add it to list as an inactive item
        this.addInactiveItem(this.order.orderItems[i].orderItemProducts[j].orderItemProductFabricCollection.fabricColors, this.order.orderItems[i].orderItemProducts[j].orderItemProductFabricCollection.fabricColorObj);
        // This function reload all options list in order item `i`

        this.byRemoveProductUpdateOptionsList(i, productId);
        this.getAllTotal();
      });
    });
  }

  /**
   * Check stock amount
   * TODO: we must fix it
   *
   * @param orderItemProduct
   */
  private fillStockAmount(orderItemProduct: OrderItemProduct) {
    let color;
    let message;
    let shouldShow;
    const stock = parseInt(orderItemProduct.productObj.ownStock) > 0 ? parseInt(orderItemProduct.productObj.ownStock) : parseInt(orderItemProduct.productObj.stock);
    const lowStockTrigger = parseInt(orderItemProduct.productObj.lowStockTrigger);
    if (orderItemProduct.productObj.manageStock !== true) {
      orderItemProduct.stockAmountAlert.shouldShow = false;
      return;
    }
    if (stock >= lowStockTrigger) {
      color = 'green';
      message = this.translate.instant('admin.dealer.order.stock_message_green');
      shouldShow = true;
    } else if (stock < lowStockTrigger && stock > 0) {
      color = 'orange';
      message = this.translate.instant('admin.dealer.order.stock_message_orange');
      shouldShow = true;
    } else if ((stock <= 0) || orderItemProduct.productObj.stock === null) {
      color = 'red';
      message = this.translate.instant('admin.dealer.order.stock_message_red');
      shouldShow = true;
    }
    orderItemProduct.stockAmountAlert.color = color;
    orderItemProduct.stockAmountAlert.message = message;
    orderItemProduct.stockAmountAlert.shouldShow = shouldShow;

  }

  public fillStockAmountForPackage(orderItemProductPackageProduct) {
    if (orderItemProductPackageProduct.productObj && orderItemProductPackageProduct.productObj.product) {
      let color;
      let message;
      let shouldShow;
      const stock = parseInt(orderItemProductPackageProduct.productObj.product.ownStock) > 0 ? parseInt(orderItemProductPackageProduct.productObj.product.ownStock) : parseInt(orderItemProductPackageProduct.productObj.product.stock);
      const lowStockTrigger = parseInt(orderItemProductPackageProduct.productObj.product.lowStockTrigger);
      if (this.isEdit && !Helper.isDefined(orderItemProductPackageProduct.stockAmountAlert)) {
        orderItemProductPackageProduct.stockAmountAlert = new StockAmountAlert();
      }
      if (orderItemProductPackageProduct.productObj.product.manageStock !== true) {
        orderItemProductPackageProduct.stockAmountAlert.shouldShow = false;
        return;
      }
      if (stock >= lowStockTrigger) {
        color = 'green';
        message = this.translate.instant('admin.dealer.order.stock_message_green');
        shouldShow = true;
      } else if (stock < lowStockTrigger && stock > 0) {
        color = 'orange';
        message = this.translate.instant('admin.dealer.order.stock_message_orange');
        shouldShow = true;
      } else if (stock <= 0 || orderItemProductPackageProduct.productObj.product.stock === null) {
        color = 'red';
        message = this.translate.instant('admin.dealer.order.stock_message_red');
        shouldShow = true;
      }
      orderItemProductPackageProduct.stockAmountAlert.color = color;
      orderItemProductPackageProduct.stockAmountAlert.message = message;
      orderItemProductPackageProduct.stockAmountAlert.shouldShow = shouldShow;
    }
  }

  filterFabricCollection(i, j, query) {
    let params = new HttpParams();
    params = params.set('q[product_id]', this.order.orderItems[i].orderItemProducts[j].product.toString());
    params = params.set('query', query.term);
    this.fabricCollectionService.getFabricCollectionList(params, new HttpParams(), 'dealer-system').subscribe((resp) => {
      this.order.orderItems[i].orderItemProducts[j].orderItemProductFabricCollection.fabricsCollections = _.filter(resp.data, 'status');
    });
  }

  findFabricCollection(orderItemId, productItemId, fabricCollectionId): FabricCollection {


    return this.order.orderItems[orderItemId].orderItemProducts[productItemId]
      .orderItemProductFabricCollection.fabricsCollections.filter(fabricCollection => {
        if (fabricCollection.id === parseInt(fabricCollectionId)) {
          return true;
        }
        return false;
      }).pop();
  }

  filterFabric(i, j, query) {
    let params = new HttpParams();
    params = params.set('query', query.term);

    this.fabricCollectionService.getFabricByQueryAndCollection(this.order.orderItems[i].collection, this.order.orderItems[i].orderItemProducts[j]
      .orderItemProductFabricCollection.fabricCollection.toString(), params, 'dealer-system').subscribe((resp) => {
      this.order.orderItems[i].orderItemProducts[j].orderItemProductFabricCollection.fabrics = _.filter(resp, 'status');
    });
  }

  findFabric(orderItemId, productItemId, fabricId): Fabric {
    return this.order.orderItems[orderItemId].orderItemProducts[productItemId]
      .orderItemProductFabricCollection.fabrics.filter(fabric => {
        if (fabric.id === parseInt(fabricId)) {
          return true;
        }
        return false;
      }).pop();
  }

  findFabricColor(orderItemId, productItemId, fabricColorId): FabricColor {
    return this.order.orderItems[orderItemId].orderItemProducts[productItemId]
      .orderItemProductFabricCollection.fabricColors.filter(color => {
        if (color.id === parseInt(fabricColorId)) {
          return true;
        }
        return false;
      }).pop();
  }

  filterFabricColor(i, j, query) {
    let params = new HttpParams();
    params = params.set('query', query.term);
    this.fabricService.getFabricColorByQuery(this.order.orderItems[i].orderItemProducts[j]
      .orderItemProductFabricCollection.fabric.toString(), params, 'dealer-system').subscribe((resp) => {
      this.order.orderItems[i].orderItemProducts[j].orderItemProductFabricCollection.fabricColors = _.filter(resp, 'status');
    });
  }

  /**
   * Get fabric for fabricCollection ID
   *
   * @param i orderItem index
   * @param j Order Item product index in selected orderItem
   * @param fabricCollectionId
   */
  getFabric(i, j, fabricCollectionId) {
    this.order.orderItems[i].orderItemProducts[j].orderItemProductFabricCollection.fabric = null;
    this.order.orderItems[i].orderItemProducts[j].orderItemProductFabricCollection.fabricCollectionObj = null;
    this.order.orderItems[i].orderItemProducts[j].orderItemProductFabricCollection.fabricColor = null;
    // removeSelected fabric
    if (fabricCollectionId == null) {
      // remove
      if (j == 0) {
        // theOther
        this.order.orderItems[i].orderItemProducts.forEach(item => {
          if (!item.allowFabric) {
            item.orderItemProductFabricCollection.fabricCollection = null;
            item.orderItemProductFabricCollection.fabricCollectionObj = null;


            item.orderItemProductFabricCollection.fabricObj = null;
            item.orderItemProductFabricCollection.fabric = null;

            item.orderItemProductFabricCollection.fabricColorObj = null;
            item.orderItemProductFabricCollection.fabricColor = null;
          }
        });
      } else {
        // self
        this.order.orderItems[i].orderItemProducts[j].orderItemProductFabricCollection.fabricCollection = null;
        this.order.orderItems[i].orderItemProducts[j].orderItemProductFabricCollection.fabricCollectionObj = null;
      }


      this.getAllTotal();
      return;
    }
    new Promise((resolve, reject) => {


      this.fabricCollectionService.getFabricsByCollectionAndFabricCollection(this.order.orderItems[i].collection, fabricCollectionId, 'dealer-system').subscribe((resp) => {
        this.order.orderItems[i].orderItemProducts[j].orderItemProductFabricCollection.fabrics = _.filter(resp, 'status');
        this.order.orderItems[i].orderItemProducts[j].orderItemProductFabricCollection.fabricCollectionObj =
          this.findFabricCollection(i, j, fabricCollectionId);
        // step one fill another with first
        if (j == 0) {

          this.order.orderItems[i].orderItemProducts.forEach(item => {
            if (!item.allowFabric &&
              item.productObj.hasFabric) {
              item.orderItemProductFabricCollection.fabricCollection = this.order.orderItems[i].orderItemProducts[0].orderItemProductFabricCollection.fabricCollection;

              item.orderItemProductFabricCollection.fabricCollectionObj = this.order.orderItems[i].orderItemProducts[0].orderItemProductFabricCollection.fabricCollectionObj;
              item.orderItemProductFabricCollection.fabricColorObj = null;
              item.orderItemProductFabricCollection.fabricColor = null;
              item.orderItemProductFabricCollection.fabricColors = null;
              item.orderItemProductFabricCollection.fabricObj = null;
              item.orderItemProductFabricCollection.fabric = null;
            }
          });
        }

        resolve(true);
      });
    }).then(() => {
      this.getAllTotal();
    });
  }

  /**
   * Get fabric colors for selected fabric ID
   *
   * @param i OrderItem index
   * @param j OrderItem product index for selected order item
   * @param fabricId
   */
  getFabricColor(i, j, fabricId) {
    if (fabricId == null) {
      if (j == 0) {
        this.order.orderItems[i].orderItemProducts[j].orderItemProductFabricCollection.fabricColorObj = null;
        this.order.orderItems[i].orderItemProducts[j].orderItemProductFabricCollection.fabricColor = null;
        this.order.orderItems[i].orderItemProducts[j].orderItemProductFabricCollection.fabricObj = null;
        this.order.orderItems[i].orderItemProducts[j].orderItemProductFabricCollection.fabric = null;
        this.order.orderItems[i].orderItemProducts.forEach(item => {
          if (this.order.orderItems[i].orderItemProducts.indexOf(item) != 0) {
            if (!item.allowFabric) {
              item.orderItemProductFabricCollection.fabricObj = this.order.orderItems[i].orderItemProducts[0].orderItemProductFabricCollection.fabricObj;
              item.orderItemProductFabricCollection.fabric = this.order.orderItems[i].orderItemProducts[0].orderItemProductFabricCollection.fabric;

              item.orderItemProductFabricCollection.fabricColorObj = this.order.orderItems[i].orderItemProducts[0].orderItemProductFabricCollection.fabricColorObj;
              item.orderItemProductFabricCollection.fabricColor = this.order.orderItems[i].orderItemProducts[0].orderItemProductFabricCollection.fabricColor;
            }
          }


        });

        this.getAllTotal();
        return;
      }

    }

    this.order.orderItems[i].orderItemProducts[j].orderItemProductFabricCollection.fabricColor = null;

    new Promise((resolve, reject) => {
      this.fabricService.getFabricColorByQuery(fabricId, new HttpParams(), 'dealer-system').subscribe((resp) => {
        this.order.orderItems[i].orderItemProducts[j].orderItemProductFabricCollection.fabricColors = _.filter(resp, 'status');
        this.order.orderItems[i].orderItemProducts[j].orderItemProductFabricCollection.fabricObj = this.findFabric(i, j, fabricId);
        // step two fill another with first
        if (j == 0) {
          this.order.orderItems[i].orderItemProducts.forEach(item => {
            if (!item.allowFabric) {
              item.orderItemProductFabricCollection.fabricObj = this.order.orderItems[i].orderItemProducts[0].orderItemProductFabricCollection.fabricObj;
              item.orderItemProductFabricCollection.fabric = this.order.orderItems[i].orderItemProducts[0].orderItemProductFabricCollection.fabric;
              item.orderItemProductFabricCollection.fabricColorObj = this.order.orderItems[i].orderItemProducts[0].orderItemProductFabricCollection.fabricColorObj;
              item.orderItemProductFabricCollection.fabricColor = this.order.orderItems[i].orderItemProducts[0].orderItemProductFabricCollection.fabricColor;
            }
          });
        }
        resolve(true);
      });
    }).then(() => this.getAllTotal());
  }

  /**
   * Set fabricColor object base on input fabric color id in selected order item product
   * @param i ordeItem index
   * @param j orderItem product index in selected order item
   * @param fabricColorId
   */
  changeFabricColor(i, j, fabricColorId) {
    this.order.orderItems[i].orderItemProducts[j].orderItemProductFabricCollection.fabricColorObj
      = this.findFabricColor(i, j, fabricColorId);
    // step two fill another with first
    if (j === 0) {
      this.order.orderItems[i].orderItemProducts.forEach(item => {
        if (!item.allowFabric) {
          item.orderItemProductFabricCollection.fabricColorObj = this.order.orderItems[i].orderItemProducts[0].orderItemProductFabricCollection.fabricColorObj;
          item.orderItemProductFabricCollection.fabricColor = this.order.orderItems[i].orderItemProducts[0].orderItemProductFabricCollection.fabricColor;
        }
      });
    }
    this.getAllTotal();
  }

  /**
   * Set fabricColor object base on input fabric color id in selected order item product
   * @param i ordeItem index
   * @param j orderItem product index in selected order item
   * @param fabricColorName
   */
  changeFabricColorName(i, j, fabricColorName) {
    this.order.orderItems[i].orderItemProducts[j].orderItemProductFabricCollection.fabricColorName = this.order.orderItems[i].orderItemProducts[j].orderItemProductFabricCollection.fabricCollectionObj.fabricColorName
      = fabricColorName;
    // step two fill another with first
    if (j === 0) {
      this.order.orderItems[i].orderItemProducts.forEach(item => {
        if (!item.allowFabric) {
          item.orderItemProductFabricCollection.fabricCollectionObj = this.order.orderItems[i].orderItemProducts[0].orderItemProductFabricCollection.fabricCollectionObj;
          item.orderItemProductFabricCollection.fabricColorName = this.order.orderItems[i].orderItemProducts[0].orderItemProductFabricCollection.fabricColorName;
        }
      });
    }
    this.getAllTotal();
  }

  changeFabric(i, j, fabricId) {
    this.order.orderItems[i].orderItemProducts[j].orderItemProductFabricCollection.fabricObj
      = this.findFabric(i, j, fabricId);
    // step two fill another with first
    if (j === 0) {
      this.order.orderItems[i].orderItemProducts.forEach(item => {
        if (!item.allowFabric) {
          item.orderItemProductFabricCollection.fabricObj = this.order.orderItems[i].orderItemProducts[0].orderItemProductFabricCollection.fabricObj;
          item.orderItemProductFabricCollection.fabric = this.order.orderItems[i].orderItemProducts[0].orderItemProductFabricCollection.fabric;
        }
      });
    }
    this.getAllTotal();
  }

  changeFabricName(i, j, fabricName) {
    this.order.orderItems[i].orderItemProducts[j].orderItemProductFabricCollection.fabricName = this.order.orderItems[i].orderItemProducts[j].orderItemProductFabricCollection.fabricCollectionObj.fabricName
      = fabricName;
    // step two fill another with first
    if (j === 0) {
      this.order.orderItems[i].orderItemProducts.forEach(item => {
        if (!item.allowFabric) {
          item.orderItemProductFabricCollection.fabricCollectionObj = this.order.orderItems[i].orderItemProducts[0].orderItemProductFabricCollection.fabricCollectionObj;
          item.orderItemProductFabricCollection.fabricName = this.order.orderItems[i].orderItemProducts[0].orderItemProductFabricCollection.fabricName;
        }
      });
    }
    this.getAllTotal();
  }

  calculateFabricPrice(i, j) {
    const fabricCollection = this.order.orderItems[i].orderItemProducts[j].orderItemProductFabricCollection;
    const priceScope = (this.customerPrice) ? 'customerPrice' : 'dealerPrice';
    const fabricCollectionPrice = (fabricCollection.fabricCollectionObj) ? fabricCollection.fabricCollectionObj[priceScope] : 0;

    const fabricPrice = (fabricCollection.fabricObj) ? fabricCollection.fabricObj[priceScope] : 0;


    return fabricCollectionPrice + fabricPrice;
  }

  getSubProduct(i, j, z, product) {
    return this.order.orderItems[i].orderItemProducts[j].orderItemProductPackages[z].packageObj.products.filter(productItem => {
      if (product == productItem.id) {
        return true;
      }
      return false;
    }).pop();
  }

  findPackProduct(i, j, z, product) {
    if (this.order.orderItems[i].orderItemProducts[j].orderItemProductPackages[z].packageObj.packageProducts) {
      this.order.orderItems[i].orderItemProducts[j].orderItemProductPackages[z].orderItemProductPackageProducts[0].productObj = this.order.orderItems[i].orderItemProducts[j].orderItemProductPackages[z].packageObj.packageProducts.filter(packageProduct => {
        if (product == packageProduct.product.id) {
          return true;
        }
        return false;
      }).pop();
    }
  }

  getAllTotal(i = null) {
    const baseTotalCost = new TotalCost();
  // articel
    this.order.transportationCost = 0;
    this.order.deliveryCost = 0;
    this.order.dealerDeliveryCost = 0;
    this.order.orderItems.forEach((orderItem, index) => {
      // product of Articel
      orderItem.orderItemProducts.forEach((orderItemProduct) => {
        const amount = orderItemProduct.amount;
        const cost = orderItemProduct.cost;
        const totalCost = orderItemProduct.totalCost;
        const product = orderItemProduct.productObj;
        if (!product) {
          return;
        }
        const itemTransportationCost = this.calculateTransportationCost(index, this.order.user.invoiceDealer, product, amount);
        if (null !== itemTransportationCost) {
          this.order.transportationCost = Helper.bcAdd(this.order.transportationCost, itemTransportationCost);
        }

        const itemDeliveryCostForDealer = this.calculateDeliveryCost(product, amount);
        if (null !== itemDeliveryCostForDealer && this.order.secondaryDeliveryAt === Order.DELIVERY_AT_CUSTOMER) {
          this.order.dealerDeliveryCost = Helper.bcAdd(this.order.dealerDeliveryCost, itemDeliveryCostForDealer);
        }

        const itemDeliveryCostForCustomer = this.calculateDeliveryCost(product, amount, false);
        if (null !== itemDeliveryCostForCustomer && this.order.secondaryDeliveryAt === Order.DELIVERY_AT_CUSTOMER) {
          this.order.deliveryCost = Helper.bcAdd(this.order.deliveryCost, itemDeliveryCostForCustomer);
        }
        // if (orderItemProduct.perProductOptionObj && orderItemProduct.perProductOptions && orderItemProduct.perProductOptions.length > 0) {
        //   let childOption = orderItemProduct.perProductOptionObj.option.options.filter(option => {
        //     return option.deleted !== true;
        //   })[0];
        //   const selectedOption = orderItemProduct.perProductOptions[0];
        //   if (childOption.type === Option.OPTION_TYPE_SELECT) {
        //     const optionItem = childOption.options.filter(option => {
        //       return option.id == selectedOption.option;
        //     })[0];
        //     if (optionItem) {
        //       childOption = optionItem;
        //     }
        //   }
        //   customerOrderPrice += this.isCalculatable(orderItemProduct, childOption) ? childOption.customerPrice * orderItemProduct.amount : 0;
        //   dealerOrderPrice += this.isCalculatable(orderItemProduct, childOption) ? childOption.dealerPrice * orderItemProduct.amount : 0;
        // }
        // A rug's line total is REPLACED by the carpet formula, not added to it, and is
        // computed before option costs accumulate — otherwise shape and finishing are
        // charged twice (FR-015). Returning here skips the sofa-only product, package
        // and fabric costing below, none of which applies to a rug.
        //
        // Shape/finishing/colour are skipped, but every OTHER option on the rug still
        // prices normally: OptionProduct scoping puts no category restriction on what
        // a rug may carry, and OrderService::applyPrices() filters rather than
        // blanket-skipping. Blanket-skipping here would show the dealer a lower total
        // than the server charges.
        if (Product.isRug(product)) {
          this.applyCarpetCost(baseTotalCost, orderItemProduct, index, amount);

          const rugOptions = this.accumulateOptionCosts(orderItemProduct, this.carpetSummaryOptionIds(orderItem));
          baseTotalCost.totalCustomerCost += rugOptions.customer;
          baseTotalCost.totalDealerPrice += rugOptions.dealer;
          return;
        }

        // let vat = country.vat.rate;
        // this.applyCost(baseTotalCost, cost, totalCost, product, amount, vat);
        this.applyCost(baseTotalCost, orderItemProduct.cost, totalCost, product, amount);
        orderItemProduct.orderItemProductPackages.forEach((orderItemProductPackage) => {
          orderItemProductPackage.orderItemProductPackageProducts.forEach((orderItemProductPackageProduct) => {
            orderItemProductPackageProduct.cost = new ProductCost();
            const costPackage = orderItemProductPackageProduct.cost;
            const totalCostPackage = orderItemProductPackageProduct.totalCost;
            const productPackage = orderItemProductPackageProduct.productObj;
            if (!productPackage) {
              return;
            }
            this.applyCostPackageProduct(baseTotalCost, costPackage, totalCostPackage, productPackage, amount);
          });
        });
        if (orderItemProduct.orderItemProductFabricCollection != null && Helper.isDefined(orderItemProduct.orderItemProductFabricCollection.fabricCollectionObj)) {
          let fabricAmount = amount;
          const costFabric = orderItemProduct.orderItemProductFabricCollection.cost;
          const totalCostFabric = orderItemProduct.orderItemProductFabricCollection.totalCost;
          // this.applyFabricCost(baseTotalCost, cost, totalCost, orderItemProduct.orderItemProductFabricCollection, amount, vat);
          const productProperties = this.calculateProductPropertiesAmount(index, product.productProperties);
          if (productProperties instanceof Array) {
            productProperties.forEach(productProperty => {
              if (orderItemProduct.orderItemProductFabricCollection.fabricCollectionObj
                && orderItemProduct.orderItemProductFabricCollection.fabricCollectionObj.isCustom) {
                if (productProperty.property.code === Property.PROPERTY_FABRIC_STOFVERRUIK) {
                  fabricAmount = Number((parseFloat(productProperty.amount) * orderItemProduct.amount).toFixed(2));
                }
              } else {
                if (productProperty.property.code === Property.PROPERTY_FABRIC_AMOUNT) {
                  fabricAmount = Number((parseFloat(productProperty.amount) * orderItemProduct.amount).toFixed(2));
                }
              }
            });
          }
          fabricAmount = orderItemProduct.orderItemProductFabricCollection.fabricCollectionObj && orderItemProduct.orderItemProductFabricCollection.fabricCollectionObj.isCustom ? this.recalculateFabricAmount(fabricAmount, orderItemProduct.summaryOptions, orderItemProduct.amount) : fabricAmount;
          this.applyFabricCost(baseTotalCost, costFabric, totalCostFabric, orderItemProduct.orderItemProductFabricCollection, fabricAmount);
        }

        /**
         * Calculate order item options
         */
        const options = this.accumulateOptionCosts(orderItemProduct, []);
        baseTotalCost.totalCustomerCost = options.customer + baseTotalCost.totalCustomerCost;
        baseTotalCost.totalDealerPrice = options.dealer + baseTotalCost.totalDealerPrice;
      });

      // Derived from the line totals the loop above has just finished computing, not
      // accumulated alongside them (POS-D02). See articleSubtotals().
      const subtotals = this.articleSubtotals(orderItem);
      orderItem.totalArticleCustomerPrice = subtotals.customer;
      orderItem.totalArticleDealerPrice = subtotals.dealer;
    });

    if (Helper.isDefined(this.order.transportationCost)) {
      baseTotalCost.totalDealerPrice += this.order.transportationCost;
    }

    if (Helper.isDefined(this.order.deliveryCost)) {
      baseTotalCost.totalCustomerPrice += this.order.deliveryCost;
      baseTotalCost.totalCustomerCost += this.order.deliveryCost;
    }

    if (Helper.isDefined(this.order.dealerDeliveryCost)) {
      baseTotalCost.totalDealerPrice += this.order.dealerDeliveryCost;
    }

    // calculate custom row price
    if (Helper.isDefined(this.order.customRows)) {
      this.order.customRows.forEach((customRow, index) => {
        baseTotalCost.totalDealerPrice += customRow.amount && customRow.price ? customRow.amount * customRow.price : 0;
        if (this.order.user?.isCustomerAccount) {
          baseTotalCost.totalCustomerCost += customRow.amount && customRow.price ? customRow.amount * customRow.price : 0;
        }
      });
    }

    baseTotalCost.totalDealerCost = baseTotalCost.totalDealerPrice + Helper.percentageOf(baseTotalCost.totalDealerPrice, this.dealerVAT);
    this.order.totalCost = baseTotalCost;
    this.updateOrderDiscount();
    this.checkDeliveryOption();
  }

  // applyCost(baseTotalCost, cost, totalCost, product, amount, vat) {
  applyCost(baseTotalCost, cost, totalCost, product, amount) {
    const productPrice = _.find(product.prices, (price) => price.country.id === this.order.user.country.id);
    if (productPrice) {
      // set default price as country price when country price not set
      product.customerPrice = productPrice.customerPrice ? productPrice.customerPrice : product.customerPrice;
      // set default price as country price when country price not set
      product.dealerPrice = productPrice.dealerPrice ? productPrice.dealerPrice : product.dealerPrice;
    }
    cost.customerPrice = cost.customerPrice && this.isShow ? cost.customerPrice : product.customerPrice;
    if (this.order.user.invoiceDealer && this.order.user.invoiceDealer.collectionDiscounts) {
      const collectionDiscounts = this.order.user.invoiceDealer.collectionDiscounts;
      if (collectionDiscounts && collectionDiscounts.length > 0) {
        collectionDiscounts.forEach(collectionDiscount => {
          if ((product.collection && product.collection.id !== undefined) && (product.collection && collectionDiscount.collection.id === product.collection.id)) {
            const discount = Helper.percentageOf(product.dealerPrice, collectionDiscount.discount);
            product.dealerPrice -= discount;
          }
        });
      }
    }
    cost.dealerPrice = product.dealerPrice;
    cost.amount = amount;

    totalCost.totalCustomerPrice = cost.customerPrice * cost.amount;
    totalCost.totalDealerPrice = cost.dealerPrice * cost.amount;

    totalCost.totalDealerVAT = Helper.percentageOf(totalCost.totalDealerPrice, this.dealerVAT); // Replace with below lie
    // totalCost.totalDealerVAT = 0;

    totalCost.totalCustomerCost = totalCost.totalCustomerPrice;
    totalCost.totalDealerCost = totalCost.totalDealerPrice + totalCost.totalDealerVAT;

    baseTotalCost.totalCustomerPrice = baseTotalCost.totalCustomerPrice + totalCost.totalCustomerPrice;
    baseTotalCost.totalDealerPrice = baseTotalCost.totalDealerPrice + totalCost.totalDealerPrice;
    baseTotalCost.totalDealerVAT = baseTotalCost.totalDealerVAT + totalCost.totalDealerVAT;
    baseTotalCost.totalCustomerCost = baseTotalCost.totalCustomerCost + totalCost.totalCustomerCost;
    baseTotalCost.totalDealerCost = baseTotalCost.totalDealerCost + totalCost.totalDealerCost;
  }

  /**
   * The rug analogue of applyCost(). Same shape, same VAT semantics — the only
   * difference is that the per-unit prices come from the carpet formula instead
   * of straight off the product, and the result is cached on the line so the
   * template reads a value rather than recomputing on every change detection pass.
   */
  applyCarpetCost(baseTotalCost, orderItemProduct, i, amount) {
    const cost = orderItemProduct.cost;
    const totalCost = orderItemProduct.totalCost;
    const carpet = this.carpetCost(i, orderItemProduct);
    orderItemProduct.carpetCost = carpet;
    orderItemProduct.carpetDescription = this.carpetSummaryDescription(this.order.orderItems[i], orderItemProduct);
    // D7/D8: the sidebar, confirmation modal and PDF all read summaryOptions through the
    // same row template a sofa's options use, so giving the rug real rows here is enough
    // for all three surfaces to show size/shape/finishing/colour with prices.
    orderItemProduct.summaryOptions = this.mergeCarpetSummaryRows(this.order.orderItems[i], orderItemProduct, carpet, amount);
    if (!carpet) {
      // no dimensions yet — the line contributes nothing until the dealer enters them
      cost.customerPrice = 0;
      cost.dealerPrice = 0;
      cost.amount = amount;
      Object.keys(totalCost).forEach(key => totalCost[key] = 0);
      return;
    }
    cost.customerPrice = carpet.perUnitCustomerInclVat;
    cost.dealerPrice = carpet.perUnitDealerExclVat;
    cost.amount = amount;

    totalCost.totalCustomerPrice = cost.customerPrice * cost.amount;
    totalCost.totalDealerPrice = cost.dealerPrice * cost.amount;
    totalCost.totalDealerVAT = Helper.percentageOf(totalCost.totalDealerPrice, this.dealerVAT);
    totalCost.totalCustomerCost = totalCost.totalCustomerPrice;
    totalCost.totalDealerCost = totalCost.totalDealerPrice + totalCost.totalDealerVAT;

    baseTotalCost.totalCustomerPrice += totalCost.totalCustomerPrice;
    baseTotalCost.totalDealerPrice += totalCost.totalDealerPrice;
    baseTotalCost.totalDealerVAT += totalCost.totalDealerVAT;
    baseTotalCost.totalCustomerCost += totalCost.totalCustomerCost;
    baseTotalCost.totalDealerCost += totalCost.totalDealerCost;
  }

  applyCostPackageProduct(baseTotalCost, cost, totalCost, productObj, amount) {
    const productPrice = _.find(productObj.prices, (price) => price.country.id === this.order.user.country.id);
    if (productPrice) {
      // set default price as country price when country price not set
      productObj.customerPrice = productPrice.customerPrice ? productPrice.customerPrice : productObj.customerPrice;
      // set default price as country price when country price not set
      productObj.dealerPrice = productPrice.dealerPrice ? productPrice.dealerPrice : productObj.dealerPrice;
    }
    const product = productObj.product;
    if (this.order.user.invoiceDealer && this.order.user.invoiceDealer.collectionDiscounts) {
      const collectionDiscounts = this.order.user.invoiceDealer.collectionDiscounts;
      if (collectionDiscounts && collectionDiscounts.length > 0) {
        collectionDiscounts.forEach(collectionDiscount => {
          if (collectionDiscount.collection.id === product.collection.id && !productObj.calculated) {
            const discount = Helper.percentageOf(productObj.dealerPrice, collectionDiscount.discount);
            productObj.dealerPrice -= discount;
            productObj.calculated = true;
          }
        });
      }
    }
    cost.customerPrice = productObj.customerPrice;
    cost.dealerPrice = productObj.dealerPrice;
    cost.amount = (amount * productObj.amount);

    totalCost.totalCustomerPrice = cost.customerPrice * cost.amount;
    totalCost.totalDealerPrice = cost.dealerPrice * cost.amount;

    totalCost.totalDealerVAT = Helper.percentageOf(totalCost.totalDealerPrice, this.dealerVAT);
    totalCost.totalCustomerVAT = Helper.percentageOf(totalCost.totalCustomerPrice, this.customerVAT);


    totalCost.totalCustomerCost = totalCost.totalCustomerPrice;

    totalCost.totalDealerCost = totalCost.totalDealerPrice + totalCost.totalDealerVAT;

    baseTotalCost.totalCustomerPrice = baseTotalCost.totalCustomerPrice + totalCost.totalCustomerPrice;
    baseTotalCost.totalDealerPrice = baseTotalCost.totalDealerPrice + totalCost.totalDealerPrice;
    baseTotalCost.totalDealerVAT = baseTotalCost.totalDealerVAT + totalCost.totalDealerVAT;
    baseTotalCost.totalCustomerCost = baseTotalCost.totalCustomerCost + totalCost.totalCustomerCost;
    baseTotalCost.totalDealerCost = baseTotalCost.totalDealerCost + totalCost.totalDealerCost;
  }

  // applyFabricCost(baseTotalCost, cost, totalCost, product: OrderItemProductFabricCollection, amount, vat) {
  applyFabricCost(baseTotalCost, cost, totalCost, orderItemProductFabricCollection: OrderItemProductFabricCollection, amount) {
    if (Helper.isDefined(orderItemProductFabricCollection.fabricObj) && orderItemProductFabricCollection.fabricObj != null) {
      cost.customerPrice = (orderItemProductFabricCollection.fabricObj && orderItemProductFabricCollection.fabricObj.overwriteCollectionPrice) ? orderItemProductFabricCollection.fabricObj.customerPrice : orderItemProductFabricCollection.fabricCollectionObj?.customerPrice;
      cost.dealerPrice = (orderItemProductFabricCollection.fabricObj && orderItemProductFabricCollection.fabricObj.overwriteCollectionPrice) ? orderItemProductFabricCollection.fabricObj.dealerPrice : orderItemProductFabricCollection.fabricCollectionObj?.dealerPrice;
    } else {
      // here
      cost.customerPrice = orderItemProductFabricCollection.fabricCollectionObj == null || orderItemProductFabricCollection.fabricCollectionObj.customerPrice == null ? 0 : orderItemProductFabricCollection.fabricCollectionObj.customerPrice;
      cost.dealerPrice = orderItemProductFabricCollection.fabricCollectionObj == null || orderItemProductFabricCollection.fabricCollectionObj.dealerPrice == null ? 0 : orderItemProductFabricCollection.fabricCollectionObj.dealerPrice;
    }
    cost.amount = amount;

    totalCost.totalCustomerPrice = cost.customerPrice * cost.amount;
    totalCost.totalDealerPrice = cost.dealerPrice * cost.amount;

    totalCost.totalDealerVAT = Helper.percentageOf(totalCost.totalDealerPrice, this.dealerVAT);
    // totalCost.totalDealerVAT = 0;

    totalCost.totalCustomerCost = totalCost.totalCustomerPrice;
    totalCost.totalDealerCost = totalCost.totalDealerPrice + totalCost.totalDealerVAT;

    baseTotalCost.totalCustomerPrice = baseTotalCost.totalCustomerPrice + totalCost.totalCustomerPrice;
    baseTotalCost.totalDealerPrice = baseTotalCost.totalDealerPrice + totalCost.totalDealerPrice;
    baseTotalCost.totalDealerVAT = baseTotalCost.totalDealerVAT + totalCost.totalDealerVAT;
    baseTotalCost.totalCustomerCost = baseTotalCost.totalCustomerCost + totalCost.totalCustomerCost;
    baseTotalCost.totalDealerCost = baseTotalCost.totalDealerCost + totalCost.totalDealerCost;
  }

  placeOrder() {
    this.isNewQuote = false;
    if (!this.checkRequiredItems()) {
      return;
    }
    // After checkRequiredItems, so the dealer is never asked for the end customer's details
    // on an order that is still incomplete for other reasons.
    if (!this.requirePosDetails(() => this.placeOrder())) {
      return;
    }
    if (this.order.secondaryDeliveryAt === Order.DELIVERY_AT_CUSTOMER || this.order.user.isCustomerAccount) {
      if (!this.order.user.isCustomerAccount) {
        this.disclaimerService.getDisclaimer('dealer-system').subscribe(res => {
          this.disclaimers = res.data;
          this.addressModal.show();
        });
      } else {
        this.addressModal.show();
      }
    } else {
      this.orderModal.show();
    }
  }

  createOrder() {
    const order = JSON.parse(JSON.stringify(this.order));
    delete order.realDealer
    delete order.totalCost;
    delete order.splitOrders;
    delete order.allowDeliveryWeek;
    delete order.allowSecondaryDeliveryWeek;
    if (order.secondaryDeliveryAt === Order.DELIVERY_AT_DEALER && !order.user.isCustomerAccount) {
      delete order.customerDeliveryAddress;
    }
    // POS insurance: the registration travels INSIDE the order body, as OrderType nests
    // PosRegistrationType (US-607). It has to - PosRegistrationCompletionGuard rejects the
    // submission when an insured order arrives without complete details, so a follow-up call
    // would always be too late. It still writes to its own PosRegistration record and never
    // to customerDeliveryAddress, which is the separation that matters.
    // Trimmed to the eight fields the form type declares: Symfony rejects the whole order
    // form on an extra field, and the loaded record carries id and exportedAt.
    if (this.needsPosDetails() && order.posRegistration) {
      order.posRegistration = ['fullName', 'phoneNumber', 'email', 'country', 'city', 'street', 'houseNumber', 'zipCode']
        .reduce((fields, name) => ({...fields, [name]: order.posRegistration[name]}), {});
    } else {
      delete order.posRegistration;
    }
    delete order.secondaryDeliveryAt;
    delete order.expectedDeliveryWeek;
    delete order.stockDeliveryWeek;
    delete order.orderItemOptions;
    delete order.lastOrder;
    delete order.isConverted;
    delete order.author;
    delete order.internalPackagingLabel;
    delete order.packagingLabels;
    delete order.author;
    delete order.invoices;
    delete order.transportationCost;
    delete order.deliveryCost;
    delete order.dealerDeliveryCost;
    delete order.remainingDays;
    delete order.days;
    delete order.workForm;
    delete order.sticker;
    delete order.serviceContact;
    order.orderItems.map((orderItem) => {
      delete orderItem.id;
      delete orderItem.models;
      delete orderItem.styles;
      delete orderItem.products;
      delete orderItem.modelObj;
      delete orderItem.collectionObj;
      delete orderItem.styleObj;
      delete orderItem.random;
      delete orderItem.collections;
      delete orderItem.articleOptionsListToSelect; // remove unused option list in save request
      delete orderItem.fabrics;
      delete orderItem.totalArticleCustomerPrice;
      delete orderItem.totalArticleDealerPrice;
      delete orderItem.oldProducts;
      delete order.customInvoice;
      delete order.exactOrderNumber;
      orderItem.orderItemOptions.forEach(item => {
        item.option = item.option.id;
        if (item.property) {
          item.property = item.property.id;
        }
        item.product = item.product.id;
        item.propertyAmount = +item.propertyAmount;
        item.productAmount = +item.productAmount;
        // `random` is about to be dropped (the server has no such column), so carry the
        // element it belongs to in a local key first — the nesting below needs it, and it
        // is deleted again before the request goes out.
        if (this.isCarpetOptionRow(orderItem, item)) {
          item.carpetElement = item.random;
        }
        delete item.totalCost;
        delete item.cost;
        delete item.parent;
        delete item.random;
        delete item.position;
        delete item.parentPosition;
        delete item.fabricCollection;
      });
      const orderItemOption = _.orderBy(orderItem.orderItemOptions, ['option', 'product', 'fabric'], ['asc', 'asc', 'asc']);
      // Dedup by (option, product) would collapse two elements that carry the same rug
      // with DIFFERENT carpet options into one row, and the product-id fan-out below
      // would then give both elements that one row. Carpet rows are keyed by element, so
      // they are deduped per element (option, product, element) instead.
      orderItem.orderItemOptions = _.uniqBy(orderItemOption,
        v => JSON.stringify([v.option, v.product, v.carpetElement !== undefined ? v.carpetElement : null]));
      delete orderItem.selectedOptions;
      delete orderItem.summaryOptions;
      orderItem.orderItemProducts.map(item => {
        item.orderItemOptions = _.filter(orderItem.orderItemOptions, (orderItemOption: any) => {
          let hasPackageProduct = false;
          _.find(item.orderItemProductPackages, orderItemProductPackage => {
            hasPackageProduct = orderItemProductPackage.orderItemProductPackageProducts[0].product === orderItemOption.product;
            return hasPackageProduct;
          });
          // a carpet row goes to ITS element only; everything else keeps the existing
          // product-id match, which fans an article-level option out to every element
          if (orderItemOption.carpetElement !== undefined) {
            return orderItemOption.carpetElement === item.random;
          }
          return (orderItemOption.product == item.product) || hasPackageProduct;
        });
        delete item.carpetOptions;
        if (item.perProductOptions && item.perProductOptions.length > 0) {
          item.perProductOptions.forEach(perProductOption => {
            const clonePerProductOption = JSON.parse(JSON.stringify(perProductOption));
            delete clonePerProductOption.optionObj;
            item.orderItemOptions.push(clonePerProductOption);
          });
        }
        delete item.selectedPerProductOption;
        delete item.perProductOptions;
        delete item.perProductOptionObj;
        delete item.allowFabricSide;
        delete item.id;
        delete item.orderItemProductOptions;
        delete item.cost;
        delete item.totalCost;
        delete item.random;
        delete item.productObj;
        delete item.allowFabric;
        delete item.totalArticleProductFabricCustomerPrice;
        delete item.totalArticleProductFabricDealerPrice;
        delete item.orderItemProductFabricCollection.fabrics;
        delete item.orderItemProductFabricCollection.fabricObj;
        delete item.orderItemProductFabricCollection.fabricColorObj;
        delete item.orderItemProductFabricCollection.fabricColors;
        delete item.orderItemProductFabricCollection.fabricsCollections;
        delete item.orderItemProductFabricCollection.fabricCollectionObj;
        delete item.orderItemProductFabricCollection.amount;
        delete item.orderItemProductFabricCollection.totalCost;
        delete item.orderItemProductFabricCollection.cost;
        delete item.stockAmountAlert;
        delete item.summaryOptions;
        // view state only — widthCm/lengthCm are the payload, and the server
        // recomputes the price and revalidates the limits itself (FR-022).
        // THE RULE: OrderItemProductType declares exactly the fields the server accepts, and
        // Symfony rejects the WHOLE order form with "should not contain extra fields" if it
        // is sent anything else -- so no order can be saved at all. Every field the API
        // serves for display only, and every field this screen adds for its own use, has to
        // be removed here. Adding a display field without adding it to this list has now
        // broken saving twice: carpetMaterialPrice (US-605 A3/C1) and then its customer
        // twin, which blocked placing an order from a quote.
        delete item.carpetCost;
        delete item.carpetDescription;
        delete item.carpetMaterialPrice;
        delete item.carpetMaterialCustomerPrice;
        delete item.carpetOptionGroups;
        delete item.orderItemOptionIds;
        delete item.selectedSizeId;
        const orderItemProductFabricCollections = JSON.parse(JSON.stringify(item.orderItemProductFabricCollection));
        item.orderItemProductFabricCollections = [];
        item.orderItemProductFabricCollections.push(orderItemProductFabricCollections);
        delete item.orderItemProductFabricCollection;
        for (let i = 0; i < item.orderItemProductPackages.length; i++) {
          if (item.orderItemProductPackages[i].orderItemProductPackageProducts[0].product === '') {
            item.orderItemProductPackages.splice(i, 1);
          } else if (Helper.isEmpty(item.orderItemProductPackages[i].orderItemProductPackageProducts[0])) {
            item.orderItemProductPackages.splice(i, 1);
          }
        }
        item.orderItemProductPackages.map(orderItemProductPackagesItem => {
          let checkOrderItemProductPackageProduct = false;
          delete orderItemProductPackagesItem.packageObj;
          orderItemProductPackagesItem.orderItemProductPackageProducts.map(orderItemProductPackageProduct => {
            delete orderItemProductPackageProduct.productObj;
            delete orderItemProductPackageProduct.cost;
            delete orderItemProductPackageProduct.totalCost;
            delete orderItemProductPackageProduct.stockAmountAlert;
            if (!orderItemProductPackageProduct.product || orderItemProductPackageProduct.product === null) {
              checkOrderItemProductPackageProduct = true;
            }
          });
          if (checkOrderItemProductPackageProduct) {
            delete orderItemProductPackagesItem.orderItemProductPackageProducts;
          }

        });
      });
      // the element key has done its job (every element's rows are nested by now) and
      // OrderItemOptionType would reject it as an extra field
      orderItem.orderItemProducts.forEach((item: any) =>
        (item.orderItemOptions || []).forEach((orderItemOption: any) => delete orderItemOption.carpetElement));
      delete orderItem.orderItemOptions;
      delete orderItem.selectedSummaryOptions;
    });
    return order;
  }

  submitItem() {
    if (this.isSubmittingOrder) {
      return;
    }
    // The hard gate, restated at the one point every screen submits through. placeOrder(),
    // placeQuote() and saveQuote() open the modal first, so reaching here incomplete means
    // the confirmation modal was opened some other way.
    if (this.needsPosDetails() && !this.isPosRegistrationComplete()) {
      this.helper.popMessageDialog(null, this.translate.instant('validators.pos_registration.incomplete'), 'error', false);
      return;
    }
    this.isSubmittingOrder = true;
    this.disableConfirmBtn = true;
    const order = this.createOrder();
    const orderId = order.id;
    if (order.user && Helper.isDefined(order.user.id)) {
      order.user = order.user.id;
      // delete order.user;
    } else {
      order.user = null;
    }

    if (order.dealerDeliveryAddress && Helper.isDefined(order.dealerDeliveryAddress.id)) {
      order.dealerDeliveryAddress = order.dealerDeliveryAddress.id;
    } else {
      order.dealerDeliveryAddress = null;
    }
    if (this.isEdit || this.isQuote) {
      delete order.id;
      delete order.created;
      delete order.invoiceStatus;
      delete order.isInvoiced;
      delete order.orderNo;
      delete order.status;
      delete order.supplier;
      delete order.customInvoice;
      delete order.exactOrderNumber;
      delete order.packagingLabel;
    }

    if ((this.isEdit || this.isQuote) && order.customRows) {
      order.customRows.map(customRow => {
        delete customRow.totalPrice;
        delete customRow.orderID;
      });
    }

    if (this.auth.isDealer()) {
      delete order.customRows;
    }

    if (this.isQuote && this.isShow) {
      this.correctOrder(order);
    }
    this.checkAction();
    if (this.replyId) {
      order.replyItem = this.replyId;
      order.isService = this.isService;
    }
    this.orderService.manageOrder(order, this.formAction, orderId).pipe(
      finalize(() => {
        this.isSubmittingOrder = false;
        this.disableConfirmBtn = false;
      })
    ).subscribe((resp) => {
      this.orderModal.hide();
      // this.helper.fileLinkDialog('success',resp)
      this.auth.requestUpdatePoints(); // get latest user profile data and update panel dealer points
      if (!this.isQuote && !this.isNewQuote) {
        if (this.auth.isDealer()) {
          this.route.navigateByUrl('/dealer-system/order/' + resp.id + '/success');
        } else {
          if (this.serviceRequestId) {
            this.route.navigateByUrl('/back-office/service/request/' + this.serviceRequestId + '/show');
          } else {
            this.route.navigateByUrl('/back-office/order/overview');
          }
        }
      } else {
        if (this.auth.isDealer()) {
          if (this.formAction === 'place-quote') {
            this.route.navigateByUrl('/dealer-system/order/overview');
          } else {
            this.route.navigateByUrl('/dealer-system/quote/overview');
          }
        } else {
          if (this.formAction === 'new-quote' || this.formAction === 'update-quote') {
            this.route.navigateByUrl('/back-office/quote/overview');
          } else {
            this.route.navigateByUrl('/back-office/order/overview');
          }
        }
      }
    });

  }

  generateOrderPdf() {
    if (this.order.isConverted || this.checkRequiredItems()) {
      const order = this.createOrder();
      delete order.id;
      delete order.orderNo;
      if (order.user && Helper.isDefined(order.user.id)) {
        order.user = order.user.id;
        // delete order.user;
      }
      if (this.isEdit || this.isQuote) {
        delete order.id;
        delete order.created;
        delete order.invoiceStatus;
        delete order.isInvoiced;
        delete order.orderNo;
        delete order.status;
        delete order.supplier;
        delete order.customInvoice;
        delete order.exactOrderNumber;
        delete order.packagingLabel;
      }
      delete order.created;
      delete order.status;
      delete order.supplier;
      delete order.invoices;
      delete order.customInvoice;
      delete order.exactOrderNumber;
      order.dealerDeliveryAddress = null;
      if (order.customRows) {
        order.customRows.map(customRow => {
          delete customRow.totalPrice;
        });
      }
      delete order.invoiceStatus;
      delete order.isInvoiced;
      const kind = (this.customerPrice) ? 'customer' : 'dealer';
     this.generateTempOrder(order, kind, this.order.secondaryDeliveryAt);
    }
  }

  private generateTempOrder(order: any, kind: string, secondaryDeliveryAt: any) {
    this.orderService.generateOrderTemp(
      order,
      kind,
      secondaryDeliveryAt
    ).subscribe((resp) => {
       if (resp && typeof resp === 'object') {
         this.helper.createDownloadLink(resp.url, resp.filename);
      }
    });
  }

  getDealerPrice(event) {
    if (event) {
      this.customerPrice = true;
    } else if (this.auth.isDealer()) {
      this.passwordModal.show();
    } else if (this.auth.isBackOffice()) {
      this.customerPrice = false;
      this.dealerPassword = null;
    }
  }

  public catchError(response) {
    const body: any = response.error;
    this.helper.popMessageDialog(this.translate.instant('auth.password_is_invalid'), this.translate.instant('auth.password_is_invalid'));
    this.priceItemHasError = true;
    this.passwordModalForm.reset();
    return throwError(body.errors);
  }

  /**
   * Check user password after in password modal click on get dealer price
   */
  getCustomerPrice() {
    this.auth.checkPassword(this.dealerPassword).pipe(catchError(res => this.catchError(res))).subscribe(() => {
      this.passwordModal.hide();
      this.customerPrice = false;
      this.dealerPassword = null;
      this.passwordModalForm.reset();

      if (this.tempOrderData) {
        this.generateTempOrder(
          this.tempOrderData.order,
          this.tempOrderData.kind,
          this.tempOrderData.secondaryDeliveryAt
        );
        this.tempOrderData = null;
      }
    });
  }

  checkPasswordError() {
    if (this.priceItemHasError || !Helper.isDefined(this.dealerPassword)
      || (!this.priceItemHasError || Helper.isDefined(this.dealerPassword))) {
      this.priceItem = true;
    }
    this.passwordModal.hide();
  }

  private newOrderItemProduct() {
    const orderItemProduct = new OrderItemProduct;
    orderItemProduct.random = Math.floor((Math.random() * 1000000) + 1);
    orderItemProduct.allowFabric = false;
    return orderItemProduct;
  }

  private newOrderItem() {
    const orderItem = new OrderItem;
    orderItem.collections = Helper.deepCopyArray(this.collections);
    orderItem.random = Math.floor((Math.random() * 1000000) + 1);
    return orderItem;
  }

  onProductChange(i, j, productItem, isAmount = false) {
    this.removeExtraPackageProductOption(i);
    this.formChecked[i] = false;
    this.applyCostOfAllOptionsForAnArticle(i);
    const modelId = this.order.orderItems[i].model;
    const styleId = this.order.orderItems[i].style;
    const productId = productItem.product;
    if (!isAmount) {
      delete this.order.orderItems[i].orderItemProducts[j].allowFabricSide;
      delete this.order.orderItems[i].orderItemProducts[j].perProductOptionObj;
      delete this.order.orderItems[i].orderItemProducts[j].perProductOptions;
      // D24: a real product change, not just the amount stepper. The previous
      // product's dimensions/preset never belonged to the new product's size
      // list, so they must not survive onto it (matches the sofa<->rug switch,
      // which already clears these via newOrderItemProduct()/getPackages()).
      this.order.orderItems[i].orderItemProducts[j].widthCm = null;
      this.order.orderItems[i].orderItemProducts[j].lengthCm = null;
      this.order.orderItems[i].orderItemProducts[j].selectedSizeId = null;
    }
    if (productId) {
      this.optionService.getPerProductOptionByProductModelStyle(productId, modelId, styleId, 'dealer-system').subscribe(res => {
        if (res.length > 0 ) {
          const notDeletedOption = res.find(item => !item.deleted);
          this.order.orderItems[i].orderItemProducts[j].perProductOptionObj = notDeletedOption || undefined;
        }
      });
    }
  }

  // ==========================================================================
  // OPTIONS, PROPERTIES
  // ==========================================================================

  /**
   * Step 1
   * Make a unique list of options for an article based on product options.
   *
   * @param i order item index
   * @param optionProducts product options list
   */
  createOptionsListToSelectForAnArticle(i, optionProducts) {
    const checkItem = Object.assign([], this.order?.orderItems?.[i]?.articleOptionsListToSelect);
    this.order.orderItems[i].articleOptionsListToSelect = _.unionWith(
      this.order?.orderItems?.[i]?.articleOptionsListToSelect,
      optionProducts,
      function (o1, o2) {
        // union optionsProduct by optionID
        return o1?.option?.id === o2?.option?.id && o1?.deleted === o2?.deleted;
      }
    );

    if (!this.isEdit) {
      this.order.orderItems[i].articleOptionsListToSelect = _.filter(this.order.orderItems[i].articleOptionsListToSelect, (optionProductItem) => !optionProductItem.deleted);
    } else {
      this.order.orderItems[i].articleOptionsListToSelect.map((optionProductItem) => {
        if (optionProductItem.deleted) {
          optionProductItem.option.status = false;
        }
      });
    }

    this.order.orderItems[i].articleOptionsListToSelect.forEach((item) => {
      item.lastValues = this.getLastOptions(item, this.order.orderItems[i]);
    });
    this.chooseOptionForAnArticle({
      mainOption: [],
      orderItem: i,
      formIsValid: false,
      show: false
    });
    // if all products have same option we should make shock to options
    if (_.isEqual(checkItem.sort(), this.order.orderItems[i].articleOptionsListToSelect.sort())) {

      this.chooseOptionForAnArticle({
          mainOption: [],
          orderItem: i,
          formIsValid: false,
          show: false
        }
      );
    }
    if (this.order.orderItems[i].articleOptionsListToSelect) {
      this.order.orderItems[i].articleOptionsListToSelect = _.orderBy(this.order.orderItems[i].articleOptionsListToSelect, (aolts) => aolts.option.position, ['asc']);
    }
    // this.changeDetector.detectChanges();
  }

  /**
   * Step 2
   * If a product removed, then update the article options list.
   *
   * @param i order item index
   */
  byRemoveProductUpdateOptionsList(i, productId = null) {
    _.unionBy(
      this.order?.orderItems?.[i]?.orderItemProducts,
      this.order?.orderItems?.[i]?.oldProducts,
      'random'
    ).forEach(product => {
      if (product?.productObj?.id === productId) {
        const modelId = (!this.isShow) ? this.order?.orderItems?.[i]?.model : this.order?.orderItems?.[i]?.model?.['id'];
        let styleId = null;
        if (this.order.orderItems[i].style) {
          styleId = (this.isShow) ? this.order.orderItems[i].style['id'] : this.order.orderItems[i].style;
        }

        /**
         * push all orderitem products to products to compare with last product select
         */
        const products = [];
        this.order.orderItems[i].orderItemProducts.forEach((orderP) => {
          products.push(orderP.product);
        });

        const diff = _.difference(this.order.orderItems[i].oldProducts, products);

        const checkItem = diff.length > 0 ? true : false;
        if (diff.length > 0) {
          diff.forEach((productItem) => {
            new Promise((resolve => {
              // this.removeExtraOption(i, productItem)
              resolve(true);
            })).then(() => {
              /**
               * add new orderItem Products to old products for next compare
               */
              this.order.orderItems[i].oldProducts = products;

              this.optionService.getOptionByProductModelStyle(product.productObj.id, modelId, styleId, 'dealer-system').subscribe(optionsProduct => {
                if (optionsProduct.length < 1) {
                  this.requiredOption = false;
                }
                optionsProduct.forEach((item) => {
                  item.products = [];
                  item.products.push(item.product.id);
                });
                this.order.orderItems[i].articleOptionsListToSelect.forEach((selectOption) => {
                  optionsProduct.forEach((item) => {
                    if (item.option.id === selectOption.option.id) {
                      if ((!this.isEdit && !item.deleted) || this.isEdit) {
                        selectOption.products.push(item.product.id);
                      }
                    }
                  });
                });
                optionsProduct = optionsProduct.filter(item => !item.deleted);
                this.createOptionsListToSelectForAnArticle(i, optionsProduct);
              });
            });
          });
        } else {
          this.order.orderItems[i].oldProducts = products;
          this.optionService.getOptionByProductModelStyle(product.productObj.id, modelId, styleId, 'dealer-system').subscribe(optionsProduct => {
            if (optionsProduct.length < 1) {
              this.requiredOption = false;
            }
            optionsProduct.forEach((item) => {
              item.products = [];
              item.products.push(item.product.id);
            });
            this.order.orderItems[i].articleOptionsListToSelect.forEach((selectOption) => {
              optionsProduct.forEach((item) => {
                if (item.option.id === selectOption.option.id) {
                  if ((!this.isEdit && !item.deleted) || this.isEdit) {
                    selectOption.products.push(item.product.id);
                  }
                  this.byRemoveProductUpdateOptionsList(i);
                }
              });
            });
            if (Helper.isDefined(this.order.orderItems[i].selectedOptions)) {
              this.order.orderItems[i].selectedOptions.map((selectedOption) => {
                const parentArticle = _.find(this.order.orderItems[i].articleOptionsListToSelect, (articleOption) => articleOption.option.id == selectedOption.firstParent);
                selectedOption.products = parentArticle.products;
              });
            }
            optionsProduct = optionsProduct.filter(item => !item.deleted);
            this.createOptionsListToSelectForAnArticle(i, optionsProduct);
          });
        }


        // this.chooseOptionForAnArticle({
        //   mainOption: [],
        //   orderItem: 0,
        //   formIsValid: false,
        //   show: false
        // })
        if (diff.length > 0) {
          diff.forEach((productItem) => {


            if (this.findByProductId(i, productItem)) {
              this.removeExtraOption(i, productItem);
            }
          });

        }


      }
    });

    this.applyCostOfAllOptionsForAnArticle(i);
  }

  setButtonStatus(resp) {
    _.remove(this.checkEnableArray, (cea) => cea.orderItem > this.order.orderItems.length);
    this.order.orderItems.forEach((orderItem, index) => {
      _.remove(this.checkEnableArray, (cea) => {
        const findProduct = _.findIndex(orderItem.orderItemProducts, (op) => op.product == cea.product);
        return cea.orderItem == index && findProduct == -1;
      });
    });
    const checkEnableArray = Object.assign([], this.checkEnableArray);
    const findOption = _.find(checkEnableArray, function (o) {
      return (o.index == resp.index && o.product == resp.product && o.orderItem == resp.orderItem);
    });
    if (!Helper.isDefined(findOption)) {
      this.checkEnableArray.push(resp);
    } else {
      findOption.status = resp.status;
    }
    let status = false;
    this.checkEnableArray.forEach((item) => {
      if (!item.status) {

        status = true;
        return;
      }
    });
    if (status) {
      this.requiredOption = true;
    } else {
      this.requiredOption = false;
    }

  }

  /**
   * Step 3
   * Choose option for an specific article, and unique.
   */
  chooseOptionForAnArticle(values) {

    if (!Helper.isDefined(this.order.orderItems[values.orderItem].selectedOptions)) {
      this.order.orderItems[values.orderItem].selectedOptions = [];
    }
    if (!values.show) {
      for (const index in this.order.orderItems[values.orderItem].selectedOptions) {
        if (this.order.orderItems[values.orderItem].selectedOptions[index].firstParent === values.firstParent) {
          const sel11 = Object.assign([], this.order.orderItems[values.orderItem].selectedOptions[index]);
          delete this.order.orderItems[values.orderItem].selectedOptions[index];
        }
      }
      this.order.orderItems[values.orderItem].selectedOptions = this.order.orderItems[values.orderItem].selectedOptions.filter(function () {
        return true;
      });
      this.order.orderItems[values.orderItem].selectedOptions = _.orderBy(this.order.orderItems[values.orderItem].selectedOptions, ['parent'], ['asc']);
    }

    const selectedOptionsse = Object.assign([], this.order.orderItems[values.orderItem].selectedOptions);
    // Kept so a POS selection on a product with no POS value can be rolled back - see
    // rejectPosSelectionWithoutValue() at the end of this method.
    const selectedOptionsBeforeChange = JSON.parse(JSON.stringify(this.order.orderItems[values.orderItem].selectedOptions));
    // if(!item.show){
    //   item.mainOption.children.forEach((option)=>{
    //     if(option.id != item.mainOption.optionSelectd){
    //       for( let index in this.order.orderItems[item.orderItem].selectedOptions){
    //         if(this.order.orderItems[item.orderItem].selectedOptions[index].parent==option.id){
    //          // this.order.orderItems[item.orderItem].selectedOptions.splice(parseInt(index),1);
    //         }
    //       }
    //     }
    //
    //   })
    // }
    // this.order.orderItems[item.orderItem].orderItemProducts.forEach((orderItemProduct)=>{
    //   for( let index in this.order.orderItems[item.orderItem].selectedOptions){
    //     if(this.order.orderItems[item.orderItem].selectedOptions[index].products.indexOf(orderItemProduct.product)==-1){
    //
    //
    //
    //     // this.order.orderItems[item.orderItem].selectedOptions.splice(parseInt(index),1);
    //     }
    //   }
    // })

    values.mainOption.forEach((optLevel1) => {
      //
      optLevel1.forEach((optLevel2) => {
        if (!optLevel2.hasOwnProperty('AsFabric') && !optLevel2.hasOwnProperty('AsFabricColor')) {
          this.order.orderItems[values.orderItem].selectedOptions.push(optLevel2);
          this.order.orderItems[values.orderItem].selectedOptions = _.unionBy(
            this.order.orderItems[values.orderItem].selectedOptions);
        }
      });
    });
    // TODO: for every change we should call  applyCostOfAllOptionsForAnArticle() method
    this.applyCostOfAllOptionsForAnArticle(values.orderItem);
    this.rejectPosSelectionWithoutValue(values.orderItem, selectedOptionsBeforeChange);
  }

  /**
   * A POS option on a product that carries no POS seating-units value must be refused,
   * not priced.
   *
   * Left alone, such a selection does not fail loudly: the calculation falls through to
   * the branch that defaults propertyAmount to 1, and a product whose value is stored as
   * 0.00 prices the insurance at EUR 0. Either way the dealer buys cover that the insurer
   * was never told the size of. Eight live products already carry 0.00 on the equivalent
   * property, and the POS options are assigned per collection, so this will happen.
   *
   * Runs after the recompute rather than on the raw selection, because orderItemOptions is
   * where the option, the product and the resolved multiplier value finally sit together.
   * The check mirrors the server-side error from US-607.
   */
  private rejectPosSelectionWithoutValue(orderItemIndex: number, previousSelection: any[]) {
    const offender = this.order.orderItems[orderItemIndex].orderItemOptions.find(orderItemOption =>
      orderItemOption.option && orderItemOption.option.requiresCustomerDetails
      && !this.productCarriesPosValue(orderItemOption));
    if (!offender) {
      return;
    }
    this.order.orderItems[orderItemIndex].selectedOptions = previousSelection;
    this.applyCostOfAllOptionsForAnArticle(orderItemIndex);
    // A package line stores its product as an id, so fall back to the option's own name
    // rather than printing "[object Object]" or a bare number at the dealer.
    const product: any = offender.product;
    this.helper.popMessageDialog(
      null,
      // The server owns this message (validators.option.missing_pos_value, US-607) so both
      // sides say the same thing. Its placeholder is Symfony's %product%, which ngx-translate
      // does not interpolate - hence the literal substitution.
      this.translate.instant('validators.option.missing_pos_value')
        .replace('%product%', (product && product.name) || offender.option.name),
      'error',
      false
    );
  }

  /**
   * Does any element on this order carry a POS option that needs the end customer's
   * details?
   *
   * It reads a flag on the selected option (set by US-607), not the collection flag the
   * delivery modal uses: Collection.endCustomerDelivery is the Bruuts direct-to-consumer
   * flag, it lives on one single collection, and POS is chosen per element rather than per
   * collection. Switching on it would also turn insured sofa orders into direct-to-consumer
   * deliveries.
   */
  private needsPosDetails(): boolean {
    // Not at quotation stage. POS is selectable on a quotation and the selection carries over
    // on conversion, but the end customer's details are only demanded when a real order is
    // submitted - placeQuote() sets quoteToOrder, which is exactly that moment. The server
    // draws the same line: PosRegistrationCompletionGuard runs from the order-creation and
    // quote-placement paths, never from quote creation itself.
    //
    // isQuote alone is not enough: it is a URL fact (the /quote routes), and a NEW quotation
    // is saved from the order screen via saveQuote(), where the URL still says /order. That
    // is the same condition the confirmation modal already uses to call itself a quotation,
    // so the modal's wording and this gate can no longer disagree.
    if ((this.isQuote || this.isNewQuote) && !this.quoteToOrder) {
      return false;
    }
    return this.order.orderItems.some(orderItem =>
      orderItem.orderItemProducts.some(orderItemProduct =>
        (orderItemProduct.summaryOptions || []).some(summaryOption => summaryOption.requiresCustomerDetails)));
  }

  // US-685: the POS country dropdown offered a hardcoded "Nederlands"; it now lists the ISO codes
  // and the template translates each one.
  public readonly posCountries: PosCountryCode[] = Object.values(PosRegistration.COUNTRIES);

  /**
   * The POS modal's field formats. Bound into the template AND checked in the submit
   * backstop, so the modal's Confirm button and the backstop can never disagree.
   *
   * These are transcriptions of the server's own constraints on PosRegistration (US-607) -
   * Assert\Regex on phoneNumber and zipCode, Assert\Email in html5 mode - not a
   * frontend-flavoured approximation of them. The server rejects the whole order submission
   * when one fails, so anything this modal accepts and the server does not is a dealer
   * filling in eight fields, clicking Place order, and being bounced with a server error.
   *
   * The telephone is deliberately digits-only with an optional leading +: a dealer typing
   * "+31 6 1234 5678" is rejected here, in the field, rather than at submit. The postcode is
   * country-agnostic on purpose, because the insurer's dealer base spans at least Dutch
   * ("6701 CX") and Belgian ("2000") shapes - both appear in the sample export.
   *
   * Keep these three in step with PosRegistration's attributes. They are one rule with two
   * implementations, the same arrangement (and the same hazard) as the carpet price.
   */
  public readonly posPatterns = {
    // Symfony's Assert\Email html5 pattern, verbatim.
    email: /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/,
    zipCode: /^[A-Za-z0-9]{2,5}(?:[ -][A-Za-z0-9]{2,5})?$/,
    phoneNumber: /^\+?[0-9]{7,15}$/,
  };

  /**
   * Whether the product on this line genuinely carries a value for the option's multiplier
   * property - the question D2 turns on.
   *
   * It has to be asked of the PRODUCT rather than of the computed line, because every property
   * on the collection is seeded with a placeholder amount of 1.0 before the product's own
   * values are merged in (see the `defaulted` flag). A product with no POS value therefore
   * arrives here looking exactly like a product worth one unit, and the line reads
   * property = set, propertyAmount = 1 - which is why an earlier form of this check passed it
   * through and quietly charged for a unit the insurer never agreed to. The ticket's "silently
   * prices at EUR 0" is the same defect with a different number in front of it.
   *
   * Keyed off the option's own multiplier, never a hardcoded id, and it also refuses a POS
   * option carrying no multiplier at all - that is a misconfigured option, and pricing it
   * would be the same silent mistake.
   */
  private productCarriesPosValue(orderItemOption): boolean {
    const multiplier = orderItemOption.option && orderItemOption.option.priceMultiplier;
    if (!multiplier) {
      return false;
    }
    const productProperty = ((orderItemOption.product && orderItemOption.product.productProperties) || [])
      .find(candidate => candidate.property && candidate.property.id === multiplier.id);
    return !!productProperty && productProperty.defaulted !== true && +productProperty.amount > 0;
  }

  /**
   * All eight insurer fields present and, for the three that have a format, valid - the same
   * two things the server checks before it will accept the order (PosRegistration::isComplete
   * plus the constraints transcribed into posPatterns above).
   */
  public isPosRegistrationComplete(): boolean {
    const registration = this.order.posRegistration;
    if (!registration) {
      return false;
    }
    const present = ['fullName', 'phoneNumber', 'email', 'street', 'houseNumber', 'zipCode', 'city', 'country']
      .every(field => !!registration[field] && String(registration[field]).trim() !== '');
    // US-685: any non-empty country used to count as complete. A dealer account must now pick one of
    // NL/BE/DE; customer accounts still type free text.
    const countryValid = !!this.order.user?.isCustomerAccount
      || PosRegistration.isCountry(String(registration.country).trim());
    return present
      && countryValid
      && this.posPatterns.email.test(String(registration.email).trim())
      && this.posPatterns.zipCode.test(String(registration.zipCode).trim())
      && this.posPatterns.phoneNumber.test(String(registration.phoneNumber).trim());
  }

  /**
   * The hard gate (D4): an insured order may not be submitted until its registration is
   * complete. Returns true when the caller may carry on; otherwise it opens the POS modal
   * and re-runs the caller once the dealer confirms.
   *
   * Every create/edit route - order add, order edit, quote add, quote edit and the
   * service-request re-order - reaches submit through this component, so this one method
   * covers all eight screens. Should PM-5 settle on the soft gate instead, this is the only
   * place that changes.
   */
  private requirePosDetails(next: () => void): boolean {
    if (!this.needsPosDetails() || this.isPosRegistrationComplete()) {
      return true;
    }
    const registration = this.order.posRegistration;
    if (registration && !this.order.user?.isCustomerAccount) {
      // US-685: nothing was pre-selected before. Dealer accounts now default to NL, and a stored value
      // that is not one of the codes is cleared, otherwise ng-select shows it as if it were chosen
      // and the dealer would never be asked to pick again.
      if (!registration.country) {
        registration.country = PosRegistration.COUNTRIES.NL;
      } else if (!PosRegistration.isCountry(registration.country)) {
        registration.country = null;
      }
    }
    this.afterPosDetails = next;
    this.posDetailsModal.show();
    return false;
  }

  public confirmPosDetails() {
    this.posDetailsModal.hide();
    const next = this.afterPosDetails;
    this.afterPosDetails = null;
    if (next) {
      next();
    }
  }

  /**
   * Step 4
   * Calculating product by product, options by options.
   */
  applyCostOfAllOptionsForAnArticle(i) {
    const productCopy = [];
    this.order.orderItems[i].orderItemProducts.forEach((productItem) => {
      productCopy.push(productItem.product);
    });
    if (!this.currentOrderItemOptions[i]) {
      this.currentOrderItemOptions[i] = JSON.parse(JSON.stringify(this.order.orderItems[i].orderItemOptions));
    }
    // this.order.orderItems[i].articleOptionsListToSelect.forEach((article,index)=>{
    //   let find=false;
    //
    //   productCopy.forEach((item)=>{
    //     if(article.products.indexOf(item)>-1){
    //       find =true;
    //     }
    //   })
    //
    //   if(!find){
    //     this.order.orderItems[i].articleOptionsListToSelect.splice(index,1);
    //   }
    // })
    // 4.1 iterate all chosen options
    if (Helper.isDefined(this.order.orderItems[i])) {
      this.order.orderItems[i].orderItemOptions = [];
      if (this.order?.orderItems?.[i]?.selectedOptions) {
        this.order.orderItems[i].selectedOptions.forEach(option => {
          const parentItem = _.find(this.order?.orderItems?.[i]?.articleOptionsListToSelect, (article) => article?.option?.id === option?.firstParent);
          let selectProducts = [];
          if (Helper.isDefined(parentItem)) {
            selectProducts = parentItem.products;
          } else {
            selectProducts = option.products;
          }

          // 4.2 get the selected option
          let selectedOptionObj = _.find(option.option.options, function (o) {
            return o.id === option.optionSelected;
          });

          if (option.AsFabricCollection) {
            selectedOptionObj = option.option;
          }

          // 4.3 iterate products to matching option and properties of product
          this.order.orderItems[i].orderItemProducts.forEach(product => {
            if (product.productObj) {
              /**
               * We need to check 3 things here
               *  1. First of all, Does this product have any options?
               *  2. Does this product have the relation with the selected option?
               *  3. Does the selected option have relation with one of the product properties?
               *  4. Are their ids the same?
               */
              // 1
              product.productObj.optionProducts = _.filter(product.productObj.optionProducts, (optionProduct) => {
                if (optionProduct.style !== null) {
                  return optionProduct.style.id === this.order.orderItems[i].style;
                }
                return true;
              });
              if (product.productObj.optionProducts) {
                if (Helper.isDefined(selectedOptionObj)) {

                  // 3,4
                  product.productObj.productProperties = this.calculateProductPropertiesAmount(i, product.productObj.productProperties);
                  const findedPropery = _.find(product.productObj.productProperties, (property) => selectedOptionObj.priceMultiplier && property.property.id === selectedOptionObj.priceMultiplier.id);
                  if (Helper.isDefined(findedPropery)) {
                    const currentOrderItemOption = _.find(this.currentOrderItemOptions[i], (orderItemOption) => orderItemOption.property && orderItemOption.property.id === findedPropery.property.id
                        && orderItemOption.product.id === product.productObj.id
                        && orderItemOption.urbanOption && orderItemOption.urbanOption.id === selectedOptionObj.id);
                    // TODO: check if the product also has the option
                    // we checked the product.property && option.property
                    /**
                     * This property of the product can be calculated, because we have an option for it.
                     * Here is an simple example of the calculation for 1 product.
                     */
                    if (selectProducts && selectProducts.indexOf(product.product) > -1) {

                      /**
                       * Adding new option to the list of options for an article
                       * So we know what options we want for this article
                       * And the cost of this option for all products
                       */
                      const orderItemOption = new OrderItemOption();
                      orderItemOption.option = selectedOptionObj;
                      orderItemOption.property = findedPropery.property;
                      orderItemOption.propertyAmount = currentOrderItemOption && this.isShow ? currentOrderItemOption.propertyAmount : findedPropery.amount;
                      orderItemOption.product = product.productObj;
                      orderItemOption.productAmount = product.amount;
                      orderItemOption.fabric = option.fabric;
                      orderItemOption.random = product.random;
                      orderItemOption.fabricCollection = option.fabricCollection;
                      orderItemOption.fabricColor = option.fabricColor;
                      orderItemOption.firstParent = option.firstParent;
                      orderItemOption.position = parentItem.option.position;
                      orderItemOption.parentPosition = option.option.parentPosition;
                      orderItemOption.parent = option.parent;
                      /**
                       * Calculating cost base on customer and dealer price
                       * Option cost for this product = (option_price * property_amount * product_amount) + vat
                       * TODO: we can use OptionCost.ts, not totalCost.
                       */
                      const totalCost = new TotalCost();
                      const cost = new ProductCost();

                      totalCost.totalCustomerPrice = Helper.bcMul(selectedOptionObj.customerPrice, orderItemOption.propertyAmount, product.amount);
                      totalCost.totalDealerPrice = Helper.bcMul(selectedOptionObj.dealerPrice, orderItemOption.propertyAmount, product.amount);
                      totalCost.totalCustomerCost = totalCost.totalCustomerPrice;
                      totalCost.totalDealerCost = totalCost.totalDealerPrice;

                      cost.customerPrice = orderItemOption.option.customerPrice ? orderItemOption.option.customerPrice : 0;
                      cost.dealerPrice = orderItemOption.option.dealerPrice ? orderItemOption.option.dealerPrice : 0;

                      const parentOption = _.find(this.order.orderItems[i].orderItemOptions, (oIOption) => oIOption.option.id === orderItemOption.parent && orderItemOption.product.id === oIOption.product.id);
                      if (parentOption !== undefined && parentOption.option.type === Option.OPTION_TYPE_OPTION) {
                        totalCost.totalCustomerPrice = Helper.bcAdd(totalCost.totalCustomerPrice, parentOption.totalCost.totalCustomerPrice);
                        totalCost.totalDealerPrice = Helper.bcAdd(totalCost.totalDealerPrice, parentOption.totalCost.totalDealerPrice);
                        totalCost.totalCustomerCost = totalCost.totalCustomerPrice;
                        totalCost.totalDealerCost = totalCost.totalDealerPrice;
                        cost.customerPrice = Helper.bcAdd(cost.customerPrice, parentOption.option.customerPrice);
                        cost.dealerPrice = Helper.bcAdd(cost.dealerPrice, parentOption.option.dealerPrice);
                      }

                      // POS insurance (docs/002-pos-insurance/): this is where a POS option's
                      // insured seating units are produced - propertyAmount x productAmount, and
                      // deliberately NOT rounded. The insurer applies the "2 chairs = 1 unit,
                      // always round up" rule on their own side, so our figure must stay the
                      // actual value: three dining chairs at 0.5 are 1.5 units, not 2. Adding a
                      // ceiling here would also inflate fabric metres and transport cost, which
                      // share this exact multiplier path. Mirrors OrderService::structOrderItemOptions().
                      cost.amount = Helper.bcMul(orderItemOption.propertyAmount, orderItemOption.productAmount);

                      totalCost.totalDealerVAT = Helper.percentageOf(totalCost.totalDealerPrice, this.dealerVAT);
                      totalCost.totalDealerCost = totalCost.totalDealerPrice + totalCost.totalDealerVAT;

                      orderItemOption.totalCost = totalCost;
                      orderItemOption.cost = cost;
                      this.order.orderItems[i].orderItemOptions.push(orderItemOption);
                    }
                  } else {
                    const currentOrderItemOption = _.find(this.currentOrderItemOptions[i], (orderItemOption) => orderItemOption.product.id === product.productObj.id
                        && orderItemOption.urbanOption && orderItemOption.urbanOption.id === selectedOptionObj.id);
                    if (selectProducts && selectProducts.indexOf(product.product) > -1) {
                      const findItem = _.findIndex(this.order.orderItems[i].orderItemOptions, (item) => item.option.id === selectedOptionObj.id && item.firstParent == option.firstParent && item.product.id == product.product);
                      if (findItem > -1 && option.AsFabricCollection) {
                        const orderItemOption = new OrderItemOption();
                        orderItemOption.option = selectedOptionObj;
                        orderItemOption.propertyAmount = currentOrderItemOption && this.isShow ? currentOrderItemOption.propertyAmount : 1;
                        orderItemOption.product = product.productObj;
                        orderItemOption.productAmount = product.amount;
                        orderItemOption.fabricCollection = option.fabricCollection;
                        orderItemOption.random = product.random;
                        orderItemOption.fabric = option.fabric;
                        orderItemOption.fabricColor = option.fabricColor;
                        orderItemOption.firstParent = option.firstParent;
                        orderItemOption.position = parentItem.option.position;
                        orderItemOption.parentPosition = option.option.parentPosition;
                        /**
                         * Calculating cost base on customer and dealer price
                         * Option cost for this product = (option_price * property_amount * product_amount) + vat
                         * TODO: we can use OptionCost.ts, not totalCost.
                         */
                        const totalCost = new TotalCost();
                        const cost = new ProductCost();
                        totalCost.totalCustomerPrice = Helper.bcMul(selectedOptionObj.customerPrice, orderItemOption.propertyAmount, product.amount);
                        totalCost.totalDealerPrice = Helper.bcMul(selectedOptionObj.dealerPrice, orderItemOption.propertyAmount, product.amount);
                        totalCost.totalCustomerCost = totalCost.totalCustomerPrice;
                        totalCost.totalDealerCost = totalCost.totalDealerPrice;
                        cost.customerPrice = orderItemOption.option.customerPrice ? orderItemOption.option.customerPrice : 0;
                        cost.dealerPrice = orderItemOption.option.dealerPrice ? orderItemOption.option.dealerPrice : 0;

                        const parentOption = _.find(this.order.orderItems[i].orderItemOptions, (oIOption) => oIOption.option.id === orderItemOption.parent && orderItemOption.product.id === oIOption.product.id);
                        if (parentOption !== undefined && parentOption.option.type === Option.OPTION_TYPE_OPTION) {
                          totalCost.totalCustomerPrice = Helper.bcAdd(totalCost.totalCustomerPrice, parentOption.totalCost.totalCustomerPrice);
                          totalCost.totalDealerPrice = Helper.bcAdd(totalCost.totalDealerPrice, parentOption.totalCost.totalDealerPrice);
                          totalCost.totalCustomerCost = totalCost.totalCustomerPrice;
                          totalCost.totalDealerCost = totalCost.totalDealerPrice;
                          orderItemOption.propertyAmount = parentOption.propertyAmount;
                          cost.customerPrice = Helper.bcAdd(cost.customerPrice, parentOption.option.customerPrice);
                          cost.dealerPrice = Helper.bcAdd(cost.dealerPrice, parentOption.option.dealerPrice);
                        }
                        cost.amount = Helper.bcMul(orderItemOption.propertyAmount, orderItemOption.productAmount);

                        totalCost.totalDealerVAT = Helper.percentageOf(totalCost.totalDealerPrice, this.dealerVAT);
                        totalCost.totalDealerCost = totalCost.totalDealerPrice + totalCost.totalDealerVAT;

                        orderItemOption.totalCost = totalCost;
                        orderItemOption.cost = cost;
                        this.order.orderItems[i].orderItemOptions.push(orderItemOption);
                      } else {
                        /**
                         * Adding new option to the list of options for an article
                         * So we know what options we want for this article
                         * And the cost of this option for all products
                         */
                        const orderItemOption = new OrderItemOption();
                        orderItemOption.option = selectedOptionObj;
                        orderItemOption.propertyAmount = currentOrderItemOption && this.isShow ? currentOrderItemOption.propertyAmount : 1;
                        orderItemOption.product = product.productObj;
                        orderItemOption.productAmount = product.amount;
                        orderItemOption.fabric = option.fabric;
                        orderItemOption.random = product.random;
                        orderItemOption.fabricCollection = option.fabricCollection;
                        orderItemOption.fabricColor = option.fabricColor;
                        orderItemOption.firstParent = option.firstParent;
                        orderItemOption.position = parentItem.option.position;
                        orderItemOption.parentPosition = option.option.parentPosition;
                        orderItemOption.parent = option.parent;
                        /**
                         * Calculating cost base on customer and dealer price
                         * Option cost for this product = (option_price * property_amount * product_amount) + vat
                         * TODO: we can use OptionCost.ts, not totalCost.
                         */
                        const totalCost = new TotalCost();
                        const cost = new ProductCost();
                        totalCost.totalCustomerPrice = Helper.bcMul(selectedOptionObj.customerPrice, orderItemOption.propertyAmount, product.amount);
                        totalCost.totalDealerPrice = Helper.bcMul(selectedOptionObj.dealerPrice, orderItemOption.propertyAmount, product.amount);
                        totalCost.totalCustomerCost = totalCost.totalCustomerPrice;
                        totalCost.totalDealerCost = totalCost.totalDealerPrice;
                        cost.customerPrice = orderItemOption.option.customerPrice ? orderItemOption.option.customerPrice : 0;
                        cost.dealerPrice = orderItemOption.option.dealerPrice ? orderItemOption.option.dealerPrice : 0;

                        const parentOption = _.find(this.order.orderItems[i].orderItemOptions, (oIOption) => oIOption.option.id === orderItemOption.parent && orderItemOption.product.id === oIOption.product.id && oIOption.productAmount === orderItemOption.productAmount);

                        if (parentOption !== undefined && parentOption.option.type === Option.OPTION_TYPE_OPTION) {
                          totalCost.totalCustomerPrice = Helper.bcAdd(totalCost.totalCustomerPrice, parentOption.totalCost.totalCustomerPrice);
                          totalCost.totalDealerPrice = Helper.bcAdd(totalCost.totalDealerPrice, parentOption.totalCost.totalDealerPrice);
                          totalCost.totalCustomerCost = totalCost.totalCustomerPrice;
                          totalCost.totalDealerCost = totalCost.totalDealerPrice;
                          cost.customerPrice = Helper.bcAdd(cost.customerPrice, parentOption.option.customerPrice);
                          cost.dealerPrice = Helper.bcAdd(cost.dealerPrice, parentOption.option.dealerPrice);
                          orderItemOption.propertyAmount = parentOption.propertyAmount;
                        }
                        cost.amount = Helper.bcMul(orderItemOption.propertyAmount, orderItemOption.productAmount);

                        totalCost.totalDealerVAT = Helper.percentageOf(totalCost.totalDealerPrice, this.dealerVAT);
                        totalCost.totalDealerCost = totalCost.totalDealerPrice + totalCost.totalDealerVAT;

                        orderItemOption.totalCost = totalCost;
                        orderItemOption.cost = cost;
                        this.order.orderItems[i].orderItemOptions.push(orderItemOption);
                      }
                    }
                  }
                }
              }
            }

            // Do the same for package products
            product.orderItemProductPackages && product.orderItemProductPackages.forEach(pkg => {
              const packageProduct = pkg.orderItemProductPackageProducts[0];
              if (packageProduct.productObj) {
                /**
                 * We need to check 3 things here
                 *  1. First of all, Does this product have any options?
                 *  2. Does this product have the relation with the selected option?
                 *  3. Does the selected option have relation with one of the product properties?
                 *  4. Are their ids the same?
                 */
                // 1
                packageProduct.productObj.optionProducts = _.filter(packageProduct.productObj.optionProducts, (optionProduct) => {
                  if (optionProduct.style !== null) {
                    return optionProduct.style.id === this.order.orderItems[i].style;
                  }
                  return true;
                });
                if (packageProduct.productObj.optionProducts) {
                  if (Helper.isDefined(selectedOptionObj)) {

                    // 3,4
                    packageProduct.productObj.productProperties = this.calculateProductPropertiesAmount(i, packageProduct.productObj.productProperties);
                    const findedPropery = _.find(packageProduct.productObj.productProperties, (property) => selectedOptionObj.priceMultiplier && property.property.id === selectedOptionObj.priceMultiplier.id);
                    if (Helper.isDefined(findedPropery)) {
                      const currentOrderItemOption = _.find(this.currentOrderItemOptions[i], (orderItemOption) => orderItemOption.property && orderItemOption.property.id === findedPropery.property.id
                          && orderItemOption.product.id === packageProduct.productObj.id
                          && orderItemOption.urbanOption && orderItemOption.urbanOption.id === selectedOptionObj.id);
                      // TODO: check if the product also has the option
                      // we checked the product.property && option.property
                      /**
                       * This property of the product can be calculated, because we have an option for it.
                       * Here is an simple example of the calculation for 1 product.
                       */
                      if (selectProducts && selectProducts.indexOf(packageProduct.product) > -1) {

                        /**
                         * Adding new option to the list of options for an article
                         * So we know what options we want for this article
                         * And the cost of this option for all products
                         */
                        const orderItemOption = new OrderItemOption();
                        orderItemOption.option = selectedOptionObj;
                        orderItemOption.property = findedPropery.property;
                        orderItemOption.propertyAmount = currentOrderItemOption && this.isShow ? currentOrderItemOption.propertyAmount : findedPropery.amount;
                        orderItemOption.product = packageProduct.productObj.product;
                        orderItemOption.productAmount = packageProduct.productObj.amount;
                        orderItemOption.random = null;
                        orderItemOption.fabric = option.fabric;
                        orderItemOption.fabricCollection = option.fabricCollection;
                        orderItemOption.fabricColor = option.fabricColor;
                        orderItemOption.firstParent = option.firstParent;
                        orderItemOption.position = parentItem.option.position;
                        orderItemOption.parentPosition = option.option.parentPosition;
                        orderItemOption.parent = option.parent;


                        /**
                         * Calculating cost base on customer and dealer price
                         * Option cost for this product = (option_price * property_amount * product_amount) + vat
                         * TODO: we can use OptionCost.ts, not totalCost.
                         */
                        const totalCost = new TotalCost();
                        const cost = new ProductCost();

                        totalCost.totalCustomerPrice = Helper.bcMul(selectedOptionObj.customerPrice, orderItemOption.propertyAmount, packageProduct.productObj.amount);
                        totalCost.totalDealerPrice = Helper.bcMul(selectedOptionObj.dealerPrice, orderItemOption.propertyAmount, packageProduct.productObj.amount);
                        totalCost.totalCustomerCost = totalCost.totalCustomerPrice;
                        totalCost.totalDealerCost = totalCost.totalDealerPrice;

                        cost.customerPrice = orderItemOption.option.customerPrice ? orderItemOption.option.customerPrice : 0;
                        cost.dealerPrice = orderItemOption.option.dealerPrice ? orderItemOption.option.dealerPrice : 0;

                        const parentOption = _.find(this.order.orderItems[i].orderItemOptions, (oIOption) => oIOption.option.id === orderItemOption.parent && orderItemOption.product.id === oIOption.product.id);
                        if (parentOption !== undefined && parentOption.option.type === Option.OPTION_TYPE_OPTION) {
                          totalCost.totalCustomerPrice = Helper.bcAdd(totalCost.totalCustomerPrice, parentOption.totalCost.totalCustomerPrice);
                          totalCost.totalDealerPrice = Helper.bcAdd(totalCost.totalDealerPrice, parentOption.totalCost.totalDealerPrice);
                          totalCost.totalCustomerCost = totalCost.totalCustomerPrice;
                          totalCost.totalDealerCost = totalCost.totalDealerPrice;
                          cost.customerPrice = Helper.bcAdd(cost.customerPrice, parentOption.option.customerPrice);
                          cost.dealerPrice = Helper.bcAdd(cost.dealerPrice, parentOption.option.dealerPrice);
                        }

                        cost.amount = Helper.bcMul(orderItemOption.propertyAmount, orderItemOption.productAmount);

                        totalCost.totalDealerVAT = Helper.percentageOf(totalCost.totalDealerPrice, this.dealerVAT);
                        totalCost.totalDealerCost = totalCost.totalDealerPrice + totalCost.totalDealerVAT;

                        orderItemOption.totalCost = totalCost;
                        orderItemOption.cost = cost;
                        this.order.orderItems[i].orderItemOptions.push(orderItemOption);
                      }
                    } else {
                      const currentOrderItemOption = _.find(this.currentOrderItemOptions[i], (orderItemOption) => orderItemOption.product.id === packageProduct.productObj.id
                          && orderItemOption.urbanOption && orderItemOption.urbanOption.id === selectedOptionObj.id);
                      if (selectProducts && selectProducts.indexOf(packageProduct.product) > -1) {
                        const findItem = _.findIndex(this.order.orderItems[i].orderItemOptions, (item) => item.option.id === selectedOptionObj.id && item.firstParent == option.firstParent && item.product.id == packageProduct.product);
                        if (findItem > -1 && option.AsFabricCollection) {
                          const orderItemOption = new OrderItemOption();
                          orderItemOption.option = selectedOptionObj;
                          orderItemOption.propertyAmount = currentOrderItemOption && this.isShow ? currentOrderItemOption.propertyAmount : 1;
                          orderItemOption.product = packageProduct.productObj.product;
                          orderItemOption.productAmount = product.amount;
                          orderItemOption.fabricCollection = option.fabricCollection;
                          orderItemOption.random = null;
                          orderItemOption.fabric = option.fabric;
                          orderItemOption.fabricColor = option.fabricColor;
                          orderItemOption.firstParent = option.firstParent;
                          orderItemOption.position = parentItem.option.position;
                          orderItemOption.parentPosition = option.option.parentPosition;
                          /**
                           * Calculating cost base on customer and dealer price
                           * Option cost for this product = (option_price * property_amount * product_amount) + vat
                           * TODO: we can use OptionCost.ts, not totalCost.
                           */
                          const totalCost = new TotalCost();
                          const cost = new ProductCost();
                          totalCost.totalCustomerPrice = Helper.bcMul(selectedOptionObj.customerPrice, orderItemOption.propertyAmount, packageProduct.productObj.amount);
                          totalCost.totalDealerPrice = Helper.bcMul(selectedOptionObj.dealerPrice, orderItemOption.propertyAmount, packageProduct.productObj.amount);
                          totalCost.totalCustomerCost = totalCost.totalCustomerPrice;
                          totalCost.totalDealerCost = totalCost.totalDealerPrice;
                          cost.customerPrice = orderItemOption.option.customerPrice ? orderItemOption.option.customerPrice : 0;
                          cost.dealerPrice = orderItemOption.option.dealerPrice ? orderItemOption.option.dealerPrice : 0;

                          const parentOption = _.find(this.order.orderItems[i].orderItemOptions, (oIOption) => oIOption.option.id === orderItemOption.parent && orderItemOption.product.id === oIOption.product.id);
                          if (parentOption !== undefined && parentOption.option.type === Option.OPTION_TYPE_OPTION) {
                            totalCost.totalCustomerPrice = Helper.bcAdd(totalCost.totalCustomerPrice, parentOption.totalCost.totalCustomerPrice);
                            totalCost.totalDealerPrice = Helper.bcAdd(totalCost.totalDealerPrice, parentOption.totalCost.totalDealerPrice);
                            totalCost.totalCustomerCost = totalCost.totalCustomerPrice;
                            totalCost.totalDealerCost = totalCost.totalDealerPrice;
                            orderItemOption.propertyAmount = parentOption.propertyAmount;
                            cost.customerPrice = Helper.bcAdd(cost.customerPrice, parentOption.option.customerPrice);
                            cost.dealerPrice = Helper.bcAdd(cost.dealerPrice, parentOption.option.dealerPrice);
                          }
                          cost.amount = Helper.bcMul(orderItemOption.propertyAmount, orderItemOption.productAmount);

                          totalCost.totalDealerVAT = Helper.percentageOf(totalCost.totalDealerPrice, this.dealerVAT);
                          totalCost.totalDealerCost = totalCost.totalDealerPrice + totalCost.totalDealerVAT;

                          orderItemOption.totalCost = totalCost;
                          orderItemOption.cost = cost;
                          this.order.orderItems[i].orderItemOptions.push(orderItemOption);
                        } else {
                          /**
                           * Adding new option to the list of options for an article
                           * So we know what options we want for this article
                           * And the cost of this option for all products
                           */
                          const orderItemOption = new OrderItemOption();
                          orderItemOption.option = selectedOptionObj;
                          orderItemOption.propertyAmount = currentOrderItemOption && this.isShow ? currentOrderItemOption.propertyAmount : 1;
                          orderItemOption.product = packageProduct.productObj.product;
                          orderItemOption.productAmount = packageProduct.productObj.amount;
                          orderItemOption.fabric = option.fabric;
                          orderItemOption.random = null;
                          orderItemOption.fabricCollection = option.fabricCollection;
                          orderItemOption.fabricColor = option.fabricColor;
                          orderItemOption.firstParent = option.firstParent;
                          orderItemOption.position = parentItem.option.position;
                          orderItemOption.parentPosition = option.option.parentPosition;
                          orderItemOption.parent = option.parent;
                          /**
                           * Calculating cost base on customer and dealer price
                           * Option cost for this product = (option_price * property_amount * product_amount) + vat
                           * TODO: we can use OptionCost.ts, not totalCost.
                           */
                          const totalCost = new TotalCost();
                          const cost = new ProductCost();
                          totalCost.totalCustomerPrice = Helper.bcMul(selectedOptionObj.customerPrice, orderItemOption.propertyAmount, packageProduct.productObj.amount);
                          totalCost.totalDealerPrice = Helper.bcMul(selectedOptionObj.dealerPrice, orderItemOption.propertyAmount, packageProduct.productObj.amount);
                          totalCost.totalCustomerCost = totalCost.totalCustomerPrice;
                          totalCost.totalDealerCost = totalCost.totalDealerPrice;
                          cost.customerPrice = orderItemOption.option.customerPrice ? orderItemOption.option.customerPrice : 0;
                          cost.dealerPrice = orderItemOption.option.dealerPrice ? orderItemOption.option.dealerPrice : 0;

                          const parentOption = _.find(this.order.orderItems[i].orderItemOptions, (oIOption) => oIOption.option.id === orderItemOption.parent && orderItemOption.product.id === oIOption.product.id && oIOption.productAmount === orderItemOption.productAmount);

                          if (parentOption !== undefined && parentOption.option.type === Option.OPTION_TYPE_OPTION) {
                            totalCost.totalCustomerPrice = Helper.bcAdd(totalCost.totalCustomerPrice, parentOption.totalCost.totalCustomerPrice);
                            totalCost.totalDealerPrice = Helper.bcAdd(totalCost.totalDealerPrice, parentOption.totalCost.totalDealerPrice);
                            totalCost.totalCustomerCost = totalCost.totalCustomerPrice;
                            totalCost.totalDealerCost = totalCost.totalDealerPrice;
                            cost.customerPrice = Helper.bcAdd(cost.customerPrice, parentOption.option.customerPrice);
                            cost.dealerPrice = Helper.bcAdd(cost.dealerPrice, parentOption.option.dealerPrice);
                            orderItemOption.propertyAmount = parentOption.propertyAmount;
                          }
                          cost.amount = Helper.bcMul(orderItemOption.propertyAmount, orderItemOption.productAmount);

                          totalCost.totalDealerVAT = Helper.percentageOf(totalCost.totalDealerPrice, this.dealerVAT);
                          totalCost.totalDealerCost = totalCost.totalDealerPrice + totalCost.totalDealerVAT;

                          orderItemOption.totalCost = totalCost;
                          orderItemOption.cost = cost;
                          this.order.orderItems[i].orderItemOptions.push(orderItemOption);
                        }
                      }
                    }
                  }
                }
              }
            });
          });
        });
      }
      // Carpet rows are keyed to one element, so they are not rebuilt from the article's
      // `selectedOptions` above — re-materialise them from each element's own selection
      // before the summary and totals read them.
      this.hydrateCarpetOptions(i, this.currentOrderItemOptions[i]);
      this.materializeCarpetOptionRows(i);
      // this.createOptionsListForSummaryBox(i);
      this.createSummaryBox(i);
      this.getAllTotal(i);
    }
  }


  createSummaryBox(i) {
    this.order.orderItems[i].orderItemProducts.map((orderItemProduct) => {
      if (orderItemProduct.productObj && orderItemProduct.productObj.optionProducts) {
        orderItemProduct.productObj.optionProducts = orderItemProduct.productObj.optionProducts.filter((op) => op.deleted === false);
      }
      orderItemProduct.summaryOptions = [];
    });
    this.order.orderItems[i].orderItemProducts.map(orderItemProductSideFabric => {
      // Per product options
      if (orderItemProductSideFabric.perProductOptionObj && orderItemProductSideFabric.perProductOptions && orderItemProductSideFabric.perProductOptions.length > 0) {
        const summaryOption = new SummaryOption();
        summaryOption.name = orderItemProductSideFabric.perProductOptionObj.option.name;
        summaryOption.id = orderItemProductSideFabric.perProductOptionObj.option.id;
        summaryOption.type = orderItemProductSideFabric.perProductOptionObj.option.type;
        summaryOption.amount = orderItemProductSideFabric.amount;
        summaryOption.perProduct = true;
        let childOption = orderItemProductSideFabric.perProductOptionObj.option.options.filter(option => option.deleted !== true)[0];
        const selectedOption = orderItemProductSideFabric.perProductOptions[orderItemProductSideFabric.perProductOptions.length - 1];
        if (childOption.type === Option.OPTION_TYPE_OPTION) {
          summaryOption.summarySubOptions[0] = childOption.name;
        }
        if (childOption.type === Option.OPTION_TYPE_SELECT) {
          summaryOption.name = childOption.name;
          const optionItem = childOption.options.filter(option => option.id == selectedOption.option)[0];
          if (optionItem) {
            summaryOption.summarySubOptions[0] = optionItem.name;
            childOption = optionItem;
          }
        }
        summaryOption.cost.customerPrice = childOption.customerPrice * summaryOption.amount;
        summaryOption.cost.dealerPrice = childOption.dealerPrice * summaryOption.amount;
        summaryOption.customerPrice = childOption.customerPrice;
        summaryOption.dealerPrice = childOption.dealerPrice;
        summaryOption.random = Math.floor((Math.random() * 1000000) + 1);
        summaryOption.needsFabric = childOption.needsFabric;
        summaryOption.fabricAmount = childOption.fabricAmount;
        orderItemProductSideFabric.summaryOptions.push(summaryOption);
      }
    });
    const selectedOptions = _.orderBy(this.order.orderItems[i].orderItemOptions, ['position', 'parentPosition', 'firstParent'], ['asc', 'asc', 'asc']);
    const options = this.order.orderItems[i].articleOptionsListToSelect;
    selectedOptions.forEach((selectedOption) => {
      const orderItemProduct = _.find(this.order.orderItems[i].orderItemProducts, (orderItemProduct) => {
        let hasPackageProduct = false;
        _.find(orderItemProduct.orderItemProductPackages, orderItemProductPackage => {
          hasPackageProduct = orderItemProductPackage.orderItemProductPackageProducts[0].product === selectedOption.product.id;
          return hasPackageProduct;
        });
        return (orderItemProduct.product == selectedOption.product.id && orderItemProduct.random == selectedOption.random) || hasPackageProduct;
      });
      if (selectedOption.firstParent != selectedOption.option.id) {
        const parent = _.find(options, (op) => op.option.id === selectedOption.firstParent);
        // `options` is articleOptionsListToSelect, which holds the groups of whichever
        // element's product loaded it — not every element's. A rug's second element
        // routinely carries its own Shape/Colour groups, and this pass also runs once
        // before that list is filled at all, so `parent` can legitimately be missing.
        // It used to be dereferenced twice below regardless, and the TypeError escaped
        // through applyCostOfAllOptionsForAnArticle(): summaryOptions had already been
        // cleared for EVERY element at the top of this method, and getAllTotal() never
        // ran, so one element's option change wiped the other elements' summary rows and
        // left the prices from the previous pass on screen (US-604 round 2).
        //
        // Skipping is not a loss for a rug: applyCarpetCost() builds the element's
        // size/shape/finishing/colour rows itself from the element's own groups
        // (mergeCarpetSummaryRows), and it prunes the generic row this block would have
        // added. `orderItemProduct` is guarded for the same reason — a row that pairs to
        // no element must not take the whole pass down with it.
        if (!parent || !orderItemProduct) {
          return;
        }
        const childParent = _.find(this.order.orderItems[i].orderItemOptions, (op) => op.option.id === selectedOption.parent);
        let findChildParent = -1;
        if (Helper.isDefined(childParent)) {
          findChildParent = _.findIndex(orderItemProduct.summaryOptions, (summaryOption) => summaryOption.id === childParent.option.id);
        }

        let findSummary = -1;

        // I don't know why but this orderItemProduct.productObj.optionProducts is empty in show mode
        // if (!this.isShow && !this.isEdit) {
        //   orderItemProduct.summaryOptions = orderItemProduct.summaryOptions.filter((summaryOption) => {
        //     const options = orderItemProduct.productObj.optionProducts.map(item => item.option);
        //     const foundedOption = this.findSummaryOptionRecursive(options, summaryOption);
        //     return undefined !== foundedOption;
        //
        //   });
        // }

        // check if summary option is present or not
        if (orderItemProduct.summaryOptions.length > 0) {
          findSummary = _.findIndex(orderItemProduct.summaryOptions, (summaryOption) => summaryOption.id == parent.option.id);

          //
          //
        }

        if (findSummary == -1) {
          // after find parent of option then create new option
          const summaryOption = new SummaryOption();
          summaryOption.summarySubOptions[0] = selectedOption.option.name;
          summaryOption.name = parent.option.name;
          summaryOption.id = parent.option.id;
          summaryOption.type = selectedOption.option.type;
          summaryOption.amount = selectedOption.cost.amount;
          summaryOption.cost.customerPrice = selectedOption.totalCost.totalCustomerCost;
          summaryOption.cost.dealerPrice = selectedOption.totalCost.totalDealerPrice;
          summaryOption.customerPrice = selectedOption.cost.customerPrice;
          summaryOption.dealerPrice = selectedOption.cost.dealerPrice;
          summaryOption.random = Math.floor((Math.random() * 1000000) + 1);
          // POS trigger (D3): the requirement rides on the option the dealer picked, so it
          // has to reach the summary row that needsPosDetails() reads.
          summaryOption.requiresCustomerDetails = selectedOption.option.requiresCustomerDetails || parent.option.requiresCustomerDetails;
          orderItemProduct.summaryOptions.push(summaryOption);
          return;
        } else if (findSummary > -1 && Helper.isDefined(childParent) && (childParent.option.type === Option.OPTION_TYPE_OPTION) && findChildParent > -1) {

          // orderItemProduct.summaryOptions[findChildParent].name = orderItemProduct.summaryOptions[findChildParent].name + ', ' + selectedOption.option.name;
          orderItemProduct.summaryOptions[findChildParent].summarySubOptions.push(', ' + selectedOption.option.name);
          orderItemProduct.summaryOptions[findChildParent].cost.customerPrice = selectedOption.totalCost.totalCustomerCost;
          orderItemProduct.summaryOptions[findChildParent].cost.dealerPrice = selectedOption.totalCost.totalDealerPrice;
          orderItemProduct.summaryOptions[findChildParent].amount = selectedOption.cost.amount;
          orderItemProduct.summaryOptions[findChildParent].customerPrice = selectedOption.cost.customerPrice;
          orderItemProduct.summaryOptions[findChildParent].dealerPrice = selectedOption.cost.dealerPrice;
          return;
        } else if (findSummary > -1 && orderItemProduct.summaryOptions[findSummary].type === Option.OPTION_TYPE_OPTION && !Helper.isDefined(selectedOption.fabricCollection)) {
          // orderItemProduct.summaryOptions[findSummary].name = orderItemProduct.summaryOptions[findSummary].name + ', ' + selectedOption.option.name;
          orderItemProduct.summaryOptions[findSummary].summarySubOptions.push(', ' + selectedOption.option.name);
          orderItemProduct.summaryOptions[findSummary].cost.customerPrice = selectedOption.totalCost.totalCustomerCost;
          orderItemProduct.summaryOptions[findSummary].cost.dealerPrice = selectedOption.totalCost.totalDealerPrice;
          orderItemProduct.summaryOptions[findSummary].amount = selectedOption.cost.amount;
          orderItemProduct.summaryOptions[findSummary].customerPrice = selectedOption.cost.customerPrice;
          orderItemProduct.summaryOptions[findSummary].dealerPrice = selectedOption.cost.dealerPrice;
          return;
        } else if (findSummary > -1 && orderItemProduct.summaryOptions[findSummary].type === Option.OPTION_TYPE_SELECT && !Helper.isDefined(selectedOption.fabricCollection)) {

          const parentChild = _.find(this.order.orderItems[i].selectedOptions, (op) => {
            const findChild = _.findIndex(op.children, (child: Option) => child.id == selectedOption.option.id);
            return op.parent === selectedOption.parent && op.firstParent === selectedOption.firstParent && findChild > -1;
          });
          if (Helper.isDefined(parentChild)) {

            const summaryOption = new SummaryOption();
            summaryOption.summarySubOptions[0] = selectedOption.option.name;
            summaryOption.name = parentChild.option.name;
            summaryOption.id = selectedOption.option.id;
            summaryOption.type = selectedOption.option.type;
            summaryOption.amount = selectedOption.cost.amount;
            summaryOption.cost.customerPrice = selectedOption.totalCost.totalCustomerCost;
            summaryOption.cost.dealerPrice = selectedOption.totalCost.totalDealerPrice;
            summaryOption.customerPrice = selectedOption.cost.customerPrice;
            summaryOption.dealerPrice = selectedOption.cost.dealerPrice;
            summaryOption.indent = 2;
            summaryOption.random = orderItemProduct.summaryOptions[findSummary].random + 1;
            summaryOption.requiresCustomerDetails = selectedOption.option.requiresCustomerDetails || parentChild.option.requiresCustomerDetails;
            orderItemProduct.summaryOptions.push(summaryOption);
          }

          return;
        } else if (findSummary > -1 && (orderItemProduct.summaryOptions[findSummary].type !== Option.OPTION_TYPE_OPTION) && Helper.isDefined(selectedOption.fabricCollection)) {
          const fabricCollection = _.find(selectedOption.option.fabricCollections, (fabricCollection) => fabricCollection.id == selectedOption.fabricCollection);
          if (Helper.isDefined(fabricCollection)) {
            let fabricName = null;
            let fabricColorName = null;
            if (Helper.isDefined(selectedOption.fabric)) {
              const fabric = _.find(fabricCollection.fabrics, (fabric) => fabric.id == selectedOption.fabric);

              if (Helper.isDefined(fabric)) {
                fabricName = fabric.name;
                if (Helper.isDefined(selectedOption.fabricColor)) {
                  //
                  const fabricColor = _.find(fabric.fabricColors, (fabriColor) => fabriColor.id == selectedOption.fabricColor);
                  if (Helper.isDefined(fabricColor)) {
                    fabricColorName = fabricColor.name;
                  }
                }
              }
            }

            let findParentFabricSummary = _.findIndex(orderItemProduct.summaryOptions, (summaryOption) => summaryOption.id == selectedOption.option.id);
            if (findParentFabricSummary == -1) {
              findParentFabricSummary = _.findIndex(orderItemProduct.summaryOptions, (summaryOption) => summaryOption.id == selectedOption.firstParent);
            }

            const summaryOption = new SummaryOption();
            summaryOption.fabricCollection = fabricCollection.name;
            summaryOption.id = fabricCollection.id;
            summaryOption.fabric = fabricName;
            summaryOption.fabricColor = fabricColorName;
            summaryOption.isFabric = true;
            if (findParentFabricSummary != -1) {
              summaryOption.random = orderItemProduct.summaryOptions[findParentFabricSummary].random;
            }
            if (orderItemProduct.summaryOptions[findParentFabricSummary]) {
              summaryOption.indent = orderItemProduct.summaryOptions[findParentFabricSummary].indent + 1;
            }
            summaryOption.parent = selectedOption.parent;
            orderItemProduct.summaryOptions.splice(findParentFabricSummary + 1, 0, summaryOption);
            return;
          }
        }
        if (selectedOption.parent != 0) {
          // const summaryOption=_.find(orderItemProduct.summaryOptions,(summaryItem)=>{
          //   return summaryItem.id==selectedOption.firstParent
          // })
          // summaryOption.summarySubOptions[0] = (Helper.isDefined( summaryOption.summarySubOptions[0])) ? summaryOption.summarySubOptions[0] +
          //   ', ' + selectedOption.option.name : selectedOption.option.name;
          // summaryOption.cost.customerPrice = selectedOption.totalCost.totalCustomerCost;
          // summaryOption.cost.dealerPrice = selectedOption.totalCost.totalDealerPrice;
          // summaryOption.amount = selectedOption.cost.amount;
          // summaryOption.customerPrice = selectedOption.cost.customerPrice;
          // summaryOption.dealerPrice = selectedOption.cost.dealerPrice;
          //
        }
      }
    });
    this.order.orderItems[i].orderItemProducts.forEach(orderItemProduct => {
      orderItemProduct.summaryOptions.forEach((summaryOption, index) => {
        if (Helper.isDefined(summaryOption.parent)) {
          const parentIndex = _.findIndex(orderItemProduct.summaryOptions, summaryOptionItem => summaryOptionItem.id === summaryOption.parent);
          if (index !== (parentIndex + 1)) {
            orderItemProduct.summaryOptions.splice(index, 1);
            orderItemProduct.summaryOptions.splice(parentIndex + 1, 0, summaryOption);
            summaryOption.indent = orderItemProduct.summaryOptions[parentIndex] ? orderItemProduct.summaryOptions[parentIndex].indent + 1 : 1;
          }
        }
      });
    });
  }

  removeOrderItemOption(i) {
    this.order.orderItems[i].orderItemOptions.forEach((item, index) => {
      const findIndex = _.findIndex(this.order.orderItems[i].orderItemProducts, (p: OrderItemProduct) => p.product == item.product.id);
      if (findIndex == -1) {
        this.order.orderItems[i].orderItemOptions.splice(index, 1);
      }
    });
    this.order.orderItems[i].orderItemOptions.forEach((item, index) => {
      const findIndex = _.findIndex(this.order.orderItems[i].orderItemProducts, (p: OrderItemProduct) => p.product == item.product.id);
      if (findIndex == -1) {
        this.removeOrderItemOption(i);
      }
    });
  }

  checkDeliveryOption() {
    let total = 0;
    let stock = 0;
    let hasProductSet = false;
    this.order.orderItems.forEach((orderItem) => {
      orderItem.collections.forEach((collection) => {
        if (collection.id === orderItem.collection) {
          if ((collection.type === Collection.TYPE_PRODUCTION)) {
            total++;
          } else if (collection.type === Collection.TYPE_STOCK) {
            orderItem.orderItemProducts.forEach(function (productItem) {
              if (productItem.orderItemProductPackages) {
                productItem.orderItemProductPackages.forEach((orderItemProductPackage) => {
                  if (orderItemProductPackage.packageObj && orderItemProductPackage.packageObj.packageProducts.length > 0) {
                    hasProductSet = true;
                  }
                });
              }
              stock += productItem.amount;
              total += productItem.amount;
            });
          }
        }
      });
      this.showPartialOrder = (hasProductSet || (total > 1 && stock > 1));
    });
    this.showDeliveryWeek = this.order.orderItems.length > 0;
  }

  setPartialPaid(e: any) {
    this.order.allowPartial = this.isAllowedPartialPaid.value;
  }

  /**
   * Check all required fields and conditions
   */
  checkRequiredItems() {
    this.order.orderItems.forEach((value, index) => {
      this.formChecked[index] = true;
    });
    const notValid = !this.orderFrom.valid || this.order.orderItems.length === 0 || (this.order.allowDeliveryWeek && !this.order.deliveryWeek) || (this.order.allowSecondaryDeliveryWeek && !this.order.secondaryDeliveryWeek) || this.requiredOption
      || (this.isBackoffice && !this.order.user);
    if (notValid) {
      this.helper.popMessageDialog(null, this.translate.instant('validators.required_fields_error'), 'error', false);
    }
    // if all validations are ok then return true
    return !notValid;
  }

  orderItemFormChecked(i = null) {
    if (Helper.isDefined(i) && this.formChecked[i]) {
      return this.formChecked[i];
    }
    if (i == null && this.formChecked[0]) {
      return this.formChecked[0];
    }
    return false;
  }

  /**
   * Check if the edit order button show or not in the view order of dealer
   * The edit order button show only the status of order is new and in_progress
   * And not past 14 days of placing order
   */
  isAllowedToEdit(row) {
    if (!this.isShow) {
      return true;
    }
    const created = moment(row.created).add(Order.DAYS_ALLOWED_FOR_EDITING, 'days');
    const now = moment();
    const isOrderNewOrInProcess = (row.status === Order.NEW.key || row.status === Order.IN_PROCESS.key);
    const isNotPastFromAllowedDays = created.isAfter(now);

    if (isOrderNewOrInProcess && isNotPastFromAllowedDays) {
      return true;
    }

    return false;
  }

  /**
   * Create a list of properties for current orderItem properties value
   *
   * @param orderItemIndex
   */
  savePropertiesForOrderItem(orderItemIndex) {
    const collection = _.find(this.collections, (collectionItem) => {
      let id = this.order?.orderItems?.[orderItemIndex]?.collection;
      if (id?.hasOwnProperty('id')) {
        id = id.id;
      }
      return collectionItem?.id === id;
    });
    if (Helper.isDefined(collection)) {
      const styleObj = this.order.orderItems[orderItemIndex].styleObj;
      this.orderItemProperties[orderItemIndex] = [];
      const styleBaseProperties = [];

      if (collection.properties) {
        // find all general properties for selected model in orderItem
        collection.properties.forEach((property) => {
          // `defaulted` records that this 1.0 is a placeholder, not a value the product carries.
          // calculateProductPropertiesAmount() clears it the moment a real product_property row
          // supplies an amount. Nothing prices off the flag; it exists so a POS option can tell
          // "this product has no seating-units value" from "this product is worth one unit",
          // which the seeded 1.0 otherwise makes indistinguishable (US-606 D2).
          this.orderItemProperties[orderItemIndex].push({amount: '1.0', property: property, style: null, defaulted: true});
        });
      }

      // check if styleObj defined in current orderItem
      if (styleObj && styleObj.properties) {
        // find all style base propeties for selected style in orderItem
        styleObj.properties.forEach((property: any) => {
          property.styleId = styleObj.id; // set style id in property selected to set it later
          styleBaseProperties.push(property);
        });
      }

      // iterate over finded properties for current selected style
      styleBaseProperties.forEach((property) => {
        // find index of current style property in list of general properties
        const foundedIndex = _.findIndex(this.orderItemProperties[orderItemIndex], (propertyItem: any) => Helper.isDefined(propertyItem.property) && propertyItem.property.id === property.id);
        // if not found in general properties add it in list of properties list
        if (foundedIndex === -1) {
          this.orderItemProperties[orderItemIndex].push({amount: '1.0', property: property, style: {id: property.styleId}, defaulted: true});
        } else {
          // if founded in properties list overwrite it with styled version
          this.orderItemProperties[orderItemIndex][foundedIndex].style = {id: property.styleId};
        }
      });
    }
  }

  /**
   * Calculate properties value for current orderItemProduct
   *
   * @param orderItemIndex
   * @param productProperties
   * @return ProductProperties[]
   */
  private calculateProductPropertiesAmount(orderItemIndex, productProperties: any) {
    // copy orderItem properties
    const orderItemProductProperties = _.cloneDeep(this.orderItemProperties[orderItemIndex]);
    if (orderItemProductProperties !== undefined) {
      // change values in orderItem properties copy and change its amount with product amounts
      orderItemProductProperties.map(productProperty => {
        // try to find index of current property in product properties
        const foundedIndex = _.findIndex(productProperties, (productPropertyItem: any) => {
          // if current product property for current product equal with current mapped productProperty in orderItem
          if (productPropertyItem.property.id === productProperty.property.id) {
            // check if doesn't have style and productPropertyItem not have style it's current selected propety and return true
            if (productProperty.style === null && productPropertyItem.style === null) {
              return true;
            } else if (productPropertyItem.style !== null && productPropertyItem.style.hasOwnProperty('id') && productPropertyItem.style.id === productProperty.style.id) {
              // if current product property for current product has style and this style equal with style for productsProperty in orderItem return true
              return true;
            }
          }
          return false;
        });
        // if we found product property update it's amount with product property
        if (foundedIndex !== -1) {
          productProperty.amount = productProperties[foundedIndex].amount;
          // Carry the placeholder marker across rather than clearing it. This method's result
          // is assigned back over its own input by every caller, so on the second pass a
          // previously-seeded 1.0 arrives looking exactly like a real product value - clearing
          // here would launder the placeholder into a genuine one and put us back where D2
          // started. Only a row that never carried the marker clears it.
          productProperty.defaulted = productProperties[foundedIndex].defaulted === true;
        }
      });
      // return all product properties whether set value in database or not
      return orderItemProductProperties;
    }
    return this.orderItemProperties[orderItemIndex];
  }


  // onChangeSelectedProducts(i) {
  //     if (this.order.orderItems[i].products) {
  //         this.order.orderItems[i].products.map((product: any) => {
  //             product.disabled = _.findIndex(this.order.orderItems[i].orderItemProducts, (orderItemProduct) => {
  //                 return orderItemProduct.product === product.id;
  //             }) !== -1;
  //         });
  //         this.order.orderItems[i].products = [...this.order.orderItems[i].products];
  //     }
  // }

  private calculateSummaryOptionSinglePrice(summaryBoxItem: SummaryOption) {
    if (summaryBoxItem.amount > 0) {
      summaryBoxItem.customerPrice = (((summaryBoxItem.cost.customerPrice * 100) / (summaryBoxItem.amount)) / 100);
      summaryBoxItem.dealerPrice = (((summaryBoxItem.cost.dealerPrice * 100) / (summaryBoxItem.amount)) / 100);
    }
  }


  checkHasChild(optionItem) {
    this.order.orderItems.forEach(res => {
      const child = res.orderItemOptions.forEach(orderItemOption => {
        if (orderItemOption.parent && orderItemOption.parent['id'] == optionItem) {
          return true;
        }
      });
    });
  }

  checkHasFabric(orderItemProductFabricCollection: OrderItemProductFabricCollection) {
    return (orderItemProductFabricCollection.fabricCollection !== null && orderItemProductFabricCollection.fabric !== null && orderItemProductFabricCollection.fabricColor !== null);
  }

  getGeneratedInvoiceForThisOrder() {
    if (this.order.isConverted || this.checkRequiredItems()) {
      const kind = (this.customerPrice) ? 'customer' : 'dealer';
      this.orderService.getInvoiceForAnOrder(this.orderId, kind).subscribe((resp) => {
        // const el: HTMLElement = this.downloadLink.nativeElement as HTMLElement;
        // el.setAttribute('href', resp.url);
        // el.setAttribute('download', resp.filename);
        // el.click();
      });
    }
  }

  getOrderAllowStatusTranslation(allowPartial) {
    if (allowPartial) {
      return this.translate.instant(allowPartial === Order.PARTIAL_ORDER_ALLOW ? 'doctrine.user.allow_partial_order' : 'doctrine.user.not_allow_partial_order');
    }
  }

  EditOrder() {
    this.route.navigateByUrl('dealer-system/order/' + this.orderId + '/edit');
  }

  private allowFabricChecked(i: any, j: any): any {
    const currentFabricCollection = this.order.orderItems[i].orderItemProducts[0].orderItemProductFabricCollection;
    const baseFabricCollection = this.order.orderItems[i].orderItemProducts[j].orderItemProductFabricCollection;
    this.order.orderItems[i].orderItemProducts[j].allowFabric = (
      currentFabricCollection.fabricCollection !== baseFabricCollection.fabricCollection ||
      currentFabricCollection.fabric !== baseFabricCollection.fabric ||
      currentFabricCollection.fabricColor !== baseFabricCollection.fabricColor
    );
    // this.allowFabric(i, j, this.order.orderItems[i].orderItemProducts[j].allowFabric);
  }

  /**
   * Get list to show in ng-select and than check if selected item is not exist in list add to list as disable item
   *
   * @param itemList ng select list
   * @param selectedItem selected item in ng-select list if this item not founded in ng-select list add this item end of list
   */
  private addInactiveItem(itemList, selectedItem) {
    if (selectedItem) {
      const item = JSON.parse(JSON.stringify(selectedItem));
      // find current selected in collections list
      const currentCollection = _.find(itemList, (collection: any) => collection.id === item.id);
      // if not exist current select item in collections list add it with inactive added to name and disable
      if (currentCollection === undefined) {
        if (item && !item.disabled) {
          item.name += ' (' + this.translate.instant('global.inactive') + ')';
          item.disabled = true;
          itemList.push(item);
          this.alertInactive = true;
        }
      } else if (currentCollection.hasOwnProperty('status') && !currentCollection.status && !currentCollection.disabled) {
        currentCollection.name += ' (' + this.translate.instant('global.inactive') + ')';
        currentCollection.disabled = true;
        this.alertInactive = true;
      }
    }
  }

  searchDealerUsers() {
    this.usersTypeahead.pipe(
      distinctUntilChanged(),
      debounceTime(300),
      switchMap(term => this.userService.getDealerUsers('query=' + term))
    ).subscribe(res => {
      this.selectedUsers = res;
    }, (err) => {
      this.selectedUsers = [];
    });
  }

  canLoadOrderUser() {
    return this.isEdit ? (this.isBackoffice && this.selectedUsers && this.selectedUsers.length > 0) : (this.isBackoffice && this.order.user);
  }

  setOrderUser(event: {}) {
    this.order.user = JSON.parse(JSON.stringify(event));
    const country = this.order.user.country;
    this.dealerVAT = this.order.user.invoiceDealer && this.order.user.invoiceDealer.salesVatPercentage ? this.order.user.invoiceDealer.salesVatPercentage : country.dealerVAT ;
    this.customerVAT = country.customerVAT;
    this.applyDealerDeliveryAddress(); // US-595: the new dealer's contacts decide the address
    this.getAllTotal();
  }

  showAddCustomRowModal() {
    if (this.order.customRows && this.order.customRows.length > 0) {
      this.editCustomRow = true;
      this.hasCustomRow = true;
      this.customRows = Object.assign([], this.order.customRows);
    } else {
      this.customRows = [];
      this.customRows.push(new OrderCustomRow());
    }
    this.addCustomRowModal.show();
  }

  manageCustomRow() {
    if (this.hasCustomRow) {
      this.order.customRows = this.customRows;
    } else {
      this.order.customRows = [];
    }
    this.getAllTotal();
    this.addCustomRowModal.hide();
  }

  addNewRow() {
    this.customRows.push(new OrderCustomRow());
  }

  removeCustomRow(index) {
    this.customRows.splice(index, 1);
    this.customRows = JSON.parse(JSON.stringify(this.customRows));
  }

  resetAddCustomRow() {
    if (!this.editCustomRow || !this.hasCustomRow) {
      this.addCustomRowForm.reset();
      this.order.customRows = [];
    }
  }

  showCancelOrderButton() {
    return (!this.isShow && this.auth.isDealer());
  }

  cancelPlaceOrder() {
    this.cancelPlaceOrderModal.show();
  }

  redirectToDashboard() {
    this.orderFrom.reset();
    if (this.auth.isDealerTabletUser()) {
      this.route.navigateByUrl('/dealer-system/quote/overview');
    } else {
      this.route.navigateByUrl('/dealer-system/dashboard');
    }
  }

  clearDeliveryWeek() {
    if (!this.order.allowDeliveryWeek) {
      this.order.deliveryWeek = null;
    }
  }

  clearSecondaryDeliveryWeek() {
    if (!this.order.allowSecondaryDeliveryWeek) {
      this.order.secondaryDeliveryWeek = null;
    }
  }

  isCustomFabric(orderItemProductFabricCollection) {
    return Helper.isDefined(orderItemProductFabricCollection.fabricCollectionObj) && orderItemProductFabricCollection.fabricCollectionObj && orderItemProductFabricCollection.fabricCollection
      && orderItemProductFabricCollection.fabricCollectionObj.isCustom;
  }

  getQuotePdf() {
    const kind = (this.customerPrice) ? 'customer' : 'dealer';
    this.backOfficeOrderService.getPdf(this.orderId, kind).subscribe({
      next: (resp: boolean | PdfResponse) => {
        if (typeof resp === 'object' && resp?.url) {
          window.open(resp.url, '_blank', 'noopener,noreferrer');
        }
      },
    });
  }

  editQuote() {
    this.route.navigateByUrl('dealer-system/quote/' + this.orderId + '/edit');
  }

  saveQuote() {
    this.isNewQuote = !Helper.isDefined(this.order.id);
    this.quoteToOrder = false;
    // No POS gate here on purpose: saving a quotation must never open the customer-details
    // modal. placeQuote() below is the conversion to a real order, and that one does gate.
    if (this.checkRequiredItems()) {
      this.orderModal.show();
    }
  }


  placeQuote() {
    this.quoteToOrder = true;
    if (!this.checkRequiredItems()) {
      return;
    }
    if (!this.requirePosDetails(() => this.placeQuote())) {
      return;
    }
    this.orderModal.show();
  }

  correctOrder(order: Order) {
    order.orderItems.forEach((item) => {
      item.collection = item.collection.id;
      item.model = item.model.id;
      if (item.style) {
        item.style = item.style.id;
      }

    });
  }

  private checkAction() {
    switch (true) {
      case Helper.isNumber(this.replyId):
        this.formAction = 'new-order';
        break;
      case this.isNewQuote:
        this.formAction = 'new-quote';
        break;
      case this.quoteToOrder:
        this.formAction = 'place-quote';
        break;
      case this.isQuote && this.isEdit:
        this.formAction = 'update-quote';
        break;
      case this.isEdit:
        this.formAction = 'update-order';
        break;
      default:
        this.formAction = 'new-order';
    }
  }

  hasCustomFabric() {
    let has = false;
    this.order.orderItems.some((orderItem) => {
      orderItem.orderItemProducts.some((orderItemProduct) => {
        if ((orderItemProduct.orderItemProductFabricCollections[0].fabricCollection as FabricCollection) && (orderItemProduct.orderItemProductFabricCollections[0].fabricCollection as FabricCollection).isCustom) {
          has = true;
        }
        return has;
      });
      return has;
    });
    return has;
  }

  customFabricPackagingLabel() {
    this.orderService.getCustomFabricPackagingPdf(this.orderId).subscribe((resp) => {
      if (resp && typeof resp === 'object') {
        window.open(resp?.url, '_blank', 'noopener,noreferrer');
      }
    });
  }

  checkFabricCollection(callback: string) {
    const hasFabricCollection = !!this.order.orderItems.find(orderItem =>
      !!orderItem.orderItemProducts.find(orderItemProduct => {
        if (
          orderItemProduct &&
          orderItemProduct.orderItemProductFabricCollection &&
          orderItemProduct.orderItemProductFabricCollection.fabricCollectionObj
        ) {
            return !!orderItemProduct.orderItemProductFabricCollection.fabricCollectionObj.discounted;
          }
        }
      )
    );
    if (hasFabricCollection) {
      this.helper.popConfirmDialog(
        this.translate.instant('global.fabric_collection.discontinued_alert.title'),
        this.translate.instant('global.fabric_collection.discontinued_alert.message'),
        'warning',
        false,
        this.translate.instant('global.fabric_collection.discontinued_alert.confirm_button'),
        this.translate.instant('global.fabric_collection.discontinued_alert.cancel_button')
      ).then(res => {
        if (res && res.value) {
          if (callback === 'EditOrder') {
            this.EditOrder();
          } else if (callback === 'placeOrder') {
            this.placeOrder();
          } else if (callback === 'placeQuote') {
            this.placeQuote();
          }
        }
      });
    } else {
      if (callback === 'EditOrder') {
        this.EditOrder();
      } else if (callback === 'placeOrder') {
        this.placeOrder();
      } else if (callback === 'placeQuote') {
        this.placeQuote();
      }
    }
  }

  getMinDeliveryWeek() {
    let minDeliveryWeek = 12;
    this.suppliers.forEach(supplier => {
      if (this.order.allowPartial == Order.PARTIAL_ORDER_NOT_ALLOW && supplier.deliveryWeek > minDeliveryWeek) {
        minDeliveryWeek = supplier.deliveryWeek;
      }
    });
    return minDeliveryWeek;
  }

  changeOrderServiceType(isService: boolean) {
    this.order.isService = isService;
  }

  onChangePerProductOption(i: number, j: number, selectedOption) {
    if (!selectedOption) {
      return;
    }
    const sideFabricOrderItemOption = this.createPerProductOptionItem(i, j, selectedOption);
    sideFabricOrderItemOption.propertyAmount = this.order?.orderItems?.[i]?.orderItemProducts?.[j]?.amount;
    this.order.orderItems[i].orderItemProducts[j].perProductOptions = [];
    this.order.orderItems[i].orderItemProducts[j].perProductOptions.push(
      sideFabricOrderItemOption
    );
    this.createSummaryBox(i);
    this.getAllTotal(i);
  }

  private calculateTransportationCost(index: number, invoiceDealer: InvoiceDealer, product: Product, amount: number): number|null {
    if (undefined === product.collection) {
      return null;
    }
    const collectionTransportation = invoiceDealer ? invoiceDealer.collectionTransportationCosts.find((tc) => tc.collection.id === product.collection.id) : undefined;
    if (undefined !== collectionTransportation) {
      const propertiesAmount = this.calculateProductPropertiesAmount(index, product.productProperties);
      const property = propertiesAmount.find((pp) => pp.property.id === collectionTransportation.multiplier.id);
      return Helper.bcMul(Helper.isDefined(property) ? property.amount : 1, collectionTransportation.cost, amount);
    }
    return null;
  }

  private calculateDeliveryCost(product: Product, amount: number, forDealer= true): number|null {
    if (undefined === product.collection) {
      return null;
    }
    if (forDealer && undefined !== product.collection.dealerDeliveryCostPerArticle && product.collection.endCustomerDelivery) {
      return Helper.bcMul( product.collection.dealerDeliveryCostPerArticle, amount);
    }
    if (!forDealer && undefined !== product.collection.deliveryCostPerArticle && product.collection.endCustomerDelivery) {
      return Helper.bcMul( product.collection.deliveryCostPerArticle, amount);
    }
    return null;
  }

  private findSummaryOptionRecursive(options: Option[], summaryOption: SummaryOption) {
    if (undefined === options) {
      return options;
    }
    let foundedOption = options.find((item) => item.id === summaryOption.id);
    if (undefined === foundedOption) {
      const childOptions = _.flatten(options.map(item => item.options)) as Option[];
      if (_.isEmpty(childOptions)) {
        return undefined;
      }
      foundedOption = this.findSummaryOptionRecursive(childOptions, summaryOption) as Option;
    }
    return foundedOption;
  }

  private recalculateFabricAmount(fabricAmount, summaryOptions: SummaryOption[], productAmount) {
    fabricAmount +=  0.25;
    summaryOptions.forEach(option => {
      if ( option.needsFabric && option.fabricAmount ) {
        fabricAmount +=  productAmount * Number(option.fabricAmount);
      }
    });

    return Number(parseFloat(fabricAmount).toFixed(2));
  }

  public isCalculatable(orderItemProduct, summaryOption) {
    return !(this.isCustomFabric(orderItemProduct.orderItemProductFabricCollection) && summaryOption.needsFabric) ||
      !this.isCustomFabric(orderItemProduct.orderItemProductFabricCollection);
  }

  clearRemark() {
    if (!this.haveRemark) {
      this.order.remark = null;
    }
  }

  onProductClear(i: number, j: number) {
    this.order.orderItems[i].orderItemProducts[j] = this.newOrderItemProduct();
  }

  disableAutofill($event) {
    $event.target.setAttribute('autocomplete', 'off');
  }

  onProductPackageClear(i, product) {
    this.removeExtraOption(i, product);
  }

  onPackageProductChange(i, j, z, packageProduct) {
    this.removeExtraPackageProductOption(i);
    if (packageProduct) {
      this.optionService.getOptionByPackageProduct(packageProduct.id, 'dealer-system').subscribe(optionsProduct => {
        if (optionsProduct.length) {
          optionsProduct = optionsProduct.filter(item => !item.deleted);
          optionsProduct.forEach(item => {
            item.products = [item.product.id];
            item.isForPackageProduct = true;
          });
          this.createOptionsListToSelectForAnArticle(i, optionsProduct);
        }
      });
    }
  }

  checkDeliveryAt() {
    // US-595: show mode holds orderItem.collection as an object, not an id, so the lookup below would reset the flags set on load.
    if (this.isShow) {
      return;
    }
    this.hasDeliveryAt = this.order.orderItems.some(orderItem => {
      const collectionObj = orderItem.collections.find( collection => collection.id === orderItem.collection);
      return collectionObj && collectionObj.endCustomerDelivery;
    });

    this.hasRegularDelivery = this.order.orderItems.some(orderItem => {
      const collectionObj = orderItem.collections.find( collection => collection.id === orderItem.collection);
      return collectionObj && !collectionObj.endCustomerDelivery;
    });
  }

  // US-595: single handler for the collection select (keeps the template free of multi-statement (change) bindings).
  // US-595: the template binds [ngModel] one-way plus this single (ngModelChange) handler, so the value is stored here
  // (before getModels/applyDealerDeliveryAddress read it) instead of a second [(ngModel)] output on the same control.
  onCollectionChange(index: number, collectionId: number): void {
    this.order.orderItems[index].collection = collectionId;
    this.getModels(index, collectionId);
    this.applyDealerDeliveryAddress();
  }

  checkDeliveryAtDealer(): void {
    this.applyDealerDeliveryAddress();
    this.getAllTotal();
  }

  // US-595: recalculated only when the user changes dealer, collection or Delivery at; a stored address is never
  // overwritten on load (edit) or recalculated (show), so old orders keep the address they were saved with.
  applyDealerDeliveryAddress(): void {
    this.checkDeliveryAt();
    if (this.isShow || !this.order?.user) {
      return;
    }
    const toCustomer = this.hasDeliveryAt && this.order.secondaryDeliveryAt === Order.DELIVERY_AT_CUSTOMER;
    const toDealer = this.hasDeliveryAt && this.order.secondaryDeliveryAt === Order.DELIVERY_AT_DEALER;
    this.order.dealerDeliveryAddress = toCustomer ? null : resolveDealerDeliveryAddress(this.order, toDealer);
  }
  /* ---------------------------------------------------------------------
     Carpets & Rugs — the Carpet Size row (FR-020 – FR-023).

     Product selection is authoritative: both flags live on Product and the
     Element block already re-renders when a product is chosen, so this hangs
     off `productObj` rather than off the collection. A sofa product has
     pricingMode = per_unit and every method here short-circuits to false.
     --------------------------------------------------------------------- */

  // ==========================================================================
  // CARPET OPTIONS — per element (shape / finishing / colour)
  // ==========================================================================
  //
  // A rug's shape, finishing and colour belong to ONE element, not to the whole
  // article. FR-023 originally put them in the article-level Options block, which
  // made one select govern every element: picking a shape wrote the same choice to
  // all of them, so a dealer ordering two rugs under one article could not give them
  // different finishings, and the second element's select was only ever a mirror of
  // the first. This block replaces that for carpet-role groups only — every other
  // collection keeps the article-level behaviour untouched.
  //
  // The selection lives on the element (`productItem.carpetOptions`, keyed by role)
  // because `applyCostOfAllOptionsForAnArticle()` rebuilds `orderItemOptions` from
  // scratch whenever any other option changes; the rows are re-materialised from it
  // afterwards (materializeCarpetOptionRows). Rows stay the runtime source of truth
  // for pricing, the summary and the payload, exactly as before.

  /** The role a group carries — on the group itself, or on its leaves (both are configurable).
   *  Lives in carpet-price.ts beside carpetRoleOfRow() so the two rules cannot drift. */
  carpetRoleOfGroup = carpetRoleOfGroup;

  /**
   * The carpet-role groups to show under ONE element, read from that element's own
   * product so availability stays scoped per rug through OptionProduct (FR-009).
   */
  carpetOptionGroupsFor(productItem): any[] {
    if (!this.isRugProduct(productItem) || !productItem.productObj) {
      return [];
    }
    // Cached, and keyed by the element's product: a template binding is re-read on every
    // change-detection pass, and handing ng-select a NEW array each time churns its item
    // identity so a click never commits the selection (the same reason rugPresets()
    // returns the stored array rather than building a fresh one).
    if (!productItem.carpetOptionGroups || productItem.carpetOptionGroups.product !== productItem.product) {
      // A group deleted in the back office is KEPT while editing an existing order, exactly
      // as createOptionsListToSelectForAnArticle() keeps a deleted sofa group. Dropping it
      // left the element's saved selection with nowhere to live, so
      // materializeCarpetOptionRows() deleted the row and the line price changed on the next
      // save without anyone touching that element. A new order still never offers it.
      const groups = (productItem.productObj.optionProducts || [])
        .filter(optionProduct => optionProduct && optionProduct.option
          && (this.isEdit || !optionProduct.deleted)
          && this.carpetRoleOfGroup(optionProduct.option));
      productItem.carpetOptionGroups = {
        product: productItem.product,
        groups: _.orderBy(_.uniqBy(groups, group => group.option.id), group => group.option.position, ['asc']),
      };
    }
    return productItem.carpetOptionGroups.groups;
  }

  /** True while ANY element of the article is a rug — hides carpet groups from the article block */
  private isCarpetOptionGroup(optionProduct): boolean {
    return !!this.carpetRoleOfGroup(optionProduct && optionProduct.option);
  }

  /**
   * The article-level Options block. Carpet-role groups are rendered under their own
   * element instead (carpetOptionGroupsFor), so they must not appear here as well —
   * two controls writing the same rows is what made the elements follow each other.
   */
  articleOptionGroups(orderItem): any[] {
    const groups = (orderItem && orderItem.articleOptionsListToSelect) || [];
    return groups.filter(optionProduct => !this.isCarpetOptionGroup(optionProduct));
  }

  /** The leaves a carpet group offers, deleted ones excluded. Cached for the same reason
   *  the group list is — ng-select needs a stable `[items]` reference. */
  carpetOptionChoices(group): any[] {
    if (!group || !group.option) {
      return [];
    }
    if (!group.carpetChoices) {
      // Same rule as the group list above: while editing, a deleted leaf stays so the saved
      // selection still resolves, marked "(inactive)" and disabled the way addInactiveItem()
      // marks a withdrawn fabric or collection. Without it the row was silently dropped and
      // repriced on save.
      group.carpetChoices = (group.option.options || [])
        .filter(leaf => leaf && (this.isEdit || !leaf.deleted));
      group.carpetChoices.forEach(leaf => {
        if (leaf.deleted && !leaf.disabled) {
          leaf.name += ' (' + this.translate.instant('global.inactive') + ')';
          leaf.disabled = true;
          this.alertInactive = true;
        }
      });
    }
    return group.carpetChoices;
  }

  carpetOptionRequired(group): boolean {
    // A group kept only because an existing order still references it is never required —
    // it cannot be satisfied, and it would block the order button with no way forward.
    return !!(group && group.option && group.option.required && !group.deleted);
  }

  carpetOptionLabel(group): string {
    return (group && group.option && group.option.name) || '';
  }

  /** This element's current choice for a group. Read through a helper so the template
   *  never has to touch `carpetOptions` before it exists. */
  carpetOptionValue(productItem, group): number {
    const selections = productItem && productItem.carpetOptions;
    return selections ? selections[this.carpetRoleOfGroup(group.option)] : null;
  }

  setCarpetOptionValue(productItem, group, leafId): void {
    if (!productItem.carpetOptions) {
      productItem.carpetOptions = {};
    }
    productItem.carpetOptions[this.carpetRoleOfGroup(group.option)] = leafId;
  }

  /**
   * Picking a shape / finishing / colour for one element. Rebuilds only that element's
   * rows and recomputes: the carpet price reads the element's own options
   * (carpetOptionFor), so the price box, summary rows and totals all follow.
   */
  onCarpetOptionChange(i: number): void {
    this.materializeCarpetOptionRows(i);
    this.createSummaryBox(i);
    this.getAllTotal(i);
  }

  /** Every carpet row currently on the article, whatever element it belongs to */
  private isCarpetOptionRow(orderItem, selectedOption): boolean {
    return !!this.carpetRoleOf(orderItem, selectedOption);
  }

  /**
   * Rebuild the article's carpet rows from each element's own selection.
   *
   * Called after every pass that rebuilds `orderItemOptions` (the generic option
   * machinery clears the array), and after hydration. Mirrors the row shape
   * applyCostOfAllOptionsForAnArticle() builds, so the payload, the export and the
   * server see exactly what they saw before — only the pairing changed.
   */
  materializeCarpetOptionRows(i: number): void {
    const orderItem = this.order.orderItems[i];
    if (!orderItem || !orderItem.orderItemProducts) {
      return;
    }
    orderItem.orderItemOptions = (orderItem.orderItemOptions || [])
      .filter(row => !this.isCarpetOptionRow(orderItem, row));

    orderItem.orderItemProducts.forEach(productItem => {
      const selections = productItem.carpetOptions;
      if (!selections) {
        return;
      }
      this.carpetOptionGroupsFor(productItem).forEach(group => {
        const role = this.carpetRoleOfGroup(group.option);
        const leaf = this.carpetOptionChoices(group).find(choice => choice.id === selections[role]);
        if (!leaf) {
          return;
        }
        orderItem.orderItemOptions.push(this.buildCarpetOptionRow(productItem, group, leaf));
      });
    });
  }

  private buildCarpetOptionRow(productItem, group, leaf): OrderItemOption {
    const row = new OrderItemOption();
    row.option = leaf;
    row.product = productItem.productObj;
    row.productAmount = productItem.amount;
    row.propertyAmount = 1;
    row.firstParent = group.option.id;
    row.parent = 0;
    row.position = group.option.position;
    row.parentPosition = leaf.parentPosition;
    // the element this row belongs to. Client-side only — the server pairs a row to an
    // element by receiving it nested under that element (see the save payload).
    row.random = productItem.random;

    const cost = new ProductCost();
    cost.customerPrice = leaf.customerPrice || 0;
    cost.dealerPrice = leaf.dealerPrice || 0;
    cost.amount = productItem.amount;
    const totalCost = new TotalCost();
    totalCost.totalCustomerPrice = Helper.bcMul(cost.customerPrice, 1, productItem.amount);
    totalCost.totalDealerPrice = Helper.bcMul(cost.dealerPrice, 1, productItem.amount);
    totalCost.totalCustomerCost = totalCost.totalCustomerPrice;
    totalCost.totalDealerVAT = Helper.percentageOf(totalCost.totalDealerPrice, this.dealerVAT);
    totalCost.totalDealerCost = totalCost.totalDealerPrice + totalCost.totalDealerVAT;
    row.cost = cost;
    row.totalCost = totalCost;
    return row;
  }

  /**
   * Seed each element's selection from the rows a saved order already has, so opening
   * an existing order shows every element's own choice. Runs once per element: after
   * that the element's `carpetOptions` is the durable state.
   */
  hydrateCarpetOptions(i: number, rows = null): void {
    const orderItem = this.order.orderItems[i];
    if (!orderItem || !orderItem.orderItemProducts) {
      return;
    }
    const articleRows = rows || orderItem.orderItemOptions || [];
    orderItem.orderItemProducts.forEach(productItem => {
      if (productItem.carpetOptions || !this.isRugProduct(productItem)) {
        return;
      }
      // `orderItemOptionIds` is the option ids the API reports for THIS element (it pairs
      // rows to elements, so two elements holding the same rug stay distinguishable).
      // Without it — an older payload — fall back to the article-wide list matched on
      // product, which is all the order-level list can offer.
      const ownIds = productItem.orderItemOptionIds;
      const selections = {};
      this.carpetOptionGroupsFor(productItem).forEach(group => {
        const role = this.carpetRoleOfGroup(group.option);
        if (ownIds && ownIds.length) {
          const leaf = this.carpetOptionChoices(group).find(choice => ownIds.indexOf(choice.id) > -1);
          if (leaf) {
            selections[role] = leaf.id;
          }
          return;
        }
        const match = articleRows.find(row => this.carpetRoleOf(orderItem, row) === role
          && this.carpetOptionBelongsToElement(row, productItem));
        const leaf = match && (match.option || match.urbanOption);
        if (leaf) {
          selections[role] = leaf.id;
        }
      });
      // Only commit a selection we actually found. Early passes run before this element's
      // productObj carries its optionProducts (the isShow copy of the payload product has
      // none), and `{}` is truthy — so the one-shot guard above then blocked every later,
      // correct pass and the element's saved shape/finishing were dropped on the next save
      // (US-604). A rug with genuinely no carpet options needs no entry: carpetOptionValue()
      // reads through undefined and setCarpetOptionValue() creates the map on the first pick.
      if (Object.keys(selections).length > 0) {
        productItem.carpetOptions = selections;
      }
    });
  }

  isRugProduct(productItem): boolean {
    return !!productItem && Product.isRug(productItem.productObj);
  }

  /** Presets exist in both sizing modes: mandatory for fixed, quick-fill for custom */
  rugPresets(productItem) {
    return (productItem && productItem.productObj && productItem.productObj.productSizes) || [];
  }

  /**
   * A priced preset offers no manual width/length fields: that size is sold at its set
   * price and is not resizable (PM decision 3, 2026-09-07). This is UX only — it stops a
   * dealer wandering into a resizable state on a rug that is not resizable. It must never
   * be what decides which price applies: a dealer who types dimensions matching a priced
   * preset gets that preset's price, on both sides, by design.
   */
  rugHasCustomInputs(productItem): boolean {
    return this.isRugProduct(productItem)
      && productItem.productObj.sizingMode === Product.SIZING_MODE_CUSTOM
      && !this.rugSelectedPresetIsPriced(productItem);
  }

  rugPresetLabel(size): string {
    return size.widthCm + ' × ' + size.lengthCm + ' cm';
  }

  /** Live, non-editable metre equivalent shown beside each field (FR-021) */
  toMetres(cm): string {
    return cm > 0 ? (cm / 100).toFixed(2) : '';
  }

  /**
   * D10: the price box showed the raw areaM2 (four decimals, period separator) straight
   * from the `number` pipe under the app's hardcoded 'en' LOCALE_ID. Display only — the
   * value used to compute the price is untouched; only what's rendered is rounded.
   */
  carpetAreaLabel(areaM2: number): string {
    return areaM2 > 0 ? areaM2.toFixed(2).replace('.', ',') : '';
  }

  /**
   * Reopening a saved order: the dimensions came back from the server but the
   * preset that produced them did not, so match them back onto one. A custom size
   * that happens to equal a preset resolves to that preset, which is harmless —
   * both write the same two columns.
   */
  restoreRugPreset(productItem) {
    if (!this.isRugProduct(productItem) || !(productItem.widthCm > 0) || !(productItem.lengthCm > 0)) {
      return;
    }
    const preset = this.rugPresets(productItem)
      .find(size => size.widthCm === productItem.widthCm && size.lengthCm === productItem.lengthCm);
    productItem.selectedSizeId = preset ? preset.id : null;
  }

  /** A preset fills both columns; in custom mode they stay editable afterwards */
  onRugPresetChange(i, j, productItem) {
    const preset = this.rugPresets(productItem).find(size => size.id === productItem.selectedSizeId);
    if (preset) {
      productItem.widthCm = preset.widthCm;
      productItem.lengthCm = preset.lengthCm;
    } else {
      // D23: clearing the dropdown must clear the dimensions with it. Leaving them behind
      // kept the previous selection's price in the box under an empty selection — and with
      // fixed prices in play those stale dimensions would also keep resolving a fixed price.
      // computeCarpetLineCost() returns null without both dimensions, which is what hides
      // the box until the new selection is valid.
      productItem.widthCm = null;
      productItem.lengthCm = null;
    }
    this.onRugSizeChange(i, j, productItem);
  }

  /**
   * Typing a dimension by hand no longer matches whatever preset filled it, so the
   * dropdown is cleared. The browser bounds are a convenience only — the server
   * validates the same limits independently (FR-022).
   */
  onRugSizeChange(i, j, productItem, clearPreset = false) {
    if (clearPreset) {
      productItem.selectedSizeId = null;
    }
    this.getAllTotal(i);
  }

  rugMinWidth(productItem) {
    return (productItem.productObj && productItem.productObj.minWidthCm) || 1;
  }

  rugMaxWidth(productItem) {
    return (productItem.productObj && productItem.productObj.maxWidthCm) || null;
  }

  rugMinLength(productItem) {
    return (productItem.productObj && productItem.productObj.minLengthCm) || 1;
  }

  rugMaxLength(productItem) {
    return (productItem.productObj && productItem.productObj.maxLengthCm) || null;
  }

  /** D26: name only the bounds that exist — an unset max printed a raw {{max}} token */
  rugSizeRangeKey(productItem, axis: 'width' | 'length'): string {
    return axis === 'width'
      ? Product.sizeRangeKey(axis, this.rugMinWidth(productItem), this.rugMaxWidth(productItem))
      : Product.sizeRangeKey(axis, this.rugMinLength(productItem), this.rugMaxLength(productItem));
  }

  /* ---------------------------------------------------------------------
     Carpets & Rugs — the live price box (FR-011 – FR-014).

     Shape and finishing are ordinary priced Options; `Option.carpetRole` says
     which part of the formula each feeds. The role may sit on the option the
     dealer picked or on its parent group ("Carpet Shape" → "Round"), so both
     are checked and the price is always read from the selected leaf.
     --------------------------------------------------------------------- */

  /**
   * The dealer's collection discount applies to the per-m² rate, exactly as it
   * applies to a sofa's unit price in applyCost(). Unlike applyCost() this does
   * not mutate the product — a rate that is discounted twice would be silent.
   */
  private dealerRateAfterCollectionDiscount(product): number {
    return this.applyCollectionDiscount(product, Number(product.dealerPrice) || 0);
  }

  /**
   * The discount arithmetic itself, given any dealer-scope amount for this product.
   *
   * Extracted so a preset's FIXED dealer price goes through exactly the same path as the
   * per-m² rate (PM decision 2, 2026-09-07): the collection discount applies to it too.
   * Silently not applying it is the failure mode this comment exists to prevent. The
   * server made the same extraction for the same reason —
   * `Product::applyDealerCollectionDiscount()`, US-596.
   */
  private applyCollectionDiscount(product, amount: number): number {
    let rate = amount;
    const collectionDiscounts = this.order.user.invoiceDealer && this.order.user.invoiceDealer.collectionDiscounts;
    if (collectionDiscounts && product.collection && product.collection.id !== undefined) {
      collectionDiscounts.forEach(collectionDiscount => {
        if (collectionDiscount.collection.id === product.collection.id) {
          rate -= Helper.percentageOf(rate, collectionDiscount.discount);
        }
      });
    }
    return rate;
  }

  /**
   * The fixed preset price for the dimensions currently in play, or null for the formula.
   * Typed or chosen makes no difference — see resolveFixedSizePrice() in carpet-price.ts
   * for why the lookup keys on dimensions and why the server runs the identical one.
   */
  private carpetFixedPrice(productItem) {
    return resolveFixedSizePrice(productItem.productObj && productItem.productObj.productSizes,
      productItem.widthCm, productItem.lengthCm);
  }

  /**
   * Whether the preset the dealer has SELECTED carries fixed prices — the question that
   * decides whether manual entry is offered.
   *
   * Deliberately not the same question as carpetFixedPrice() above, which asks whether the
   * dimensions currently in play resolve to a priced preset. Pricing must key on the
   * dimensions, because that is all the server has to key on. Hiding the fields must key on
   * the selection, or a dealer typing a size that happens to match a priced preset loses the
   * inputs from under the cursor mid-edit and cannot correct a typo. A typed matching size
   * still gets the fixed price, on both sides, by design — it just keeps its fields.
   */
  public rugSelectedPresetIsPriced(productItem): boolean {
    if (!productItem || !productItem.selectedSizeId) {
      return false;
    }
    const preset = this.rugPresets(productItem).find(size => size.id === productItem.selectedSizeId);
    return !!preset
      && preset.fixedDealerPrice !== null && preset.fixedDealerPrice !== undefined && preset.fixedDealerPrice !== ''
      && preset.fixedCustomerPrice !== null && preset.fixedCustomerPrice !== undefined && preset.fixedCustomerPrice !== '';
  }

  /**
   * The role may sit on the picked option or on its parent group — check both.
   *
   * A row being edited carries the Option under `option`; a row read back from the API
   * carries it under `urbanOption`. Accept either, so one reader serves the create and
   * the edit path (the same convention carpetOptionName() documents).
   */
  private carpetRoleOf(orderItem, selectedOption): string {
    // The elements' OWN carpet groups first: that is the list materializeCarpetOptionRows()
    // builds rows from, so every row it creates resolves here by construction.
    // articleOptionsListToSelect stays only as a last resort — it is filled from
    // getOptionByProductModelStyle(), which is model/style- and deleted-filtered, it is still
    // empty on the first applyCostOfAllOptionsForAnArticle() pass (that call runs
    // synchronously, before the option subscribe resolves), and createOrder() deletes it
    // before reading the rows. Resolving a row against it alone (US-604) left carpet rows
    // unrecognised: unstripped on rebuild, unkeyed to their element on save, and therefore
    // fanned onto every element sharing the product — the old value and the new one, both
    // priced.
    const groups = [];
    ((orderItem && orderItem.orderItemProducts) || []).forEach(productItem =>
      groups.push(...this.carpetOptionGroupsFor(productItem)));
    return carpetRoleOfRow(selectedOption,
      groups.concat((orderItem && orderItem.articleOptionsListToSelect) || []));
  }

  /**
   * Summary-option ids whose price the carpet formula has already accounted for,
   * so the option pass must not add them again (FR-015). A SummaryOption is keyed
   * by its PARENT group id, so the group is checked first — that is where a
   * back-office user sets carpetRole ("Carpet Shape" → shape) — with the selected
   * leaf's own role and its parents included in case the role was set on the leaf.
   */
  private carpetSummaryOptionIds(orderItem): any[] {
    // -1 is the Carpet size row's own sentinel id (D8) — it has no Option behind it,
    // so it can't be matched by id like Shape/Finishing/Colour below, but its price
    // is already inside the carpet-formula total and must be skipped the same way.
    const ids: any[] = [-1];
    ((orderItem && orderItem.articleOptionsListToSelect) || []).forEach(group => {
      if (this.carpetRoleOfGroup(group.option)) {
        ids.push(group.option.id);
      }
    });
    // Through the resolver, not a raw `.carpetRole`: in production the role sits on the
    // parent group, so a leaf test never fired and the only thing keeping shape and
    // finishing out of accumulateOptionCosts() was the group happening to be present in
    // articleOptionsListToSelect above. `firstParent` is the id createSummaryBox() puts on
    // the generic row it builds for the same option.
    ((orderItem && orderItem.orderItemOptions) || []).forEach(selected => {
      if (this.carpetRoleOf(orderItem, selected)) {
        ids.push(selected.option.id, selected.firstParent, selected.parent);
      }
    });
    return ids;
  }

  /**
   * An article's subtotal is the sum of the lines it renders, so it is DERIVED once from
   * the line totals getAllTotal() has just computed - never accumulated in parallel with
   * them (POS-D02).
   *
   * It used to be built by six `customerOrderPrice +=` / `dealerOrderPrice +=` statements
   * scattered through the branches of that loop, one per priced thing: rug line, rug
   * options, product, package products, fabric, options. Every feature that added a priced
   * line had to remember to add it in both places and in the right branch - carpets added
   * two of those rows, POS a third - and missing one made the article subtotal drift while
   * the order total, built from the same line totals, stayed correct. That is the exact
   * symptom reported three features running.
   *
   * The terms below mirror the rows the price box renders, one each, so a new priced line
   * is one term rather than a pair of increments in the correct branch.
   */
  private articleSubtotals(orderItem): {customer: number, dealer: number} {
    return (orderItem.orderItemProducts || []).reduce((totals, orderItemProduct) => {
      const product = orderItemProduct.productObj;
      if (!product) {
        return totals;
      }

      // A rug's line total already contains its shape and finishing, and the carpet
      // formula REPLACES the product/package/fabric legs rather than adding to them -
      // the same reason getAllTotal() returns early for a rug.
      const isRug = Product.isRug(product);
      const options = this.accumulateOptionCosts(
        orderItemProduct,
        isRug ? this.carpetSummaryOptionIds(orderItem) : [],
      );

      totals.customer = Helper.bcAdd(
        totals.customer,
        orderItemProduct.totalCost.totalCustomerPrice || 0,
        isRug ? 0 : this.packageSubtotal(orderItemProduct, true),
        isRug ? 0 : this.fabricSubtotal(orderItemProduct, true),
        options.customer - options.excludeCustomer,
      );
      totals.dealer = Helper.bcAdd(
        totals.dealer,
        orderItemProduct.totalCost.totalDealerPrice || 0,
        isRug ? 0 : this.packageSubtotal(orderItemProduct, false),
        isRug ? 0 : this.fabricSubtotal(orderItemProduct, false),
        options.dealer - options.excludeDealer,
      );
      return totals;
    }, {customer: 0, dealer: 0});
  }

  private packageSubtotal(orderItemProduct, customer: boolean): number {
    return (orderItemProduct.orderItemProductPackages || []).reduce(
      (total, orderItemProductPackage) => (orderItemProductPackage.orderItemProductPackageProducts || []).reduce(
        (packageTotal, packageProduct) => Helper.bcAdd(
          packageTotal,
          (customer ? packageProduct.totalCost?.totalCustomerPrice : packageProduct.totalCost?.totalDealerPrice) || 0,
        ),
        total,
      ),
      0,
    );
  }

  private fabricSubtotal(orderItemProduct, customer: boolean): number {
    const fabric = orderItemProduct.orderItemProductFabricCollection;
    if (!fabric || !Helper.isDefined(fabric.fabricCollectionObj)) {
      return 0;
    }

    return (customer ? fabric.totalCost?.totalCustomerPrice : fabric.totalCost?.totalDealerPrice) || 0;
  }

  /**
   * Article-level option costs for one product line. Shared by the sofa and rug
   * paths so the two can never drift: the only difference is `skipIds`, which is
   * empty for a sofa and carries the carpet roles for a rug — mirroring
   * OrderService::applyPrices(), which filters those three rather than skipping
   * the whole option pass.
   */
  private accumulateOptionCosts(orderItemProduct, skipIds: any[]) {
    const totals = {customer: 0, dealer: 0, excludeCustomer: 0, excludeDealer: 0};
    if (!Helper.isDefined(orderItemProduct.summaryOptions) || orderItemProduct.summaryOptions == null) {
      return totals;
    }
    orderItemProduct.summaryOptions.forEach(summaryOption => {
      // A carpet breakdown row shows a component of the price the carpet formula already
      // put on the product row (FR-015). Adding it here would charge shape and finishing
      // twice — and skipIds cannot catch it, since it carries the leaf option's id while
      // carpetRole sits on the parent group.
      if (summaryOption.carpetComponent) {
        return;
      }
      if (skipIds.length && skipIds.indexOf(summaryOption.id) > -1) {
        return;
      }
      if (summaryOption.amount > 0 && this.isCalculatable(orderItemProduct, summaryOption)) {
        totals.customer += summaryOption.cost.customerPrice;
        totals.dealer += summaryOption.cost.dealerPrice;
        if (summaryOption.perProduct) {
          totals.excludeCustomer += summaryOption.cost.customerPrice;
          totals.excludeDealer += summaryOption.cost.dealerPrice;
        }
      }
    });
    return totals;
  }

  /**
   * The carpet-role option selected FOR ONE ELEMENT.
   *
   * An article's `orderItemOptions` holds one row per element — the article-level select
   * fans the same choice out to every element, but each row carries its own `product`
   * and `random`, and the server prices each element from its own rows
   * (`OrderItemOptionsRepository::getOrderItemOptionsOfProduct()`). Matching only on the
   * role therefore returned the FIRST element's row for every element: two rugs whose
   * rows differ — an edited order, an import, or a per-element UI — were both priced,
   * described and summarised from element 1's shape and finishing, while the server
   * charged each element its own. That is a browser/server disagreement (FR-019).
   *
   * `productItem` is optional so a caller with no element in hand keeps the old,
   * article-wide behaviour, and the element filter falls back to the product id alone
   * when either side has no `random` — the same pair createSummaryBox() already matches
   * elements on.
   */
  private carpetOptionFor(orderItem, role: string, productItem = null) {
    const selected = (orderItem && orderItem.orderItemOptions) || [];
    return selected.find(selectedOption => this.carpetRoleOf(orderItem, selectedOption) === role
      && (!productItem || this.carpetOptionBelongsToElement(selectedOption, productItem)));
  }

  private carpetOptionBelongsToElement(selectedOption, productItem): boolean {
    const optionProduct = selectedOption.product && (selectedOption.product.id ?? selectedOption.product);
    const sameElement = !selectedOption.random || !productItem.random
      || selectedOption.random == productItem.random;
    return optionProduct == productItem.product && sameElement;
  }

  private carpetOptionRate(orderItem, role: string, productItem = null) {
    const match = this.carpetOptionFor(orderItem, role, productItem);
    if (!match) {
      return {dealer: 0, customer: 0};
    }
    return {
      dealer: Number(match.option.dealerPrice) || 0,
      customer: Number(match.option.customerPrice) || 0,
    };
  }

  /**
   * Recomputed on every size, quantity or option change. Returns null until the
   * line has both dimensions, which is what hides the box.
   * The server recomputes the same numbers on save — this is display only (FR-019).
   */
  carpetCost(i, productItem): CarpetLineCost | null {
    if (!this.isRugProduct(productItem)) {
      return null;
    }
    const orderItem = this.order.orderItems[i];
    const shape = this.carpetOptionRate(orderItem, Option.CARPET_ROLE_SHAPE, productItem);
    const finishing = this.carpetOptionRate(orderItem, Option.CARPET_ROLE_FINISHING, productItem);
    const fixed = this.carpetFixedPrice(productItem);
    return computeCarpetLineCost(
      productItem.widthCm,
      productItem.lengthCm,
      {
        materialDealer: this.dealerRateAfterCollectionDiscount(productItem.productObj),
        materialCustomer: Number(productItem.productObj.customerPrice) || 0,
        shapeDealer: shape.dealer,
        shapeCustomer: shape.customer,
        finishingDealer: finishing.dealer,
        finishingCustomer: finishing.customer,
        // The collection discount applies to the fixed dealer price the same way it
        // applies to the per-m² rate above; the customer price is untouched in both cases.
        fixedMaterialDealer: fixed ? this.applyCollectionDiscount(productItem.productObj, fixed.dealer) : null,
        fixedMaterialCustomer: fixed ? fixed.customer : null,
      },
      this.customerVAT,
      productItem.amount
    );
  }

  /** The existing Dealer price / Customer price toggle decides which scope shows */
  carpetAmount(cost: CarpetLineCost, component: string): number {
    if (!cost) {
      return 0;
    }
    return !this.customerPrice ? cost[component + 'Dealer'] : cost[component + 'Customer'];
  }

  /**
   * The product row's price in the summary box and confirmation modal (D7/D8). A sofa
   * reads its own cost, unchanged.
   *
   * A rug shows the MATERIAL amount — what the dimensions themselves cost, area m² ×
   * rate — because Shape and Finishing are priced on their own rows below. `cost.*Price`
   * still holds the whole per-unit total (material + shape + finishing, FR-015) that the
   * line and order totals are built from; showing that total here as well would print
   * the same euros twice. Material carries the formula's round-up remainder (see
   * carpet-price.ts), so product + shape + finishing lands exactly on the per-unit
   * total and the visible rows add up.
   *
   * Falls back to `cost` when there is no carpet cost (no dimensions entered yet), so a
   * rug is never blank where it used to show a number.
   */
  summaryUnitPrice(orderItemProduct): number {
    const carpet = orderItemProduct.carpetCost;
    if (!carpet) {
      return this.customerPrice ? orderItemProduct.cost.customerPrice : orderItemProduct.cost.dealerPrice;
    }
    return this.carpetAmount(carpet, 'material');
  }

  /** The total column of the same row: unit price × quantity */
  summaryTotalPrice(orderItemProduct): number {
    const carpet = orderItemProduct.carpetCost;
    if (!carpet) {
      return this.customerPrice ? orderItemProduct.totalCost.totalCustomerPrice : orderItemProduct.totalCost.totalDealerPrice;
    }
    return this.carpetAmount(carpet, 'material') * (orderItemProduct.cost.amount || 1);
  }

  carpetPerUnitTotal(cost: CarpetLineCost): number {
    return !cost ? 0 : (!this.customerPrice ? cost.perUnitDealerExclVat : cost.perUnitCustomerInclVat);
  }

  carpetLineTotal(cost: CarpetLineCost): number {
    return !cost ? 0 : (!this.customerPrice ? cost.dealer : cost.customerInclVat);
  }

  /**
   * One line per item, the convention sofas already use (FR-025):
   *   Round · Cotton bound edge · 3.47 × 2.13 m · Charcoal
   * Dimensions read in metres even though they are stored in centimetres.
   */
  carpetSummaryDescription(orderItem, productItem): string {
    if (!this.isRugProduct(productItem)) {
      return '';
    }
    const named = role => {
      const match = this.carpetOptionFor(orderItem, role, productItem);
      return match && match.option ? match.option.name : null;
    };
    const dimensions = productItem.widthCm > 0 && productItem.lengthCm > 0
      // width × length, the same order the size row above uses
      ? this.toMetres(productItem.widthCm) + ' × ' + this.toMetres(productItem.lengthCm) + ' m'
      : null;
    return [
      named(Option.CARPET_ROLE_SHAPE),
      named(Option.CARPET_ROLE_FINISHING),
      dimensions,
      named(Option.CARPET_ROLE_COLOUR),
    ].filter(part => !!part).join(' · ');
  }

  /**
   * Size/Shape/Finishing/Colour as real summaryOptions rows (D7/D8), same shape a sofa's
   * options use in the sidebar, confirmation modal and PDF. Called on every recompute
   * (option change or size change alike), so any carpet rows left over from the previous
   * call — real ones from createSummaryBox()'s generic option pass, or our own from the
   * last call — are stripped by id first and rebuilt fresh; genuinely other options on
   * the rug (see applyCost's rug branch) are not Shape/Finishing/Colour/size and pass
   * through untouched.
   *
   * D7/D8: every priced component shows its OWN calculated amount — Shape the flat
   * per-unit shape price, Finishing perimeter × rate — the same figures the per-line
   * carpet price box itemises. The material belongs to the product row above (see
   * summaryUnitPrice()), so the Size row states the dimensions only, and Colour never
   * contributes (FR-010): both stay at zero, which CustomCurrency renders as the dash a
   * zero-cost sofa option row already shows.
   *
   * Product row + Shape + Finishing is therefore exactly the per-unit total the server
   * charges, to the cent — material carries the formula's round-up remainder (see
   * carpet-price.ts). These rows are a BREAKDOWN, never a charge: `carpetComponent`
   * keeps every one of them out of accumulateOptionCosts().
   *
   */
  private mergeCarpetSummaryRows(orderItem, productItem, carpet: CarpetLineCost | null, amount): SummaryOption[] {
    const carpetRowIds = this.carpetSummaryOptionIds(orderItem);
    // Our own rows go by the flag: they are keyed by the SELECTED LEAF's id (1583 "Round"),
    // while carpetRowIds holds the parent GROUP ids (1582 "Carpet Shape") that carry
    // carpetRole — so an id check alone left the previous call's rows in place and the
    // list grew by two rows, and two prices, on every recompute.
    const otherOptions = (productItem.summaryOptions ?? [])
      .filter(summaryOption => !summaryOption.carpetComponent && carpetRowIds.indexOf(summaryOption.id) === -1);
    if (!carpet) {
      return otherOptions;
    }

    const buildRow = (id: number, labelKey: string, subLabel: string,
                      price: {dealer: number, customer: number} = {dealer: 0, customer: 0}): SummaryOption => {
      const row = new SummaryOption();
      row.id = id;
      row.name = this.translate.instant(labelKey);
      row.summarySubOptions[0] = subLabel;
      row.amount = amount;
      row.customerPrice = price.customer;
      row.dealerPrice = price.dealer;
      // the total column, the convention every other summary row uses
      row.cost.customerPrice = price.customer * amount;
      row.cost.dealerPrice = price.dealer * amount;
      row.random = Math.floor((Math.random() * 1000000) + 1);
      row.carpetComponent = true;
      return row;
    };

    // Per-unit component prices, straight off the carpet formula — the same numbers the
    // price box shows. Colour is absent on purpose: it never carries a price (FR-010).
    const rowPrice = {
      [Option.CARPET_ROLE_SHAPE]: {dealer: carpet.shapeDealer, customer: carpet.shapeCustomer},
      [Option.CARPET_ROLE_FINISHING]: {dealer: carpet.finishingDealer, customer: carpet.finishingCustomer},
    };

    const carpetRows: SummaryOption[] = [
      // -1: the Size row's sentinel id (see carpetSummaryOptionIds) — there is no Option
      // behind a dimension, so it can never collide with a real option id.
      // no price: the material amount this size buys is shown on the product row above
      // (summaryUnitPrice()), so repeating it here would print the same euros twice
      buildRow(-1, 'admin.dealer.order.carpet_size',
        carpetSizeLabel(productItem.widthCm, productItem.lengthCm)),
    ];

    const addOptionRow = (role: string): void => {
      const selected = this.carpetOptionFor(orderItem, role, productItem);
      if (!selected) {
        return;
      }
      carpetRows.push(buildRow(selected.option.id, carpetRoleLabelKey(role), selected.option.name,
        rowPrice[role]));
    };
    addOptionRow(Option.CARPET_ROLE_SHAPE);
    addOptionRow(Option.CARPET_ROLE_FINISHING);
    addOptionRow(Option.CARPET_ROLE_COLOUR);

    return carpetRows.concat(otherOptions);
  }

  /**
   * Element-block wording (FR-027). A per-collection override still wins — that is the
   * existing mechanism and the carpet collection is expected to carry one. Without an
   * override a rug still reads in rug terms, so wording never depends on configuration
   * that may not have been done yet. A sofa is untouched either way.
   *
   * Replaces two getCustomLabel() interpolations with one, so it is a net reduction in
   * work per change-detection cycle rather than an addition.
   */
  elementLabel(field: string, orderItem, productItem, defaultKey: string, rugKey: string): string {
    const custom = this.getCustomLabel(field, orderItem);
    if (custom) {
      return custom;
    }
    return this.translate.instant(this.isRugProduct(productItem) ? rugKey : defaultKey);
  }

  getCustomLabel (field , orderItem ) {
    if (!orderItem.collections) {
      return null;
    }
    const collectionObj = orderItem.collections.find( collection => collection.id === orderItem.collection);
    return collectionObj[field];
  }

  confirmAddress() {
    this.addressModal.hide();
    this.orderModal.show();
  }

  checkDisclaimers() {
    this.disclaimersChecked = !this.disclaimers.some(item => !item.checked);
  }

  getDeliveryAddresses() {
    const addresses = [];
    const primaryAddress = this.order.user.deliveryContact;
    const secondaryAddress = this.order.user.secondaryDeliveryContact;
    if (primaryAddress) {
      addresses.push({
        label: [primaryAddress.address, primaryAddress.postalCode, primaryAddress.city].join(' - '),
        value: primaryAddress
      });
    }
    if (secondaryAddress) {
      addresses.push({
        label: [secondaryAddress.address, secondaryAddress.postalCode, secondaryAddress.city].join(' - '),
        value: secondaryAddress
      });
    }

    return addresses;
  }

  private removeExtraPackageProductOption(i) {
    this.order?.orderItems?.[i]?.articleOptionsListToSelect?.forEach(optionProduct => {
      if (optionProduct?.product && optionProduct?.isForPackageProduct) {
        this.removeExtraOption(i, optionProduct.product.id);
      }
    });
  }

  private isTabletDevice(): boolean {
    // Using native matchMedia API to detect tablet characteristics
    const mediaQuery = [
      'screen',
      '(min-width: 768px)',
      '(max-width: 1024px)',
      '(orientation: landscape), (orientation: portrait)'
    ].join(' and ');

    return window.matchMedia(mediaQuery).matches;
  }
  changeDiscount(event) {
    this.discount.amount = 0.0;
    this.discount.percentage = 0.0;
    this.discount.type = event.value;
    this.discount.applied = 0.0;
  }
  showAddDiscountModal() {
    this.addDiscountModal.show();
  }
  manageDiscount(): void {
    this.checkDiscountValidation();
    this.order.discount = JSON.parse(JSON.stringify(this.discount));
    this.addDiscountModal.hide();
  }
  castDiscount(value) {
    const totalPrice = this.findDiscountablePrice();
    this.discount.castIt(totalPrice, value);
  }

  updateOrderDiscount() {
    this.updateDiscount();
    this.order.discount = JSON.parse(JSON.stringify(this.discount));
  }

  updateDiscount() {
    const totalPrice = this.findDiscountablePrice();
    this.discount.castIt(
      totalPrice,
      this.discount.type === Discount.TYPE_AMOUNT ?
        this.discount.amount : this.discount.percentage
    );

    this.checkDiscountValidation();
  }

  private checkDiscountValidation() {
    const totalPrice = this.findDiscountablePrice();
    if (this.discount.type === Discount.TYPE_AMOUNT &&  this.discount.amount > totalPrice) {
      this.discount.amount = totalPrice;
      this.discount.castIt(
        totalPrice,
        totalPrice
      );
    }
  }

  private findDiscountablePrice(): number {
    if (this.discount.supplierId) {
      const orderItem = this.order.orderItems.find((oi) => oi.modelObj?.supplier?.id === this.discount.supplierId);
      return this.order.user.isCustomerAccount ?
        orderItem.totalArticleCustomerPrice : orderItem.totalArticleDealerPrice;
    }
    return this.order.user.isCustomerAccount ?
      this.order.totalCost.totalCustomerCost : this.order.totalCost.totalDealerPrice;
  }

  private getBasePrice(order: Order, isCustomerPrice: boolean): number {
    return isCustomerPrice
      ? order.totalCost.totalCustomerCost
      : order.totalCost.totalDealerPrice;
  }

  private getDiscountAmount(discount: Discount): number {
    return discount.amount > 0 ? discount.amount : discount.applied;
  }

  removeDiscount() {
    this.order.discount = new Discount();
    this.discount = new Discount();
    this.addDiscountModal.hide();
  }

  calculateFinalPrice(order: Order, customerPrice: boolean, discount: Discount): number {
    if (!order?.totalCost) {
      return 0;
    }

    const basePrice = this.getBasePrice(order, customerPrice);
    const discountAmount = this.getDiscountAmount(discount);

    // Return base price without discount for non-customer accounts when using customer pricing
    if (customerPrice && !order.user?.isCustomerAccount) {
      return basePrice;
    }

    // Return dealer price without discount for customer accounts when using dealer pricing
    if (!customerPrice && order.user?.isCustomerAccount) {
      return basePrice;
    }

    return basePrice - discountAmount;
  }
}
